/* tslint:disable */
/* eslint-disable */
/**
 * V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import { BASE_PATH, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export var AppliesPer;
(function (AppliesPer) {
    AppliesPer["Event"] = "event";
    AppliesPer["Season"] = "season";
})(AppliesPer || (AppliesPer = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var AuthenticatedByFabricksFilterType;
(function (AuthenticatedByFabricksFilterType) {
    AuthenticatedByFabricksFilterType["ShowAll"] = "showAll";
    AuthenticatedByFabricksFilterType["Yes"] = "yes";
    AuthenticatedByFabricksFilterType["No"] = "no";
})(AuthenticatedByFabricksFilterType || (AuthenticatedByFabricksFilterType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BiddingBlockedReason;
(function (BiddingBlockedReason) {
    BiddingBlockedReason["NoShipmentToTurkey"] = "noShipmentToTurkey";
})(BiddingBlockedReason || (BiddingBlockedReason = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BoxType;
(function (BoxType) {
    BoxType["Shirt"] = "shirt";
    BoxType["Ball"] = "ball";
    BoxType["Frame"] = "frame";
})(BoxType || (BoxType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BusinessIdentifierType;
(function (BusinessIdentifierType) {
    BusinessIdentifierType["CPF"] = "cPF";
    BusinessIdentifierType["VAT"] = "vAT";
    BusinessIdentifierType["EORI"] = "eORI";
    BusinessIdentifierType["RG"] = "rG";
})(BusinessIdentifierType || (BusinessIdentifierType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var BusinessUnit;
(function (BusinessUnit) {
    BusinessUnit["Mws"] = "mws";
    BusinessUnit["Ftg"] = "ftg";
})(BusinessUnit || (BusinessUnit = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ContractPayoutSource;
(function (ContractPayoutSource) {
    ContractPayoutSource["Manual"] = "manual";
    ContractPayoutSource["VariablePayout"] = "variablePayout";
    ContractPayoutSource["EventsPredictedPayout"] = "eventsPredictedPayout";
    ContractPayoutSource["EventsProformaFinancaialReportPayout"] = "eventsProformaFinancaialReportPayout";
    ContractPayoutSource["EventsFinalFinancialReportPayout"] = "eventsFinalFinancialReportPayout";
})(ContractPayoutSource || (ContractPayoutSource = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ContractPayoutStatus;
(function (ContractPayoutStatus) {
    ContractPayoutStatus["Open"] = "open";
    ContractPayoutStatus["Blocked"] = "blocked";
    ContractPayoutStatus["Paid"] = "paid";
    ContractPayoutStatus["Postponed"] = "postponed";
})(ContractPayoutStatus || (ContractPayoutStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ContractStatus;
(function (ContractStatus) {
    ContractStatus["Active"] = "active";
    ContractStatus["Archived"] = "archived";
    ContractStatus["Deleted"] = "deleted";
})(ContractStatus || (ContractStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ContractType;
(function (ContractType) {
    ContractType["Collaboration"] = "collaboration";
    ContractType["Partnership"] = "partnership";
    ContractType["Pilot"] = "pilot";
})(ContractType || (ContractType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var CostType;
(function (CostType) {
    CostType["CostDeductionPerProduct"] = "costDeductionPerProduct";
    CostType["CostDeductionPerEvent"] = "costDeductionPerEvent";
    CostType["PercentageCostPerProduct"] = "percentageCostPerProduct";
    CostType["PercentageCostPerEvent"] = "percentageCostPerEvent";
    CostType["CostDeductionPerProductType"] = "costDeductionPerProductType";
    CostType["PercentageCostPerProductType"] = "percentageCostPerProductType";
    CostType["CostDeductionPerSeason"] = "costDeductionPerSeason";
})(CostType || (CostType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var DeductFromType;
(function (DeductFromType) {
    DeductFromType["Mws"] = "mws";
    DeductFromType["Partner"] = "partner";
})(DeductFromType || (DeductFromType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var DeductionSourceType;
(function (DeductionSourceType) {
    DeductionSourceType["Gross"] = "gross";
    DeductionSourceType["Net"] = "net";
})(DeductionSourceType || (DeductionSourceType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var DiscountTypeDto;
(function (DiscountTypeDto) {
    DiscountTypeDto["NotAttributed"] = "notAttributed";
    DiscountTypeDto["All"] = "all";
    DiscountTypeDto["Upsell"] = "upsell";
})(DiscountTypeDto || (DiscountTypeDto = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var DocumentTypeCode;
(function (DocumentTypeCode) {
    DocumentTypeCode["Label"] = "label";
    DocumentTypeCode["Invoice"] = "invoice";
    DocumentTypeCode["Receipt"] = "receipt";
})(DocumentTypeCode || (DocumentTypeCode = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var EntityType;
(function (EntityType) {
    EntityType["Product"] = "product";
    EntityType["Customer"] = "customer";
    EntityType["Order"] = "order";
    EntityType["Event"] = "event";
})(EntityType || (EntityType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FinancialReportType;
(function (FinancialReportType) {
    FinancialReportType["Settlement"] = "settlement";
    FinancialReportType["Invoice"] = "invoice";
})(FinancialReportType || (FinancialReportType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FramingStatus;
(function (FramingStatus) {
    FramingStatus["ReadyForConfiguration"] = "readyForConfiguration";
    FramingStatus["Configured"] = "configured";
    FramingStatus["Closed"] = "closed";
    FramingStatus["Configuring"] = "configuring";
})(FramingStatus || (FramingStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FramingTier;
(function (FramingTier) {
    FramingTier["Classic"] = "classic";
    FramingTier["Limited"] = "limited";
})(FramingTier || (FramingTier = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var FramingType;
(function (FramingType) {
    FramingType["NotFrameable"] = "notFrameable";
    FramingType["Frameable"] = "frameable";
    FramingType["Framed"] = "framed";
})(FramingType || (FramingType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var InvoiceBrandType;
(function (InvoiceBrandType) {
    InvoiceBrandType["MatchWornShirt"] = "matchWornShirt";
    InvoiceBrandType["FrameTheGame"] = "frameTheGame";
})(InvoiceBrandType || (InvoiceBrandType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var Months;
(function (Months) {
    Months["January"] = "january";
    Months["February"] = "february";
    Months["March"] = "march";
    Months["April"] = "april";
    Months["May"] = "may";
    Months["June"] = "june";
    Months["July"] = "july";
    Months["August"] = "august";
    Months["September"] = "september";
    Months["October"] = "october";
    Months["November"] = "november";
    Months["December"] = "december";
})(Months || (Months = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OrderDocumentType;
(function (OrderDocumentType) {
    OrderDocumentType["Invoice"] = "invoice";
    OrderDocumentType["CreditNote"] = "creditNote";
})(OrderDocumentType || (OrderDocumentType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OrderItemType;
(function (OrderItemType) {
    OrderItemType["Sku"] = "sku";
    OrderItemType["VirtualTicket"] = "virtualTicket";
    OrderItemType["Frame"] = "frame";
    OrderItemType["Refund"] = "refund";
})(OrderItemType || (OrderItemType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OrderPaymentStatus;
(function (OrderPaymentStatus) {
    OrderPaymentStatus["Open"] = "open";
    OrderPaymentStatus["Processing"] = "processing";
    OrderPaymentStatus["Paid"] = "paid";
    OrderPaymentStatus["Closed"] = "closed";
    OrderPaymentStatus["AwaitingPayment"] = "awaitingPayment";
    OrderPaymentStatus["Unpaid"] = "unpaid";
    OrderPaymentStatus["Pending"] = "pending";
})(OrderPaymentStatus || (OrderPaymentStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OrderPickDestination;
(function (OrderPickDestination) {
    OrderPickDestination["Framing"] = "framing";
    OrderPickDestination["Shipping"] = "shipping";
    OrderPickDestination["LongStorage"] = "longStorage";
})(OrderPickDestination || (OrderPickDestination = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var OrdersFilterType;
(function (OrdersFilterType) {
    OrdersFilterType["All"] = "all";
    OrdersFilterType["Frames"] = "frames";
    OrdersFilterType["Products"] = "products";
    OrdersFilterType["Tickets"] = "tickets";
})(OrdersFilterType || (OrdersFilterType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PartnerRegion;
(function (PartnerRegion) {
    PartnerRegion["France"] = "france";
    PartnerRegion["Belgium"] = "belgium";
    PartnerRegion["Italy"] = "italy";
    PartnerRegion["Netherlands"] = "netherlands";
    PartnerRegion["UnitedKingdom"] = "unitedKingdom";
    PartnerRegion["Turkey"] = "turkey";
    PartnerRegion["EasternEurope"] = "easternEurope";
    PartnerRegion["Nordics"] = "nordics";
    PartnerRegion["Spain"] = "spain";
    PartnerRegion["Portugal"] = "portugal";
    PartnerRegion["MexicoSouthAmerica"] = "mexicoSouthAmerica";
    PartnerRegion["Brazil"] = "brazil";
    PartnerRegion["Germany"] = "germany";
    PartnerRegion["AustraliaNewZealand"] = "australiaNewZealand";
    PartnerRegion["SouthEastAsia"] = "southEastAsia";
    PartnerRegion["MiddleEast"] = "middleEast";
    PartnerRegion["NorthAmerica"] = "northAmerica";
    PartnerRegion["AustraliaAmsterdam"] = "australiaAmsterdam";
})(PartnerRegion || (PartnerRegion = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PartnerSortAttribute;
(function (PartnerSortAttribute) {
    PartnerSortAttribute["StartDate"] = "startDate";
    PartnerSortAttribute["EndDate"] = "endDate";
})(PartnerSortAttribute || (PartnerSortAttribute = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PaymentProviderType;
(function (PaymentProviderType) {
    PaymentProviderType["Adyen"] = "adyen";
    PaymentProviderType["Socios"] = "socios";
})(PaymentProviderType || (PaymentProviderType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PaymentReminderType;
(function (PaymentReminderType) {
    PaymentReminderType["Ultimatum"] = "ultimatum";
    PaymentReminderType["Warning"] = "warning";
    PaymentReminderType["FormalRequest"] = "formalRequest";
    PaymentReminderType["KindReminder"] = "kindReminder";
})(PaymentReminderType || (PaymentReminderType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PaymentTransactionType;
(function (PaymentTransactionType) {
    PaymentTransactionType["Refund"] = "refund";
    PaymentTransactionType["Payment"] = "payment";
})(PaymentTransactionType || (PaymentTransactionType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var PreAuthorisationStatus;
(function (PreAuthorisationStatus) {
    PreAuthorisationStatus["Active"] = "active";
    PreAuthorisationStatus["Released"] = "released";
    PreAuthorisationStatus["Captured"] = "captured";
})(PreAuthorisationStatus || (PreAuthorisationStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var RefundType;
(function (RefundType) {
    RefundType["ShippingAmount"] = "shippingAmount";
    RefundType["VatAmount"] = "vatAmount";
    RefundType["ItemAmount"] = "itemAmount";
    RefundType["TotalAmount"] = "totalAmount";
})(RefundType || (RefundType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus["PickupPlanned"] = "pickupPlanned";
    ShipmentStatus["PickedUp"] = "pickedUp";
})(ShipmentStatus || (ShipmentStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var ShippingType;
(function (ShippingType) {
    ShippingType["PaidShipping"] = "paidShipping";
    ShippingType["FreeShipping"] = "freeShipping";
    ShippingType["NoShipping"] = "noShipping";
})(ShippingType || (ShippingType = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SortContractOn;
(function (SortContractOn) {
    SortContractOn["GrossProceeds"] = "grossProceeds";
    SortContractOn["NetProceeds"] = "netProceeds";
    SortContractOn["NetProceedsPercentage"] = "netProceedsPercentage";
    SortContractOn["DateCreated"] = "dateCreated";
    SortContractOn["MwsShare"] = "mwsShare";
})(SortContractOn || (SortContractOn = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var SortDirection;
(function (SortDirection) {
    SortDirection["Ascending"] = "ascending";
    SortDirection["Descending"] = "descending";
})(SortDirection || (SortDirection = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var UnitOfMeasurement;
(function (UnitOfMeasurement) {
    UnitOfMeasurement["Metric"] = "metric";
    UnitOfMeasurement["Imperial"] = "imperial";
})(UnitOfMeasurement || (UnitOfMeasurement = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VatExemptionReason;
(function (VatExemptionReason) {
    VatExemptionReason["NotExempted"] = "notExempted";
    VatExemptionReason["IsVatReversed"] = "isVatReversed";
    VatExemptionReason["IsExport"] = "isExport";
    VatExemptionReason["IsVatExempt"] = "isVatExempt";
    VatExemptionReason["UsSalesTaxApplies"] = "usSalesTaxApplies";
})(VatExemptionReason || (VatExemptionReason = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VatNumberCheckStatus;
(function (VatNumberCheckStatus) {
    VatNumberCheckStatus["NoVatNumberSet"] = "noVatNumberSet";
    VatNumberCheckStatus["NotChecked"] = "notChecked";
    VatNumberCheckStatus["CheckedNotValid"] = "checkedNotValid";
    VatNumberCheckStatus["CheckedAndValid"] = "checkedAndValid";
    VatNumberCheckStatus["NonEuNumber"] = "nonEuNumber";
})(VatNumberCheckStatus || (VatNumberCheckStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
export var VersionTypeDto;
(function (VersionTypeDto) {
    VersionTypeDto["Control"] = "control";
    VersionTypeDto["A"] = "a";
    VersionTypeDto["B"] = "b";
    VersionTypeDto["C"] = "c";
})(VersionTypeDto || (VersionTypeDto = {}));
/**
 * AdminAdyenMerchantsApi - axios parameter creator
 * @export
 */
export const AdminAdyenMerchantsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Get all Adyen Merchants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/adyen-merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FinanceManager and Admin] Create an Adyen merchant
         * @param {string} [name] The name of the Adyen Merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsPost: (name, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/adyen-merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminAdyenMerchantsApi - functional programming interface
 * @export
 */
export const AdminAdyenMerchantsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminAdyenMerchantsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Get all Adyen Merchants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminAdyenMerchantsGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FinanceManager and Admin] Create an Adyen merchant
         * @param {string} [name] The name of the Adyen Merchant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsPost(name, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminAdyenMerchantsPost(name, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminAdyenMerchantsApi - factory interface
 * @export
 */
export const AdminAdyenMerchantsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminAdyenMerchantsApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Get all Adyen Merchants
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsGet(options) {
            return localVarFp.adminAdyenMerchantsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FinanceManager and Admin] Create an Adyen merchant
         * @param {AdminAdyenMerchantsApiAdminAdyenMerchantsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminAdyenMerchantsPost(requestParameters = {}, options) {
            return localVarFp.adminAdyenMerchantsPost(requestParameters.name, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminAdyenMerchantsApi - object-oriented interface
 * @export
 * @class AdminAdyenMerchantsApi
 * @extends {BaseAPI}
 */
export class AdminAdyenMerchantsApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Get all Adyen Merchants
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAdyenMerchantsApi
     */
    adminAdyenMerchantsGet(options) {
        return AdminAdyenMerchantsApiFp(this.configuration).adminAdyenMerchantsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FinanceManager and Admin] Create an Adyen merchant
     * @param {AdminAdyenMerchantsApiAdminAdyenMerchantsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminAdyenMerchantsApi
     */
    adminAdyenMerchantsPost(requestParameters = {}, options) {
        return AdminAdyenMerchantsApiFp(this.configuration).adminAdyenMerchantsPost(requestParameters.name, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminContractPayoutsApi - axios parameter creator
 * @export
 */
export const AdminContractPayoutsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get contract payouts
         * @param {string} contractId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsGet: (contractId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsGet', 'contractId', contractId);
            const localVarPath = `/admin/contracts/{contractId}/payouts`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Block a contract installment
         * @param {string} contractId
         * @param {string} installmentId
         * @param {AdminContractsContractIdPayoutsInstallmentIdBlockPutRequest} [adminContractsContractIdPayoutsInstallmentIdBlockPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdBlockPut: (contractId, installmentId, adminContractsContractIdPayoutsInstallmentIdBlockPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdBlockPut', 'contractId', contractId);
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdBlockPut', 'installmentId', installmentId);
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/block`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)))
                .replace(`{${"installmentId"}}`, encodeURIComponent(String(installmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminContractsContractIdPayoutsInstallmentIdBlockPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a contract payouts documents
         * @param {string} installmentId
         * @param {string} contractId
         * @param {AdminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest} [adminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdDocumentsPut: (installmentId, contractId, adminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdDocumentsPut', 'installmentId', installmentId);
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdDocumentsPut', 'contractId', contractId);
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/documents`
                .replace(`{${"installmentId"}}`, encodeURIComponent(String(installmentId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Open a contract installment
         * @param {string} contractId
         * @param {string} installmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdOpenPut: (contractId, installmentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdOpenPut', 'contractId', contractId);
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdOpenPut', 'installmentId', installmentId);
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/open`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)))
                .replace(`{${"installmentId"}}`, encodeURIComponent(String(installmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Payout a contract installment
         * @param {string} contractId
         * @param {string} installmentId
         * @param {AdminContractsContractIdPayoutsInstallmentIdPayPutRequest} [adminContractsContractIdPayoutsInstallmentIdPayPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPayPut: (contractId, installmentId, adminContractsContractIdPayoutsInstallmentIdPayPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPayPut', 'contractId', contractId);
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPayPut', 'installmentId', installmentId);
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/pay`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)))
                .replace(`{${"installmentId"}}`, encodeURIComponent(String(installmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminContractsContractIdPayoutsInstallmentIdPayPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Postpone a contract installment
         * @param {string} installmentId
         * @param {string} contractId
         * @param {AdminContractsContractIdPayoutsInstallmentIdPostponePutRequest} [adminContractsContractIdPayoutsInstallmentIdPostponePutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPostponePut: (installmentId, contractId, adminContractsContractIdPayoutsInstallmentIdPostponePutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPostponePut', 'installmentId', installmentId);
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdPostponePut', 'contractId', contractId);
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/postpone`
                .replace(`{${"installmentId"}}`, encodeURIComponent(String(installmentId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminContractsContractIdPayoutsInstallmentIdPostponePutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Unblock a blocked contract installment
         * @param {string} installmentId
         * @param {string} contractId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdUnblockPut: (installmentId, contractId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'installmentId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdUnblockPut', 'installmentId', installmentId);
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdPayoutsInstallmentIdUnblockPut', 'contractId', contractId);
            const localVarPath = `/admin/contracts/{contractId}/payouts/{installmentId}/unblock`
                .replace(`{${"installmentId"}}`, encodeURIComponent(String(installmentId)))
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get payouts for all contracts
         * @param {string} [partnerId]
         * @param {ContractPayoutStatus} [payoutStatus]
         * @param {Date} [dueBefore]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPayoutsOverviewGet: (partnerId, payoutStatus, dueBefore, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/contracts/payouts-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (partnerId !== undefined) {
                localVarQueryParameter['partnerId'] = partnerId;
            }
            if (payoutStatus !== undefined) {
                localVarQueryParameter['payoutStatus'] = payoutStatus;
            }
            if (dueBefore !== undefined) {
                localVarQueryParameter['dueBefore'] = (dueBefore instanceof Date) ?
                    dueBefore.toISOString() :
                    dueBefore;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminContractPayoutsApi - functional programming interface
 * @export
 */
export const AdminContractPayoutsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminContractPayoutsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get contract payouts
         * @param {string} contractId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsGet(contractId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsContractIdPayoutsGet(contractId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Block a contract installment
         * @param {string} contractId
         * @param {string} installmentId
         * @param {AdminContractsContractIdPayoutsInstallmentIdBlockPutRequest} [adminContractsContractIdPayoutsInstallmentIdBlockPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdBlockPut(contractId, installmentId, adminContractsContractIdPayoutsInstallmentIdBlockPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdBlockPut(contractId, installmentId, adminContractsContractIdPayoutsInstallmentIdBlockPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a contract payouts documents
         * @param {string} installmentId
         * @param {string} contractId
         * @param {AdminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest} [adminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdDocumentsPut(installmentId, contractId, adminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdDocumentsPut(installmentId, contractId, adminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Open a contract installment
         * @param {string} contractId
         * @param {string} installmentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdOpenPut(contractId, installmentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdOpenPut(contractId, installmentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Payout a contract installment
         * @param {string} contractId
         * @param {string} installmentId
         * @param {AdminContractsContractIdPayoutsInstallmentIdPayPutRequest} [adminContractsContractIdPayoutsInstallmentIdPayPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPayPut(contractId, installmentId, adminContractsContractIdPayoutsInstallmentIdPayPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdPayPut(contractId, installmentId, adminContractsContractIdPayoutsInstallmentIdPayPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Postpone a contract installment
         * @param {string} installmentId
         * @param {string} contractId
         * @param {AdminContractsContractIdPayoutsInstallmentIdPostponePutRequest} [adminContractsContractIdPayoutsInstallmentIdPostponePutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPostponePut(installmentId, contractId, adminContractsContractIdPayoutsInstallmentIdPostponePutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdPostponePut(installmentId, contractId, adminContractsContractIdPayoutsInstallmentIdPostponePutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Unblock a blocked contract installment
         * @param {string} installmentId
         * @param {string} contractId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdUnblockPut(installmentId, contractId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsContractIdPayoutsInstallmentIdUnblockPut(installmentId, contractId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get payouts for all contracts
         * @param {string} [partnerId]
         * @param {ContractPayoutStatus} [payoutStatus]
         * @param {Date} [dueBefore]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPayoutsOverviewGet(partnerId, payoutStatus, dueBefore, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsPayoutsOverviewGet(partnerId, payoutStatus, dueBefore, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminContractPayoutsApi - factory interface
 * @export
 */
export const AdminContractPayoutsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminContractPayoutsApiFp(configuration);
    return {
        /**
         *
         * @summary Get contract payouts
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsGet(requestParameters, options) {
            return localVarFp.adminContractsContractIdPayoutsGet(requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Block a contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdBlockPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdBlockPut(requestParameters, options) {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdBlockPut(requestParameters.contractId, requestParameters.installmentId, requestParameters.adminContractsContractIdPayoutsInstallmentIdBlockPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a contract payouts documents
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdDocumentsPut(requestParameters, options) {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdDocumentsPut(requestParameters.installmentId, requestParameters.contractId, requestParameters.adminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Open a contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdOpenPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdOpenPut(requestParameters, options) {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdOpenPut(requestParameters.contractId, requestParameters.installmentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Payout a contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPayPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPayPut(requestParameters, options) {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdPayPut(requestParameters.contractId, requestParameters.installmentId, requestParameters.adminContractsContractIdPayoutsInstallmentIdPayPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Postpone a contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPostponePutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdPostponePut(requestParameters, options) {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdPostponePut(requestParameters.installmentId, requestParameters.contractId, requestParameters.adminContractsContractIdPayoutsInstallmentIdPostponePutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Unblock a blocked contract installment
         * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdUnblockPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdPayoutsInstallmentIdUnblockPut(requestParameters, options) {
            return localVarFp.adminContractsContractIdPayoutsInstallmentIdUnblockPut(requestParameters.installmentId, requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get payouts for all contracts
         * @param {AdminContractPayoutsApiAdminContractsPayoutsOverviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPayoutsOverviewGet(requestParameters = {}, options) {
            return localVarFp.adminContractsPayoutsOverviewGet(requestParameters.partnerId, requestParameters.payoutStatus, requestParameters.dueBefore, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminContractPayoutsApi - object-oriented interface
 * @export
 * @class AdminContractPayoutsApi
 * @extends {BaseAPI}
 */
export class AdminContractPayoutsApi extends BaseAPI {
    /**
     *
     * @summary Get contract payouts
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractPayoutsApi
     */
    adminContractsContractIdPayoutsGet(requestParameters, options) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsGet(requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Block a contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdBlockPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractPayoutsApi
     */
    adminContractsContractIdPayoutsInstallmentIdBlockPut(requestParameters, options) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdBlockPut(requestParameters.contractId, requestParameters.installmentId, requestParameters.adminContractsContractIdPayoutsInstallmentIdBlockPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a contract payouts documents
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractPayoutsApi
     */
    adminContractsContractIdPayoutsInstallmentIdDocumentsPut(requestParameters, options) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdDocumentsPut(requestParameters.installmentId, requestParameters.contractId, requestParameters.adminContractsContractIdPayoutsInstallmentIdDocumentsPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Open a contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdOpenPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractPayoutsApi
     */
    adminContractsContractIdPayoutsInstallmentIdOpenPut(requestParameters, options) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdOpenPut(requestParameters.contractId, requestParameters.installmentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Payout a contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPayPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractPayoutsApi
     */
    adminContractsContractIdPayoutsInstallmentIdPayPut(requestParameters, options) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdPayPut(requestParameters.contractId, requestParameters.installmentId, requestParameters.adminContractsContractIdPayoutsInstallmentIdPayPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Postpone a contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdPostponePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractPayoutsApi
     */
    adminContractsContractIdPayoutsInstallmentIdPostponePut(requestParameters, options) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdPostponePut(requestParameters.installmentId, requestParameters.contractId, requestParameters.adminContractsContractIdPayoutsInstallmentIdPostponePutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Unblock a blocked contract installment
     * @param {AdminContractPayoutsApiAdminContractsContractIdPayoutsInstallmentIdUnblockPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractPayoutsApi
     */
    adminContractsContractIdPayoutsInstallmentIdUnblockPut(requestParameters, options) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsContractIdPayoutsInstallmentIdUnblockPut(requestParameters.installmentId, requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get payouts for all contracts
     * @param {AdminContractPayoutsApiAdminContractsPayoutsOverviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractPayoutsApi
     */
    adminContractsPayoutsOverviewGet(requestParameters = {}, options) {
        return AdminContractPayoutsApiFp(this.configuration).adminContractsPayoutsOverviewGet(requestParameters.partnerId, requestParameters.payoutStatus, requestParameters.dueBefore, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminContractProgressApi - axios parameter creator
 * @export
 */
export const AdminContractProgressApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a summary over all contracts
         * @param {Array<string>} [partnerManagerIds]
         * @param {Array<string>} [partnerIds]
         * @param {string} [seasonIds]
         * @param {Array<PartnerRegion>} [partnerRegions]
         * @param {Array<ContractType>} [contractTypes]
         * @param {boolean} [hasProtectionClause]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsSummaryGet: (partnerManagerIds, partnerIds, seasonIds, partnerRegions, contractTypes, hasProtectionClause, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/contracts/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (partnerManagerIds) {
                localVarQueryParameter['partnerManagerIds'] = partnerManagerIds;
            }
            if (partnerIds) {
                localVarQueryParameter['partnerIds'] = partnerIds;
            }
            if (seasonIds !== undefined) {
                localVarQueryParameter['seasonIds'] = seasonIds;
            }
            if (partnerRegions) {
                localVarQueryParameter['partnerRegions'] = partnerRegions;
            }
            if (contractTypes) {
                localVarQueryParameter['contractTypes'] = contractTypes;
            }
            if (hasProtectionClause !== undefined) {
                localVarQueryParameter['hasProtectionClause'] = hasProtectionClause;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminContractProgressApi - functional programming interface
 * @export
 */
export const AdminContractProgressApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminContractProgressApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a summary over all contracts
         * @param {Array<string>} [partnerManagerIds]
         * @param {Array<string>} [partnerIds]
         * @param {string} [seasonIds]
         * @param {Array<PartnerRegion>} [partnerRegions]
         * @param {Array<ContractType>} [contractTypes]
         * @param {boolean} [hasProtectionClause]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsSummaryGet(partnerManagerIds, partnerIds, seasonIds, partnerRegions, contractTypes, hasProtectionClause, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsSummaryGet(partnerManagerIds, partnerIds, seasonIds, partnerRegions, contractTypes, hasProtectionClause, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminContractProgressApi - factory interface
 * @export
 */
export const AdminContractProgressApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminContractProgressApiFp(configuration);
    return {
        /**
         *
         * @summary Get a summary over all contracts
         * @param {AdminContractProgressApiAdminContractsSummaryGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsSummaryGet(requestParameters = {}, options) {
            return localVarFp.adminContractsSummaryGet(requestParameters.partnerManagerIds, requestParameters.partnerIds, requestParameters.seasonIds, requestParameters.partnerRegions, requestParameters.contractTypes, requestParameters.hasProtectionClause, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminContractProgressApi - object-oriented interface
 * @export
 * @class AdminContractProgressApi
 * @extends {BaseAPI}
 */
export class AdminContractProgressApi extends BaseAPI {
    /**
     *
     * @summary Get a summary over all contracts
     * @param {AdminContractProgressApiAdminContractsSummaryGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractProgressApi
     */
    adminContractsSummaryGet(requestParameters = {}, options) {
        return AdminContractProgressApiFp(this.configuration).adminContractsSummaryGet(requestParameters.partnerManagerIds, requestParameters.partnerIds, requestParameters.seasonIds, requestParameters.partnerRegions, requestParameters.contractTypes, requestParameters.hasProtectionClause, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminContractSeasonApi - axios parameter creator
 * @export
 */
export const AdminContractSeasonApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get contract seasons
         * @param {string} [name]
         * @param {boolean} [isCurrent]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractSeasonsGet: (name, isCurrent, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/contract-seasons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (isCurrent !== undefined) {
                localVarQueryParameter['isCurrent'] = isCurrent;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminContractSeasonApi - functional programming interface
 * @export
 */
export const AdminContractSeasonApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminContractSeasonApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get contract seasons
         * @param {string} [name]
         * @param {boolean} [isCurrent]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractSeasonsGet(name, isCurrent, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractSeasonsGet(name, isCurrent, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminContractSeasonApi - factory interface
 * @export
 */
export const AdminContractSeasonApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminContractSeasonApiFp(configuration);
    return {
        /**
         *
         * @summary Get contract seasons
         * @param {AdminContractSeasonApiAdminContractSeasonsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractSeasonsGet(requestParameters = {}, options) {
            return localVarFp.adminContractSeasonsGet(requestParameters.name, requestParameters.isCurrent, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminContractSeasonApi - object-oriented interface
 * @export
 * @class AdminContractSeasonApi
 * @extends {BaseAPI}
 */
export class AdminContractSeasonApi extends BaseAPI {
    /**
     *
     * @summary Get contract seasons
     * @param {AdminContractSeasonApiAdminContractSeasonsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractSeasonApi
     */
    adminContractSeasonsGet(requestParameters = {}, options) {
        return AdminContractSeasonApiFp(this.configuration).adminContractSeasonsGet(requestParameters.name, requestParameters.isCurrent, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminContractsApi - axios parameter creator
 * @export
 */
export const AdminContractsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [admin] Duplicate a contract
         * @param {string} contractId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdDuplicatePost: (contractId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminContractsContractIdDuplicatePost', 'contractId', contractId);
            const localVarPath = `/admin/contracts/{contractId}/duplicate`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Gets a paginated list of contracts
         * @param {string} [seasonIds]
         * @param {Array<string>} [partnerIds]
         * @param {Array<string>} [partnerManagerIds]
         * @param {boolean} [isArchived]
         * @param {Array<ContractType>} [contractTypes]
         * @param {Array<PartnerRegion>} [partnerRegions]
         * @param {SortContractOn} [sortContractOn]
         * @param {SortDirection} [sortDirection]
         * @param {boolean} [hasProtectionClause]
         * @param {string} [ids]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsGet: (seasonIds, partnerIds, partnerManagerIds, isArchived, contractTypes, partnerRegions, sortContractOn, sortDirection, hasProtectionClause, ids, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (seasonIds !== undefined) {
                localVarQueryParameter['seasonIds'] = seasonIds;
            }
            if (partnerIds) {
                localVarQueryParameter['partnerIds'] = partnerIds;
            }
            if (partnerManagerIds) {
                localVarQueryParameter['partnerManagerIds'] = partnerManagerIds;
            }
            if (isArchived !== undefined) {
                localVarQueryParameter['isArchived'] = isArchived;
            }
            if (contractTypes) {
                localVarQueryParameter['contractTypes'] = contractTypes;
            }
            if (partnerRegions) {
                localVarQueryParameter['partnerRegions'] = partnerRegions;
            }
            if (sortContractOn !== undefined) {
                localVarQueryParameter['sortContractOn'] = sortContractOn;
            }
            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }
            if (hasProtectionClause !== undefined) {
                localVarQueryParameter['hasProtectionClause'] = hasProtectionClause;
            }
            if (ids !== undefined) {
                localVarQueryParameter['ids'] = ids;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Activate a contract with protection clause
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdActivatePatch: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdActivatePatch', 'id', id);
            const localVarPath = `/admin/contracts/{id}/activate`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Finance Manager and Admin] Archive a contract with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdArchivePatch: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdArchivePatch', 'id', id);
            const localVarPath = `/admin/contracts/{id}/archive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Finance Manager and Admin] Delete a contract with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdDelete', 'id', id);
            const localVarPath = `/admin/contracts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get contract with Id
         * @param {string} id
         * @param {boolean} [showProgressInContractCurrency]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdGet: (id, showProgressInContractCurrency, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdGet', 'id', id);
            const localVarPath = `/admin/contracts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (showProgressInContractCurrency !== undefined) {
                localVarQueryParameter['showProgressInContractCurrency'] = showProgressInContractCurrency;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Recalculates the progress of the contract
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdRecalculateProgressPost: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdRecalculateProgressPost', 'id', id);
            const localVarPath = `/admin/contracts/{id}/recalculate-progress`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Finance Manager and Admin] Unarchived a contract that is archived
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUnarchivePatch: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdUnarchivePatch', 'id', id);
            const localVarPath = `/admin/contracts/{id}/unarchive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Updates the locked status of the contract to whatever you want it to be
         * @param {string} id
         * @param {boolean} [locked]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUpdateLockPost: (id, locked, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminContractsIdUpdateLockPost', 'id', id);
            const localVarPath = `/admin/contracts/{id}/update-lock`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (locked !== undefined) {
                localVarQueryParameter['locked'] = locked;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FinanceManager and Admin] Create a contract
         * @param {AdminContractsPostRequest} [adminContractsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPost: (adminContractsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminContractsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FinanceManager and Admin] Update the contract
         * @param {AdminContractsPutRequest} [adminContractsPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPut: (adminContractsPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminContractsPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminContractsApi - functional programming interface
 * @export
 */
export const AdminContractsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminContractsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [admin] Duplicate a contract
         * @param {string} contractId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdDuplicatePost(contractId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsContractIdDuplicatePost(contractId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Gets a paginated list of contracts
         * @param {string} [seasonIds]
         * @param {Array<string>} [partnerIds]
         * @param {Array<string>} [partnerManagerIds]
         * @param {boolean} [isArchived]
         * @param {Array<ContractType>} [contractTypes]
         * @param {Array<PartnerRegion>} [partnerRegions]
         * @param {SortContractOn} [sortContractOn]
         * @param {SortDirection} [sortDirection]
         * @param {boolean} [hasProtectionClause]
         * @param {string} [ids]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsGet(seasonIds, partnerIds, partnerManagerIds, isArchived, contractTypes, partnerRegions, sortContractOn, sortDirection, hasProtectionClause, ids, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsGet(seasonIds, partnerIds, partnerManagerIds, isArchived, contractTypes, partnerRegions, sortContractOn, sortDirection, hasProtectionClause, ids, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Activate a contract with protection clause
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdActivatePatch(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsIdActivatePatch(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Finance Manager and Admin] Archive a contract with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdArchivePatch(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsIdArchivePatch(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Finance Manager and Admin] Delete a contract with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsIdDelete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get contract with Id
         * @param {string} id
         * @param {boolean} [showProgressInContractCurrency]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdGet(id, showProgressInContractCurrency, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsIdGet(id, showProgressInContractCurrency, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Recalculates the progress of the contract
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdRecalculateProgressPost(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsIdRecalculateProgressPost(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Finance Manager and Admin] Unarchived a contract that is archived
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUnarchivePatch(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsIdUnarchivePatch(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Updates the locked status of the contract to whatever you want it to be
         * @param {string} id
         * @param {boolean} [locked]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUpdateLockPost(id, locked, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsIdUpdateLockPost(id, locked, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FinanceManager and Admin] Create a contract
         * @param {AdminContractsPostRequest} [adminContractsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPost(adminContractsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsPost(adminContractsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FinanceManager and Admin] Update the contract
         * @param {AdminContractsPutRequest} [adminContractsPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPut(adminContractsPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminContractsPut(adminContractsPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminContractsApi - factory interface
 * @export
 */
export const AdminContractsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminContractsApiFp(configuration);
    return {
        /**
         *
         * @summary [admin] Duplicate a contract
         * @param {AdminContractsApiAdminContractsContractIdDuplicatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsContractIdDuplicatePost(requestParameters, options) {
            return localVarFp.adminContractsContractIdDuplicatePost(requestParameters.contractId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Gets a paginated list of contracts
         * @param {AdminContractsApiAdminContractsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsGet(requestParameters = {}, options) {
            return localVarFp.adminContractsGet(requestParameters.seasonIds, requestParameters.partnerIds, requestParameters.partnerManagerIds, requestParameters.isArchived, requestParameters.contractTypes, requestParameters.partnerRegions, requestParameters.sortContractOn, requestParameters.sortDirection, requestParameters.hasProtectionClause, requestParameters.ids, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Activate a contract with protection clause
         * @param {AdminContractsApiAdminContractsIdActivatePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdActivatePatch(requestParameters, options) {
            return localVarFp.adminContractsIdActivatePatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Finance Manager and Admin] Archive a contract with Id
         * @param {AdminContractsApiAdminContractsIdArchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdArchivePatch(requestParameters, options) {
            return localVarFp.adminContractsIdArchivePatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Finance Manager and Admin] Delete a contract with Id
         * @param {AdminContractsApiAdminContractsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdDelete(requestParameters, options) {
            return localVarFp.adminContractsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get contract with Id
         * @param {AdminContractsApiAdminContractsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdGet(requestParameters, options) {
            return localVarFp.adminContractsIdGet(requestParameters.id, requestParameters.showProgressInContractCurrency, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Recalculates the progress of the contract
         * @param {AdminContractsApiAdminContractsIdRecalculateProgressPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdRecalculateProgressPost(requestParameters, options) {
            return localVarFp.adminContractsIdRecalculateProgressPost(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Finance Manager and Admin] Unarchived a contract that is archived
         * @param {AdminContractsApiAdminContractsIdUnarchivePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUnarchivePatch(requestParameters, options) {
            return localVarFp.adminContractsIdUnarchivePatch(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Updates the locked status of the contract to whatever you want it to be
         * @param {AdminContractsApiAdminContractsIdUpdateLockPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsIdUpdateLockPost(requestParameters, options) {
            return localVarFp.adminContractsIdUpdateLockPost(requestParameters.id, requestParameters.locked, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FinanceManager and Admin] Create a contract
         * @param {AdminContractsApiAdminContractsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPost(requestParameters = {}, options) {
            return localVarFp.adminContractsPost(requestParameters.adminContractsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FinanceManager and Admin] Update the contract
         * @param {AdminContractsApiAdminContractsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminContractsPut(requestParameters = {}, options) {
            return localVarFp.adminContractsPut(requestParameters.adminContractsPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminContractsApi - object-oriented interface
 * @export
 * @class AdminContractsApi
 * @extends {BaseAPI}
 */
export class AdminContractsApi extends BaseAPI {
    /**
     *
     * @summary [admin] Duplicate a contract
     * @param {AdminContractsApiAdminContractsContractIdDuplicatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsContractIdDuplicatePost(requestParameters, options) {
        return AdminContractsApiFp(this.configuration).adminContractsContractIdDuplicatePost(requestParameters.contractId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Gets a paginated list of contracts
     * @param {AdminContractsApiAdminContractsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsGet(requestParameters = {}, options) {
        return AdminContractsApiFp(this.configuration).adminContractsGet(requestParameters.seasonIds, requestParameters.partnerIds, requestParameters.partnerManagerIds, requestParameters.isArchived, requestParameters.contractTypes, requestParameters.partnerRegions, requestParameters.sortContractOn, requestParameters.sortDirection, requestParameters.hasProtectionClause, requestParameters.ids, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Activate a contract with protection clause
     * @param {AdminContractsApiAdminContractsIdActivatePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsIdActivatePatch(requestParameters, options) {
        return AdminContractsApiFp(this.configuration).adminContractsIdActivatePatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Finance Manager and Admin] Archive a contract with Id
     * @param {AdminContractsApiAdminContractsIdArchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsIdArchivePatch(requestParameters, options) {
        return AdminContractsApiFp(this.configuration).adminContractsIdArchivePatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Finance Manager and Admin] Delete a contract with Id
     * @param {AdminContractsApiAdminContractsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsIdDelete(requestParameters, options) {
        return AdminContractsApiFp(this.configuration).adminContractsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get contract with Id
     * @param {AdminContractsApiAdminContractsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsIdGet(requestParameters, options) {
        return AdminContractsApiFp(this.configuration).adminContractsIdGet(requestParameters.id, requestParameters.showProgressInContractCurrency, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Recalculates the progress of the contract
     * @param {AdminContractsApiAdminContractsIdRecalculateProgressPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsIdRecalculateProgressPost(requestParameters, options) {
        return AdminContractsApiFp(this.configuration).adminContractsIdRecalculateProgressPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Finance Manager and Admin] Unarchived a contract that is archived
     * @param {AdminContractsApiAdminContractsIdUnarchivePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsIdUnarchivePatch(requestParameters, options) {
        return AdminContractsApiFp(this.configuration).adminContractsIdUnarchivePatch(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Updates the locked status of the contract to whatever you want it to be
     * @param {AdminContractsApiAdminContractsIdUpdateLockPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsIdUpdateLockPost(requestParameters, options) {
        return AdminContractsApiFp(this.configuration).adminContractsIdUpdateLockPost(requestParameters.id, requestParameters.locked, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FinanceManager and Admin] Create a contract
     * @param {AdminContractsApiAdminContractsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsPost(requestParameters = {}, options) {
        return AdminContractsApiFp(this.configuration).adminContractsPost(requestParameters.adminContractsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FinanceManager and Admin] Update the contract
     * @param {AdminContractsApiAdminContractsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminContractsApi
     */
    adminContractsPut(requestParameters = {}, options) {
        return AdminContractsApiFp(this.configuration).adminContractsPut(requestParameters.adminContractsPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminCountriesApi - axios parameter creator
 * @export
 */
export const AdminCountriesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get a country by iso2Code or Id
         * @param {string} countryIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesCountryIdentifierGet: (countryIdentifier, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'countryIdentifier' is not null or undefined
            assertParamExists('adminCountriesCountryIdentifierGet', 'countryIdentifier', countryIdentifier);
            const localVarPath = `/admin/countries/{countryIdentifier}`
                .replace(`{${"countryIdentifier"}}`, encodeURIComponent(String(countryIdentifier)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Gets all counties, can search by name, if you give Id, it will find by Id  if search term is empty it will give all the countries
         * @param {string} [searchTerm] If SearchTerm is empty you will get all the countries                  search is done on name and country code or the id                  id must 100% match
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {boolean} [includeStates]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesGet: (searchTerm, offSet, pageSize, includeStates, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (includeStates !== undefined) {
                localVarQueryParameter['includeStates'] = includeStates;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminCountriesApi - functional programming interface
 * @export
 */
export const AdminCountriesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminCountriesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get a country by iso2Code or Id
         * @param {string} countryIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesCountryIdentifierGet(countryIdentifier, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCountriesCountryIdentifierGet(countryIdentifier, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Gets all counties, can search by name, if you give Id, it will find by Id  if search term is empty it will give all the countries
         * @param {string} [searchTerm] If SearchTerm is empty you will get all the countries                  search is done on name and country code or the id                  id must 100% match
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {boolean} [includeStates]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesGet(searchTerm, offSet, pageSize, includeStates, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCountriesGet(searchTerm, offSet, pageSize, includeStates, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminCountriesApi - factory interface
 * @export
 */
export const AdminCountriesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminCountriesApiFp(configuration);
    return {
        /**
         *
         * @summary Get a country by iso2Code or Id
         * @param {AdminCountriesApiAdminCountriesCountryIdentifierGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesCountryIdentifierGet(requestParameters, options) {
            return localVarFp.adminCountriesCountryIdentifierGet(requestParameters.countryIdentifier, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets all counties, can search by name, if you give Id, it will find by Id  if search term is empty it will give all the countries
         * @param {AdminCountriesApiAdminCountriesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCountriesGet(requestParameters = {}, options) {
            return localVarFp.adminCountriesGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, requestParameters.includeStates, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminCountriesApi - object-oriented interface
 * @export
 * @class AdminCountriesApi
 * @extends {BaseAPI}
 */
export class AdminCountriesApi extends BaseAPI {
    /**
     *
     * @summary Get a country by iso2Code or Id
     * @param {AdminCountriesApiAdminCountriesCountryIdentifierGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCountriesApi
     */
    adminCountriesCountryIdentifierGet(requestParameters, options) {
        return AdminCountriesApiFp(this.configuration).adminCountriesCountryIdentifierGet(requestParameters.countryIdentifier, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets all counties, can search by name, if you give Id, it will find by Id  if search term is empty it will give all the countries
     * @param {AdminCountriesApiAdminCountriesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCountriesApi
     */
    adminCountriesGet(requestParameters = {}, options) {
        return AdminCountriesApiFp(this.configuration).adminCountriesGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, requestParameters.includeStates, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminCurrencyApi - axios parameter creator
 * @export
 */
export const AdminCurrencyApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] add a new currency
         * @param {string} [body] An ISO standard currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCurrenciesPost: (body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminCurrencyApi - functional programming interface
 * @export
 */
export const AdminCurrencyApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminCurrencyApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] add a new currency
         * @param {string} [body] An ISO standard currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCurrenciesPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCurrenciesPost(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminCurrencyApi - factory interface
 * @export
 */
export const AdminCurrencyApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminCurrencyApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] add a new currency
         * @param {AdminCurrencyApiAdminCurrenciesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCurrenciesPost(requestParameters = {}, options) {
            return localVarFp.adminCurrenciesPost(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminCurrencyApi - object-oriented interface
 * @export
 * @class AdminCurrencyApi
 * @extends {BaseAPI}
 */
export class AdminCurrencyApi extends BaseAPI {
    /**
     *
     * @summary [Admin] add a new currency
     * @param {AdminCurrencyApiAdminCurrenciesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCurrencyApi
     */
    adminCurrenciesPost(requestParameters = {}, options) {
        return AdminCurrencyApiFp(this.configuration).adminCurrenciesPost(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminCustomerAddressesApi - axios parameter creator
 * @export
 */
export const AdminCustomerAddressesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete an address from a customer  It is not possible to delete an address if this address is a customer\'s billing or shipping address
         * @param {string} addressId The id of the address that needs to be removed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdDelete: (addressId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminCustomersAddressesAddressIdDelete', 'addressId', addressId);
            const localVarPath = `/admin/customers/addresses/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update one address of a customer
         * @param {string} addressId The id of the address that needs to be updated
         * @param {AdminCustomersAddressesAddressIdPutRequest} [adminCustomersAddressesAddressIdPutRequest] The request object that contains the necessary fields of a customer address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdPut: (addressId, adminCustomersAddressesAddressIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminCustomersAddressesAddressIdPut', 'addressId', addressId);
            const localVarPath = `/admin/customers/addresses/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminCustomersAddressesAddressIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add\'s an address to the given customer
         * @param {string} customerId
         * @param {AdminCustomersAddressesAddressIdPutRequest} [adminCustomersAddressesAddressIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesPost: (customerId, adminCustomersAddressesAddressIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdAddressesPost', 'customerId', customerId);
            const localVarPath = `/admin/customers/{customerId}/addresses`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminCustomersAddressesAddressIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminCustomerAddressesApi - functional programming interface
 * @export
 */
export const AdminCustomerAddressesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminCustomerAddressesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete an address from a customer  It is not possible to delete an address if this address is a customer\'s billing or shipping address
         * @param {string} addressId The id of the address that needs to be removed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdDelete(addressId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersAddressesAddressIdDelete(addressId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update one address of a customer
         * @param {string} addressId The id of the address that needs to be updated
         * @param {AdminCustomersAddressesAddressIdPutRequest} [adminCustomersAddressesAddressIdPutRequest] The request object that contains the necessary fields of a customer address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdPut(addressId, adminCustomersAddressesAddressIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersAddressesAddressIdPut(addressId, adminCustomersAddressesAddressIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Add\'s an address to the given customer
         * @param {string} customerId
         * @param {AdminCustomersAddressesAddressIdPutRequest} [adminCustomersAddressesAddressIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesPost(customerId, adminCustomersAddressesAddressIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdAddressesPost(customerId, adminCustomersAddressesAddressIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminCustomerAddressesApi - factory interface
 * @export
 */
export const AdminCustomerAddressesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminCustomerAddressesApiFp(configuration);
    return {
        /**
         *
         * @summary Delete an address from a customer  It is not possible to delete an address if this address is a customer\'s billing or shipping address
         * @param {AdminCustomerAddressesApiAdminCustomersAddressesAddressIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdDelete(requestParameters, options) {
            return localVarFp.adminCustomersAddressesAddressIdDelete(requestParameters.addressId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update one address of a customer
         * @param {AdminCustomerAddressesApiAdminCustomersAddressesAddressIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersAddressesAddressIdPut(requestParameters, options) {
            return localVarFp.adminCustomersAddressesAddressIdPut(requestParameters.addressId, requestParameters.adminCustomersAddressesAddressIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add\'s an address to the given customer
         * @param {AdminCustomerAddressesApiAdminCustomersCustomerIdAddressesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesPost(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdAddressesPost(requestParameters.customerId, requestParameters.adminCustomersAddressesAddressIdPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminCustomerAddressesApi - object-oriented interface
 * @export
 * @class AdminCustomerAddressesApi
 * @extends {BaseAPI}
 */
export class AdminCustomerAddressesApi extends BaseAPI {
    /**
     *
     * @summary Delete an address from a customer  It is not possible to delete an address if this address is a customer\'s billing or shipping address
     * @param {AdminCustomerAddressesApiAdminCustomersAddressesAddressIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerAddressesApi
     */
    adminCustomersAddressesAddressIdDelete(requestParameters, options) {
        return AdminCustomerAddressesApiFp(this.configuration).adminCustomersAddressesAddressIdDelete(requestParameters.addressId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update one address of a customer
     * @param {AdminCustomerAddressesApiAdminCustomersAddressesAddressIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerAddressesApi
     */
    adminCustomersAddressesAddressIdPut(requestParameters, options) {
        return AdminCustomerAddressesApiFp(this.configuration).adminCustomersAddressesAddressIdPut(requestParameters.addressId, requestParameters.adminCustomersAddressesAddressIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add\'s an address to the given customer
     * @param {AdminCustomerAddressesApiAdminCustomersCustomerIdAddressesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerAddressesApi
     */
    adminCustomersCustomerIdAddressesPost(requestParameters, options) {
        return AdminCustomerAddressesApiFp(this.configuration).adminCustomersCustomerIdAddressesPost(requestParameters.customerId, requestParameters.adminCustomersAddressesAddressIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminCustomerPaymentTokensApi - axios parameter creator
 * @export
 */
export const AdminCustomerPaymentTokensApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Get all saved payment tokens for a customer
         * @param {string} customerId
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensGet: (customerId, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPaymentTokensGet', 'customerId', customerId);
            const localVarPath = `/admin/customers/{customerId}/payment-tokens`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} customerId
         * @param {string} paymentTokenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete: (customerId, paymentTokenId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete', 'customerId', customerId);
            // verify required parameter 'paymentTokenId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete', 'paymentTokenId', paymentTokenId);
            const localVarPath = `/admin/customers/{customerId}/payment-tokens/{paymentTokenId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"paymentTokenId"}}`, encodeURIComponent(String(paymentTokenId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminCustomerPaymentTokensApi - functional programming interface
 * @export
 */
export const AdminCustomerPaymentTokensApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminCustomerPaymentTokensApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Get all saved payment tokens for a customer
         * @param {string} customerId
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensGet(customerId, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdPaymentTokensGet(customerId, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} customerId
         * @param {string} paymentTokenId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(customerId, paymentTokenId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(customerId, paymentTokenId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminCustomerPaymentTokensApi - factory interface
 * @export
 */
export const AdminCustomerPaymentTokensApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminCustomerPaymentTokensApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Get all saved payment tokens for a customer
         * @param {AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensGet(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdPaymentTokensGet(requestParameters.customerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensPaymentTokenIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(requestParameters.customerId, requestParameters.paymentTokenId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminCustomerPaymentTokensApi - object-oriented interface
 * @export
 * @class AdminCustomerPaymentTokensApi
 * @extends {BaseAPI}
 */
export class AdminCustomerPaymentTokensApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Get all saved payment tokens for a customer
     * @param {AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerPaymentTokensApi
     */
    adminCustomersCustomerIdPaymentTokensGet(requestParameters, options) {
        return AdminCustomerPaymentTokensApiFp(this.configuration).adminCustomersCustomerIdPaymentTokensGet(requestParameters.customerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminCustomerPaymentTokensApiAdminCustomersCustomerIdPaymentTokensPaymentTokenIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerPaymentTokensApi
     */
    adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(requestParameters, options) {
        return AdminCustomerPaymentTokensApiFp(this.configuration).adminCustomersCustomerIdPaymentTokensPaymentTokenIdDelete(requestParameters.customerId, requestParameters.paymentTokenId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminCustomerPreAuthorisationsApi - axios parameter creator
 * @export
 */
export const AdminCustomerPreAuthorisationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all pre-authorisations for a customer
         * @param {string} customerId
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsGet: (customerId, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPreAuthorisationsGet', 'customerId', customerId);
            const localVarPath = `/admin/customers/{customerId}/pre-authorisations`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Release pre-authorization
         * @param {string} preAuthorisationId
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch: (preAuthorisationId, customerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'preAuthorisationId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch', 'preAuthorisationId', preAuthorisationId);
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch', 'customerId', customerId);
            const localVarPath = `/admin/customers/{customerId}/pre-authorisations/{preAuthorisationId}/release`
                .replace(`{${"preAuthorisationId"}}`, encodeURIComponent(String(preAuthorisationId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminCustomerPreAuthorisationsApi - functional programming interface
 * @export
 */
export const AdminCustomerPreAuthorisationsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminCustomerPreAuthorisationsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get all pre-authorisations for a customer
         * @param {string} customerId
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsGet(customerId, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdPreAuthorisationsGet(customerId, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Release pre-authorization
         * @param {string} preAuthorisationId
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(preAuthorisationId, customerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(preAuthorisationId, customerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminCustomerPreAuthorisationsApi - factory interface
 * @export
 */
export const AdminCustomerPreAuthorisationsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminCustomerPreAuthorisationsApiFp(configuration);
    return {
        /**
         *
         * @summary Get all pre-authorisations for a customer
         * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsGet(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdPreAuthorisationsGet(requestParameters.customerId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Release pre-authorization
         * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(requestParameters.preAuthorisationId, requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminCustomerPreAuthorisationsApi - object-oriented interface
 * @export
 * @class AdminCustomerPreAuthorisationsApi
 * @extends {BaseAPI}
 */
export class AdminCustomerPreAuthorisationsApi extends BaseAPI {
    /**
     *
     * @summary Get all pre-authorisations for a customer
     * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerPreAuthorisationsApi
     */
    adminCustomersCustomerIdPreAuthorisationsGet(requestParameters, options) {
        return AdminCustomerPreAuthorisationsApiFp(this.configuration).adminCustomersCustomerIdPreAuthorisationsGet(requestParameters.customerId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Release pre-authorization
     * @param {AdminCustomerPreAuthorisationsApiAdminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomerPreAuthorisationsApi
     */
    adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(requestParameters, options) {
        return AdminCustomerPreAuthorisationsApiFp(this.configuration).adminCustomersCustomerIdPreAuthorisationsPreAuthorisationIdReleasePatch(requestParameters.preAuthorisationId, requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminCustomersApi - axios parameter creator
 * @export
 */
export const AdminCustomersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Set a user\'s address to their billing address and/or shipping address
         * @param {string} customerId The id of the customer
         * @param {string} addressId The id of the new billing/shipping address
         * @param {boolean} [billing] Set this address to the user\&#39;s billing address
         * @param {boolean} [shipping] Set this address to the user\&#39;s shipping address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesAddressIdStatusPatch: (customerId, addressId, billing, shipping, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdAddressesAddressIdStatusPatch', 'customerId', customerId);
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdAddressesAddressIdStatusPatch', 'addressId', addressId);
            const localVarPath = `/admin/customers/{customerId}/addresses/{addressId}/status`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (billing !== undefined) {
                localVarQueryParameter['billing'] = billing;
            }
            if (shipping !== undefined) {
                localVarQueryParameter['shipping'] = shipping;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} customerId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdBlockShipmentPatch: (customerId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdBlockShipmentPatch', 'customerId', customerId);
            const localVarPath = `/admin/customers/{customerId}/block-shipment`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FinanceManager and Admin] Enable / disabled credit for a customer.
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdCreditEnabledPatch: (customerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdCreditEnabledPatch', 'customerId', customerId);
            const localVarPath = `/admin/customers/{customerId}/credit/enabled`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [FinanceManager and Admin] update a customers\' financial credit allotment.
         * @param {string} customerId
         * @param {number} updatedCredit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdCreditUpdatedCreditPatch: (customerId, updatedCredit, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdCreditUpdatedCreditPatch', 'customerId', customerId);
            // verify required parameter 'updatedCredit' is not null or undefined
            assertParamExists('adminCustomersCustomerIdCreditUpdatedCreditPatch', 'updatedCredit', updatedCredit);
            const localVarPath = `/admin/customers/{customerId}/credit/{updatedCredit}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"updatedCredit"}}`, encodeURIComponent(String(updatedCredit)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get customer by id
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdGet: (customerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdGet', 'customerId', customerId);
            const localVarPath = `/admin/customers/{customerId}`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} customerId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdTrustedPatch: (customerId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('adminCustomersCustomerIdTrustedPatch', 'customerId', customerId);
            const localVarPath = `/admin/customers/{customerId}/trusted`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get customers by ids
         * @param {string} [customerIds]
         * @param {string} [platformIds]
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersGet: (customerIds, platformIds, searchTerm, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (customerIds !== undefined) {
                localVarQueryParameter['customerIds'] = customerIds;
            }
            if (platformIds !== undefined) {
                localVarQueryParameter['platformIds'] = platformIds;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get customer object by userId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUserUserIdGet: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminCustomersUserUserIdGet', 'userId', userId);
            const localVarPath = `/admin/customers/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get customer by userIds
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUsersPost: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/customers/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminCustomersApi - functional programming interface
 * @export
 */
export const AdminCustomersApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminCustomersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Set a user\'s address to their billing address and/or shipping address
         * @param {string} customerId The id of the customer
         * @param {string} addressId The id of the new billing/shipping address
         * @param {boolean} [billing] Set this address to the user\&#39;s billing address
         * @param {boolean} [shipping] Set this address to the user\&#39;s shipping address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesAddressIdStatusPatch(customerId, addressId, billing, shipping, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdAddressesAddressIdStatusPatch(customerId, addressId, billing, shipping, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} customerId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdBlockShipmentPatch(customerId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdBlockShipmentPatch(customerId, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FinanceManager and Admin] Enable / disabled credit for a customer.
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdCreditEnabledPatch(customerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdCreditEnabledPatch(customerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [FinanceManager and Admin] update a customers\' financial credit allotment.
         * @param {string} customerId
         * @param {number} updatedCredit
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdCreditUpdatedCreditPatch(customerId, updatedCredit, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdCreditUpdatedCreditPatch(customerId, updatedCredit, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get customer by id
         * @param {string} customerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdGet(customerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdGet(customerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} customerId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdTrustedPatch(customerId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersCustomerIdTrustedPatch(customerId, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get customers by ids
         * @param {string} [customerIds]
         * @param {string} [platformIds]
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersGet(customerIds, platformIds, searchTerm, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersGet(customerIds, platformIds, searchTerm, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get customer object by userId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUserUserIdGet(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersUserUserIdGet(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get customer by userIds
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUsersPost(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminCustomersUsersPost(requestBody, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminCustomersApi - factory interface
 * @export
 */
export const AdminCustomersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminCustomersApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Set a user\'s address to their billing address and/or shipping address
         * @param {AdminCustomersApiAdminCustomersCustomerIdAddressesAddressIdStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdAddressesAddressIdStatusPatch(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdAddressesAddressIdStatusPatch(requestParameters.customerId, requestParameters.addressId, requestParameters.billing, requestParameters.shipping, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCustomersApiAdminCustomersCustomerIdBlockShipmentPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdBlockShipmentPatch(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdBlockShipmentPatch(requestParameters.customerId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FinanceManager and Admin] Enable / disabled credit for a customer.
         * @param {AdminCustomersApiAdminCustomersCustomerIdCreditEnabledPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdCreditEnabledPatch(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdCreditEnabledPatch(requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [FinanceManager and Admin] update a customers\' financial credit allotment.
         * @param {AdminCustomersApiAdminCustomersCustomerIdCreditUpdatedCreditPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdCreditUpdatedCreditPatch(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdCreditUpdatedCreditPatch(requestParameters.customerId, requestParameters.updatedCredit, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get customer by id
         * @param {AdminCustomersApiAdminCustomersCustomerIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdGet(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdGet(requestParameters.customerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminCustomersApiAdminCustomersCustomerIdTrustedPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersCustomerIdTrustedPatch(requestParameters, options) {
            return localVarFp.adminCustomersCustomerIdTrustedPatch(requestParameters.customerId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get customers by ids
         * @param {AdminCustomersApiAdminCustomersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersGet(requestParameters = {}, options) {
            return localVarFp.adminCustomersGet(requestParameters.customerIds, requestParameters.platformIds, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get customer object by userId
         * @param {AdminCustomersApiAdminCustomersUserUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUserUserIdGet(requestParameters, options) {
            return localVarFp.adminCustomersUserUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get customer by userIds
         * @param {AdminCustomersApiAdminCustomersUsersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCustomersUsersPost(requestParameters = {}, options) {
            return localVarFp.adminCustomersUsersPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminCustomersApi - object-oriented interface
 * @export
 * @class AdminCustomersApi
 * @extends {BaseAPI}
 */
export class AdminCustomersApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Set a user\'s address to their billing address and/or shipping address
     * @param {AdminCustomersApiAdminCustomersCustomerIdAddressesAddressIdStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomersApi
     */
    adminCustomersCustomerIdAddressesAddressIdStatusPatch(requestParameters, options) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdAddressesAddressIdStatusPatch(requestParameters.customerId, requestParameters.addressId, requestParameters.billing, requestParameters.shipping, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminCustomersApiAdminCustomersCustomerIdBlockShipmentPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomersApi
     */
    adminCustomersCustomerIdBlockShipmentPatch(requestParameters, options) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdBlockShipmentPatch(requestParameters.customerId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FinanceManager and Admin] Enable / disabled credit for a customer.
     * @param {AdminCustomersApiAdminCustomersCustomerIdCreditEnabledPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomersApi
     */
    adminCustomersCustomerIdCreditEnabledPatch(requestParameters, options) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdCreditEnabledPatch(requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [FinanceManager and Admin] update a customers\' financial credit allotment.
     * @param {AdminCustomersApiAdminCustomersCustomerIdCreditUpdatedCreditPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomersApi
     */
    adminCustomersCustomerIdCreditUpdatedCreditPatch(requestParameters, options) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdCreditUpdatedCreditPatch(requestParameters.customerId, requestParameters.updatedCredit, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get customer by id
     * @param {AdminCustomersApiAdminCustomersCustomerIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomersApi
     */
    adminCustomersCustomerIdGet(requestParameters, options) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdGet(requestParameters.customerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminCustomersApiAdminCustomersCustomerIdTrustedPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomersApi
     */
    adminCustomersCustomerIdTrustedPatch(requestParameters, options) {
        return AdminCustomersApiFp(this.configuration).adminCustomersCustomerIdTrustedPatch(requestParameters.customerId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get customers by ids
     * @param {AdminCustomersApiAdminCustomersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomersApi
     */
    adminCustomersGet(requestParameters = {}, options) {
        return AdminCustomersApiFp(this.configuration).adminCustomersGet(requestParameters.customerIds, requestParameters.platformIds, requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get customer object by userId
     * @param {AdminCustomersApiAdminCustomersUserUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomersApi
     */
    adminCustomersUserUserIdGet(requestParameters, options) {
        return AdminCustomersApiFp(this.configuration).adminCustomersUserUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get customer by userIds
     * @param {AdminCustomersApiAdminCustomersUsersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminCustomersApi
     */
    adminCustomersUsersPost(requestParameters = {}, options) {
        return AdminCustomersApiFp(this.configuration).adminCustomersUsersPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminDiscountsApi - axios parameter creator
 * @export
 */
export const AdminDiscountsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Creates or updates a batch of discounts. Existing discounts will be updated if a match is found;  otherwise, new discounts will be created. Requires Finance Manager or Admin permissions.
         * @param {Array<CreateOrUpdateDiscountRequest>} [createOrUpdateDiscountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsBatchPut: (createOrUpdateDiscountRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/discounts/batch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createOrUpdateDiscountRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Retrieves discounts filtered by platform, type, tier, country, category, or event.  Requires Finance Manager or Admin permissions.
         * @param {string} [platformId]
         * @param {DiscountTypeDto} [discountType]
         * @param {VersionTypeDto} [versionType]
         * @param {number} [tier]
         * @param {string} [countryCode]
         * @param {string} [categoryId]
         * @param {string} [eventId]
         * @param {boolean} [isActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsGet: (platformId, discountType, versionType, tier, countryCode, categoryId, eventId, isActive, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/discounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (platformId !== undefined) {
                localVarQueryParameter['PlatformId'] = platformId;
            }
            if (discountType !== undefined) {
                localVarQueryParameter['DiscountType'] = discountType;
            }
            if (versionType !== undefined) {
                localVarQueryParameter['VersionType'] = versionType;
            }
            if (tier !== undefined) {
                localVarQueryParameter['Tier'] = tier;
            }
            if (countryCode !== undefined) {
                localVarQueryParameter['CountryCode'] = countryCode;
            }
            if (categoryId !== undefined) {
                localVarQueryParameter['CategoryId'] = categoryId;
            }
            if (eventId !== undefined) {
                localVarQueryParameter['EventId'] = eventId;
            }
            if (isActive !== undefined) {
                localVarQueryParameter['IsActive'] = isActive;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminDiscountsApi - functional programming interface
 * @export
 */
export const AdminDiscountsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminDiscountsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Creates or updates a batch of discounts. Existing discounts will be updated if a match is found;  otherwise, new discounts will be created. Requires Finance Manager or Admin permissions.
         * @param {Array<CreateOrUpdateDiscountRequest>} [createOrUpdateDiscountRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsBatchPut(createOrUpdateDiscountRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminDiscountsBatchPut(createOrUpdateDiscountRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Retrieves discounts filtered by platform, type, tier, country, category, or event.  Requires Finance Manager or Admin permissions.
         * @param {string} [platformId]
         * @param {DiscountTypeDto} [discountType]
         * @param {VersionTypeDto} [versionType]
         * @param {number} [tier]
         * @param {string} [countryCode]
         * @param {string} [categoryId]
         * @param {string} [eventId]
         * @param {boolean} [isActive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsGet(platformId, discountType, versionType, tier, countryCode, categoryId, eventId, isActive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminDiscountsGet(platformId, discountType, versionType, tier, countryCode, categoryId, eventId, isActive, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminDiscountsApi - factory interface
 * @export
 */
export const AdminDiscountsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminDiscountsApiFp(configuration);
    return {
        /**
         *
         * @summary Creates or updates a batch of discounts. Existing discounts will be updated if a match is found;  otherwise, new discounts will be created. Requires Finance Manager or Admin permissions.
         * @param {AdminDiscountsApiAdminDiscountsBatchPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsBatchPut(requestParameters = {}, options) {
            return localVarFp.adminDiscountsBatchPut(requestParameters.createOrUpdateDiscountRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Retrieves discounts filtered by platform, type, tier, country, category, or event.  Requires Finance Manager or Admin permissions.
         * @param {AdminDiscountsApiAdminDiscountsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDiscountsGet(requestParameters = {}, options) {
            return localVarFp.adminDiscountsGet(requestParameters.platformId, requestParameters.discountType, requestParameters.versionType, requestParameters.tier, requestParameters.countryCode, requestParameters.categoryId, requestParameters.eventId, requestParameters.isActive, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminDiscountsApi - object-oriented interface
 * @export
 * @class AdminDiscountsApi
 * @extends {BaseAPI}
 */
export class AdminDiscountsApi extends BaseAPI {
    /**
     *
     * @summary Creates or updates a batch of discounts. Existing discounts will be updated if a match is found;  otherwise, new discounts will be created. Requires Finance Manager or Admin permissions.
     * @param {AdminDiscountsApiAdminDiscountsBatchPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountsApi
     */
    adminDiscountsBatchPut(requestParameters = {}, options) {
        return AdminDiscountsApiFp(this.configuration).adminDiscountsBatchPut(requestParameters.createOrUpdateDiscountRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Retrieves discounts filtered by platform, type, tier, country, category, or event.  Requires Finance Manager or Admin permissions.
     * @param {AdminDiscountsApiAdminDiscountsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminDiscountsApi
     */
    adminDiscountsGet(requestParameters = {}, options) {
        return AdminDiscountsApiFp(this.configuration).adminDiscountsGet(requestParameters.platformId, requestParameters.discountType, requestParameters.versionType, requestParameters.tier, requestParameters.countryCode, requestParameters.categoryId, requestParameters.eventId, requestParameters.isActive, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminExchangeRatesApi - axios parameter creator
 * @export
 */
export const AdminExchangeRatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] refresh current exchange rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExchangeratesRefreshPost: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/exchangerates/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminExchangeRatesApi - functional programming interface
 * @export
 */
export const AdminExchangeRatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminExchangeRatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] refresh current exchange rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExchangeratesRefreshPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminExchangeratesRefreshPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminExchangeRatesApi - factory interface
 * @export
 */
export const AdminExchangeRatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminExchangeRatesApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] refresh current exchange rates.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminExchangeratesRefreshPost(options) {
            return localVarFp.adminExchangeratesRefreshPost(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminExchangeRatesApi - object-oriented interface
 * @export
 * @class AdminExchangeRatesApi
 * @extends {BaseAPI}
 */
export class AdminExchangeRatesApi extends BaseAPI {
    /**
     *
     * @summary [Admin] refresh current exchange rates.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminExchangeRatesApi
     */
    adminExchangeratesRefreshPost(options) {
        return AdminExchangeRatesApiFp(this.configuration).adminExchangeratesRefreshPost(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminFinancialReportApi - axios parameter creator
 * @export
 */
export const AdminFinancialReportApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Generate a financial report for an event
         * @param {string} eventId
         * @param {AdminFinancialReportsEventsEventIdPostRequest} [adminFinancialReportsEventsEventIdPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsEventsEventIdPost: (eventId, adminFinancialReportsEventsEventIdPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminFinancialReportsEventsEventIdPost', 'eventId', eventId);
            const localVarPath = `/admin/financial-reports/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminFinancialReportsEventsEventIdPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get financial reports
         * @param {string} [contractId]
         * @param {'Ascending' | 'Descending'} [sortBy]
         * @param {boolean} [isFinal]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsGet: (contractId, sortBy, isFinal, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/financial-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (contractId !== undefined) {
                localVarQueryParameter['ContractId'] = contractId;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['SortBy'] = sortBy;
            }
            if (isFinal !== undefined) {
                localVarQueryParameter['IsFinal'] = isFinal;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminFinancialReportApi - functional programming interface
 * @export
 */
export const AdminFinancialReportApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminFinancialReportApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Generate a financial report for an event
         * @param {string} eventId
         * @param {AdminFinancialReportsEventsEventIdPostRequest} [adminFinancialReportsEventsEventIdPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsEventsEventIdPost(eventId, adminFinancialReportsEventsEventIdPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFinancialReportsEventsEventIdPost(eventId, adminFinancialReportsEventsEventIdPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get financial reports
         * @param {string} [contractId]
         * @param {'Ascending' | 'Descending'} [sortBy]
         * @param {boolean} [isFinal]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsGet(contractId, sortBy, isFinal, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminFinancialReportsGet(contractId, sortBy, isFinal, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminFinancialReportApi - factory interface
 * @export
 */
export const AdminFinancialReportApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminFinancialReportApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Generate a financial report for an event
         * @param {AdminFinancialReportApiAdminFinancialReportsEventsEventIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsEventsEventIdPost(requestParameters, options) {
            return localVarFp.adminFinancialReportsEventsEventIdPost(requestParameters.eventId, requestParameters.adminFinancialReportsEventsEventIdPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get financial reports
         * @param {AdminFinancialReportApiAdminFinancialReportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFinancialReportsGet(requestParameters = {}, options) {
            return localVarFp.adminFinancialReportsGet(requestParameters.contractId, requestParameters.sortBy, requestParameters.isFinal, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminFinancialReportApi - object-oriented interface
 * @export
 * @class AdminFinancialReportApi
 * @extends {BaseAPI}
 */
export class AdminFinancialReportApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Generate a financial report for an event
     * @param {AdminFinancialReportApiAdminFinancialReportsEventsEventIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFinancialReportApi
     */
    adminFinancialReportsEventsEventIdPost(requestParameters, options) {
        return AdminFinancialReportApiFp(this.configuration).adminFinancialReportsEventsEventIdPost(requestParameters.eventId, requestParameters.adminFinancialReportsEventsEventIdPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get financial reports
     * @param {AdminFinancialReportApiAdminFinancialReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminFinancialReportApi
     */
    adminFinancialReportsGet(requestParameters = {}, options) {
        return AdminFinancialReportApiFp(this.configuration).adminFinancialReportsGet(requestParameters.contractId, requestParameters.sortBy, requestParameters.isFinal, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminGlobalShippingConfigsApi - axios parameter creator
 * @export
 */
export const AdminGlobalShippingConfigsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] get a global shipping config
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigEntityIdGet: (entityId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('adminGlobalshippingconfigEntityIdGet', 'entityId', entityId);
            const localVarPath = `/admin/globalshippingconfig/{entityId}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] get global shipping configs and filter by name
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigGet: (searchTerm, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/globalshippingconfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [ShippingAdmin] update a global shipping config
         * @param {AdminGlobalshippingconfigPatchRequest} [adminGlobalshippingconfigPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPatch: (adminGlobalshippingconfigPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/globalshippingconfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminGlobalshippingconfigPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [ShippingAdmin] create a global shipping config
         * @param {AdminGlobalshippingconfigPostRequest} [adminGlobalshippingconfigPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPost: (adminGlobalshippingconfigPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/globalshippingconfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminGlobalshippingconfigPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminGlobalShippingConfigsApi - functional programming interface
 * @export
 */
export const AdminGlobalShippingConfigsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminGlobalShippingConfigsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] get a global shipping config
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigEntityIdGet(entityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminGlobalshippingconfigEntityIdGet(entityId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] get global shipping configs and filter by name
         * @param {string} [searchTerm]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigGet(searchTerm, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminGlobalshippingconfigGet(searchTerm, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [ShippingAdmin] update a global shipping config
         * @param {AdminGlobalshippingconfigPatchRequest} [adminGlobalshippingconfigPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPatch(adminGlobalshippingconfigPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminGlobalshippingconfigPatch(adminGlobalshippingconfigPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [ShippingAdmin] create a global shipping config
         * @param {AdminGlobalshippingconfigPostRequest} [adminGlobalshippingconfigPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPost(adminGlobalshippingconfigPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminGlobalshippingconfigPost(adminGlobalshippingconfigPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminGlobalShippingConfigsApi - factory interface
 * @export
 */
export const AdminGlobalShippingConfigsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminGlobalShippingConfigsApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] get a global shipping config
         * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigEntityIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigEntityIdGet(requestParameters, options) {
            return localVarFp.adminGlobalshippingconfigEntityIdGet(requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] get global shipping configs and filter by name
         * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigGet(requestParameters = {}, options) {
            return localVarFp.adminGlobalshippingconfigGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [ShippingAdmin] update a global shipping config
         * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPatch(requestParameters = {}, options) {
            return localVarFp.adminGlobalshippingconfigPatch(requestParameters.adminGlobalshippingconfigPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [ShippingAdmin] create a global shipping config
         * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGlobalshippingconfigPost(requestParameters = {}, options) {
            return localVarFp.adminGlobalshippingconfigPost(requestParameters.adminGlobalshippingconfigPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminGlobalShippingConfigsApi - object-oriented interface
 * @export
 * @class AdminGlobalShippingConfigsApi
 * @extends {BaseAPI}
 */
export class AdminGlobalShippingConfigsApi extends BaseAPI {
    /**
     *
     * @summary [Admin] get a global shipping config
     * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigEntityIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminGlobalShippingConfigsApi
     */
    adminGlobalshippingconfigEntityIdGet(requestParameters, options) {
        return AdminGlobalShippingConfigsApiFp(this.configuration).adminGlobalshippingconfigEntityIdGet(requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] get global shipping configs and filter by name
     * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminGlobalShippingConfigsApi
     */
    adminGlobalshippingconfigGet(requestParameters = {}, options) {
        return AdminGlobalShippingConfigsApiFp(this.configuration).adminGlobalshippingconfigGet(requestParameters.searchTerm, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [ShippingAdmin] update a global shipping config
     * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminGlobalShippingConfigsApi
     */
    adminGlobalshippingconfigPatch(requestParameters = {}, options) {
        return AdminGlobalShippingConfigsApiFp(this.configuration).adminGlobalshippingconfigPatch(requestParameters.adminGlobalshippingconfigPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [ShippingAdmin] create a global shipping config
     * @param {AdminGlobalShippingConfigsApiAdminGlobalshippingconfigPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminGlobalShippingConfigsApi
     */
    adminGlobalshippingconfigPost(requestParameters = {}, options) {
        return AdminGlobalShippingConfigsApiFp(this.configuration).adminGlobalshippingconfigPost(requestParameters.adminGlobalshippingconfigPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminLegalOrganisationApi - axios parameter creator
 * @export
 */
export const AdminLegalOrganisationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] get all legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/legalorganisations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Delete a legal organisation by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminLegalorganisationsIdDelete', 'id', id);
            const localVarPath = `/admin/legalorganisations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get a legal organisation by id
         * @param {string} id ID of the legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminLegalorganisationsIdGet', 'id', id);
            const localVarPath = `/admin/legalorganisations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update a legal organisation
         * @param {string} legalOrganisationId
         * @param {AdminLegalorganisationsLegalOrganisationIdPatchRequest} [adminLegalorganisationsLegalOrganisationIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsLegalOrganisationIdPatch: (legalOrganisationId, adminLegalorganisationsLegalOrganisationIdPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'legalOrganisationId' is not null or undefined
            assertParamExists('adminLegalorganisationsLegalOrganisationIdPatch', 'legalOrganisationId', legalOrganisationId);
            const localVarPath = `/admin/legalorganisations/{legalOrganisationId}`
                .replace(`{${"legalOrganisationId"}}`, encodeURIComponent(String(legalOrganisationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminLegalorganisationsLegalOrganisationIdPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Gets a paginated list of legal organisations with the searched name
         * @param {string} [searchTerm]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsListGet: (searchTerm, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/legalorganisations/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Create a legal organisation
         * @param {AdminLegalorganisationsPostRequest} [adminLegalorganisationsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsPost: (adminLegalorganisationsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/legalorganisations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminLegalorganisationsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminLegalOrganisationApi - functional programming interface
 * @export
 */
export const AdminLegalOrganisationApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminLegalOrganisationApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] get all legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminLegalorganisationsGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Delete a legal organisation by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminLegalorganisationsIdDelete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get a legal organisation by id
         * @param {string} id ID of the legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminLegalorganisationsIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update a legal organisation
         * @param {string} legalOrganisationId
         * @param {AdminLegalorganisationsLegalOrganisationIdPatchRequest} [adminLegalorganisationsLegalOrganisationIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsLegalOrganisationIdPatch(legalOrganisationId, adminLegalorganisationsLegalOrganisationIdPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminLegalorganisationsLegalOrganisationIdPatch(legalOrganisationId, adminLegalorganisationsLegalOrganisationIdPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Gets a paginated list of legal organisations with the searched name
         * @param {string} [searchTerm]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsListGet(searchTerm, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminLegalorganisationsListGet(searchTerm, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Create a legal organisation
         * @param {AdminLegalorganisationsPostRequest} [adminLegalorganisationsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsPost(adminLegalorganisationsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminLegalorganisationsPost(adminLegalorganisationsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminLegalOrganisationApi - factory interface
 * @export
 */
export const AdminLegalOrganisationApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminLegalOrganisationApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] get all legal organisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsGet(options) {
            return localVarFp.adminLegalorganisationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Delete a legal organisation by Id
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdDelete(requestParameters, options) {
            return localVarFp.adminLegalorganisationsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get a legal organisation by id
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsIdGet(requestParameters, options) {
            return localVarFp.adminLegalorganisationsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update a legal organisation
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsLegalOrganisationIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsLegalOrganisationIdPatch(requestParameters, options) {
            return localVarFp.adminLegalorganisationsLegalOrganisationIdPatch(requestParameters.legalOrganisationId, requestParameters.adminLegalorganisationsLegalOrganisationIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Gets a paginated list of legal organisations with the searched name
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsListGet(requestParameters = {}, options) {
            return localVarFp.adminLegalorganisationsListGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Create a legal organisation
         * @param {AdminLegalOrganisationApiAdminLegalorganisationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminLegalorganisationsPost(requestParameters = {}, options) {
            return localVarFp.adminLegalorganisationsPost(requestParameters.adminLegalorganisationsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminLegalOrganisationApi - object-oriented interface
 * @export
 * @class AdminLegalOrganisationApi
 * @extends {BaseAPI}
 */
export class AdminLegalOrganisationApi extends BaseAPI {
    /**
     *
     * @summary [Admin] get all legal organisation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLegalOrganisationApi
     */
    adminLegalorganisationsGet(options) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Delete a legal organisation by Id
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLegalOrganisationApi
     */
    adminLegalorganisationsIdDelete(requestParameters, options) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get a legal organisation by id
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLegalOrganisationApi
     */
    adminLegalorganisationsIdGet(requestParameters, options) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update a legal organisation
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsLegalOrganisationIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLegalOrganisationApi
     */
    adminLegalorganisationsLegalOrganisationIdPatch(requestParameters, options) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsLegalOrganisationIdPatch(requestParameters.legalOrganisationId, requestParameters.adminLegalorganisationsLegalOrganisationIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Gets a paginated list of legal organisations with the searched name
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLegalOrganisationApi
     */
    adminLegalorganisationsListGet(requestParameters = {}, options) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsListGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Create a legal organisation
     * @param {AdminLegalOrganisationApiAdminLegalorganisationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminLegalOrganisationApi
     */
    adminLegalorganisationsPost(requestParameters = {}, options) {
        return AdminLegalOrganisationApiFp(this.configuration).adminLegalorganisationsPost(requestParameters.adminLegalorganisationsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminNotesApi - axios parameter creator
 * @export
 */
export const AdminNotesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] get notes for an entity
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesGet: (entityId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('adminEntitiesEntityIdNotesGet', 'entityId', entityId);
            const localVarPath = `/admin/entities/{entityId}/notes`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] create a note for an entity with id entityId
         * @param {string} entityId
         * @param {AdminEntitiesEntityIdNotesPostRequest} [adminEntitiesEntityIdNotesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesPost: (entityId, adminEntitiesEntityIdNotesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('adminEntitiesEntityIdNotesPost', 'entityId', entityId);
            const localVarPath = `/admin/entities/{entityId}/notes`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminEntitiesEntityIdNotesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] delete a note by noteId
         * @param {string} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdDelete: (noteId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('adminNotesNoteIdDelete', 'noteId', noteId);
            const localVarPath = `/admin/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] update a note by noteId
         * @param {string} noteId
         * @param {AdminNotesNoteIdPatchRequest} [adminNotesNoteIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdPatch: (noteId, adminNotesNoteIdPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'noteId' is not null or undefined
            assertParamExists('adminNotesNoteIdPatch', 'noteId', noteId);
            const localVarPath = `/admin/notes/{noteId}`
                .replace(`{${"noteId"}}`, encodeURIComponent(String(noteId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminNotesNoteIdPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminNotesApi - functional programming interface
 * @export
 */
export const AdminNotesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminNotesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] get notes for an entity
         * @param {string} entityId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesGet(entityId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminEntitiesEntityIdNotesGet(entityId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] create a note for an entity with id entityId
         * @param {string} entityId
         * @param {AdminEntitiesEntityIdNotesPostRequest} [adminEntitiesEntityIdNotesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesPost(entityId, adminEntitiesEntityIdNotesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminEntitiesEntityIdNotesPost(entityId, adminEntitiesEntityIdNotesPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] delete a note by noteId
         * @param {string} noteId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdDelete(noteId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminNotesNoteIdDelete(noteId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] update a note by noteId
         * @param {string} noteId
         * @param {AdminNotesNoteIdPatchRequest} [adminNotesNoteIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdPatch(noteId, adminNotesNoteIdPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminNotesNoteIdPatch(noteId, adminNotesNoteIdPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminNotesApi - factory interface
 * @export
 */
export const AdminNotesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminNotesApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] get notes for an entity
         * @param {AdminNotesApiAdminEntitiesEntityIdNotesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesGet(requestParameters, options) {
            return localVarFp.adminEntitiesEntityIdNotesGet(requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] create a note for an entity with id entityId
         * @param {AdminNotesApiAdminEntitiesEntityIdNotesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminEntitiesEntityIdNotesPost(requestParameters, options) {
            return localVarFp.adminEntitiesEntityIdNotesPost(requestParameters.entityId, requestParameters.adminEntitiesEntityIdNotesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] delete a note by noteId
         * @param {AdminNotesApiAdminNotesNoteIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdDelete(requestParameters, options) {
            return localVarFp.adminNotesNoteIdDelete(requestParameters.noteId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] update a note by noteId
         * @param {AdminNotesApiAdminNotesNoteIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminNotesNoteIdPatch(requestParameters, options) {
            return localVarFp.adminNotesNoteIdPatch(requestParameters.noteId, requestParameters.adminNotesNoteIdPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminNotesApi - object-oriented interface
 * @export
 * @class AdminNotesApi
 * @extends {BaseAPI}
 */
export class AdminNotesApi extends BaseAPI {
    /**
     *
     * @summary [Admin] get notes for an entity
     * @param {AdminNotesApiAdminEntitiesEntityIdNotesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotesApi
     */
    adminEntitiesEntityIdNotesGet(requestParameters, options) {
        return AdminNotesApiFp(this.configuration).adminEntitiesEntityIdNotesGet(requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] create a note for an entity with id entityId
     * @param {AdminNotesApiAdminEntitiesEntityIdNotesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotesApi
     */
    adminEntitiesEntityIdNotesPost(requestParameters, options) {
        return AdminNotesApiFp(this.configuration).adminEntitiesEntityIdNotesPost(requestParameters.entityId, requestParameters.adminEntitiesEntityIdNotesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] delete a note by noteId
     * @param {AdminNotesApiAdminNotesNoteIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotesApi
     */
    adminNotesNoteIdDelete(requestParameters, options) {
        return AdminNotesApiFp(this.configuration).adminNotesNoteIdDelete(requestParameters.noteId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] update a note by noteId
     * @param {AdminNotesApiAdminNotesNoteIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminNotesApi
     */
    adminNotesNoteIdPatch(requestParameters, options) {
        return AdminNotesApiFp(this.configuration).adminNotesNoteIdPatch(requestParameters.noteId, requestParameters.adminNotesNoteIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminOrderDocumentsApi - axios parameter creator
 * @export
 */
export const AdminOrderDocumentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] get an order document including its invoice items by id
         * @param {string} documentId the id of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdGet: (documentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('adminOrderDocumentsDocumentIdGet', 'documentId', documentId);
            const localVarPath = `/admin/order-documents/{documentId}`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get the url of an order document pdf
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdPdfGet: (documentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('adminOrderDocumentsDocumentIdPdfGet', 'documentId', documentId);
            const localVarPath = `/admin/order-documents/{documentId}/pdf`
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] List invoice documents of an event
         * @param {string} eventId
         * @param {string} [searchTerm]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdGet: (eventId, searchTerm, pageSize, offset, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminOrderDocumentsEventsEventIdGet', 'eventId', eventId);
            const localVarPath = `/admin/order-documents/events/{eventId}`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Recalculate invoice documents for an event
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdRecalculationPost: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminOrderDocumentsEventsEventIdRecalculationPost', 'eventId', eventId);
            const localVarPath = `/admin/order-documents/events/{eventId}/recalculation`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Download a zip file containing all the customer invoices for an event
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdZipGet: (eventId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('adminOrderDocumentsEventsEventIdZipGet', 'eventId', eventId);
            const localVarPath = `/admin/order-documents/events/{eventId}/zip`
                .replace(`{${"eventId"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Search order documents.
         * @param {string} [vendorId]
         * @param {string} [searchTerm]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsGet: (vendorId, searchTerm, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/order-documents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (vendorId !== undefined) {
                localVarQueryParameter['vendorId'] = vendorId;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] get paginated order documents of an user.
         * @param {string} userId The id of the user
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsUsersUserIdGet: (userId, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminOrderDocumentsUsersUserIdGet', 'userId', userId);
            const localVarPath = `/admin/order-documents/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminOrderDocumentsApi - functional programming interface
 * @export
 */
export const AdminOrderDocumentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminOrderDocumentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] get an order document including its invoice items by id
         * @param {string} documentId the id of the invoice
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdGet(documentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrderDocumentsDocumentIdGet(documentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get the url of an order document pdf
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdPdfGet(documentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrderDocumentsDocumentIdPdfGet(documentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] List invoice documents of an event
         * @param {string} eventId
         * @param {string} [searchTerm]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdGet(eventId, searchTerm, pageSize, offset, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrderDocumentsEventsEventIdGet(eventId, searchTerm, pageSize, offset, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Recalculate invoice documents for an event
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdRecalculationPost(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrderDocumentsEventsEventIdRecalculationPost(eventId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Download a zip file containing all the customer invoices for an event
         * @param {string} eventId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdZipGet(eventId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrderDocumentsEventsEventIdZipGet(eventId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Search order documents.
         * @param {string} [vendorId]
         * @param {string} [searchTerm]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsGet(vendorId, searchTerm, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrderDocumentsGet(vendorId, searchTerm, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] get paginated order documents of an user.
         * @param {string} userId The id of the user
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsUsersUserIdGet(userId, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrderDocumentsUsersUserIdGet(userId, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminOrderDocumentsApi - factory interface
 * @export
 */
export const AdminOrderDocumentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminOrderDocumentsApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] get an order document including its invoice items by id
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdGet(requestParameters, options) {
            return localVarFp.adminOrderDocumentsDocumentIdGet(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get the url of an order document pdf
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsDocumentIdPdfGet(requestParameters, options) {
            return localVarFp.adminOrderDocumentsDocumentIdPdfGet(requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] List invoice documents of an event
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdGet(requestParameters, options) {
            return localVarFp.adminOrderDocumentsEventsEventIdGet(requestParameters.eventId, requestParameters.searchTerm, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Recalculate invoice documents for an event
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdRecalculationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdRecalculationPost(requestParameters, options) {
            return localVarFp.adminOrderDocumentsEventsEventIdRecalculationPost(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Download a zip file containing all the customer invoices for an event
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdZipGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsEventsEventIdZipGet(requestParameters, options) {
            return localVarFp.adminOrderDocumentsEventsEventIdZipGet(requestParameters.eventId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Search order documents.
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsGet(requestParameters = {}, options) {
            return localVarFp.adminOrderDocumentsGet(requestParameters.vendorId, requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] get paginated order documents of an user.
         * @param {AdminOrderDocumentsApiAdminOrderDocumentsUsersUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrderDocumentsUsersUserIdGet(requestParameters, options) {
            return localVarFp.adminOrderDocumentsUsersUserIdGet(requestParameters.userId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminOrderDocumentsApi - object-oriented interface
 * @export
 * @class AdminOrderDocumentsApi
 * @extends {BaseAPI}
 */
export class AdminOrderDocumentsApi extends BaseAPI {
    /**
     *
     * @summary [Admin] get an order document including its invoice items by id
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDocumentsApi
     */
    adminOrderDocumentsDocumentIdGet(requestParameters, options) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsDocumentIdGet(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get the url of an order document pdf
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsDocumentIdPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDocumentsApi
     */
    adminOrderDocumentsDocumentIdPdfGet(requestParameters, options) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsDocumentIdPdfGet(requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] List invoice documents of an event
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDocumentsApi
     */
    adminOrderDocumentsEventsEventIdGet(requestParameters, options) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsEventsEventIdGet(requestParameters.eventId, requestParameters.searchTerm, requestParameters.pageSize, requestParameters.offset, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Recalculate invoice documents for an event
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdRecalculationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDocumentsApi
     */
    adminOrderDocumentsEventsEventIdRecalculationPost(requestParameters, options) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsEventsEventIdRecalculationPost(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Download a zip file containing all the customer invoices for an event
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsEventsEventIdZipGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDocumentsApi
     */
    adminOrderDocumentsEventsEventIdZipGet(requestParameters, options) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsEventsEventIdZipGet(requestParameters.eventId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Search order documents.
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDocumentsApi
     */
    adminOrderDocumentsGet(requestParameters = {}, options) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsGet(requestParameters.vendorId, requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] get paginated order documents of an user.
     * @param {AdminOrderDocumentsApiAdminOrderDocumentsUsersUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderDocumentsApi
     */
    adminOrderDocumentsUsersUserIdGet(requestParameters, options) {
        return AdminOrderDocumentsApiFp(this.configuration).adminOrderDocumentsUsersUserIdGet(requestParameters.userId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminOrderRefundsApi - axios parameter creator
 * @export
 */
export const AdminOrderRefundsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} orderId
         * @param {number} [percentage]
         * @param {'ShippingAmount' | 'VatAmount' | 'ItemAmount' | 'TotalAmount'} [refundType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundCalculateGet: (orderId, percentage, refundType, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdRefundCalculateGet', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/refund/calculate`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (percentage !== undefined) {
                localVarQueryParameter['percentage'] = percentage;
            }
            if (refundType !== undefined) {
                localVarQueryParameter['refundType'] = refundType;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} orderId
         * @param {AdminOrdersOrderIdRefundPostRequest} [adminOrdersOrderIdRefundPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundPost: (orderId, adminOrdersOrderIdRefundPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdRefundPost', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/refund`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrdersOrderIdRefundPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminOrderRefundsApi - functional programming interface
 * @export
 */
export const AdminOrderRefundsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminOrderRefundsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} orderId
         * @param {number} [percentage]
         * @param {'ShippingAmount' | 'VatAmount' | 'ItemAmount' | 'TotalAmount'} [refundType]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundCalculateGet(orderId, percentage, refundType, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdRefundCalculateGet(orderId, percentage, refundType, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} orderId
         * @param {AdminOrdersOrderIdRefundPostRequest} [adminOrdersOrderIdRefundPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundPost(orderId, adminOrdersOrderIdRefundPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdRefundPost(orderId, adminOrdersOrderIdRefundPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminOrderRefundsApi - factory interface
 * @export
 */
export const AdminOrderRefundsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminOrderRefundsApiFp(configuration);
    return {
        /**
         *
         * @param {AdminOrderRefundsApiAdminOrdersOrderIdRefundCalculateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundCalculateGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdRefundCalculateGet(requestParameters.orderId, requestParameters.percentage, requestParameters.refundType, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminOrderRefundsApiAdminOrdersOrderIdRefundPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdRefundPost(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdRefundPost(requestParameters.orderId, requestParameters.adminOrdersOrderIdRefundPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminOrderRefundsApi - object-oriented interface
 * @export
 * @class AdminOrderRefundsApi
 * @extends {BaseAPI}
 */
export class AdminOrderRefundsApi extends BaseAPI {
    /**
     *
     * @param {AdminOrderRefundsApiAdminOrdersOrderIdRefundCalculateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderRefundsApi
     */
    adminOrdersOrderIdRefundCalculateGet(requestParameters, options) {
        return AdminOrderRefundsApiFp(this.configuration).adminOrdersOrderIdRefundCalculateGet(requestParameters.orderId, requestParameters.percentage, requestParameters.refundType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminOrderRefundsApiAdminOrdersOrderIdRefundPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrderRefundsApi
     */
    adminOrdersOrderIdRefundPost(requestParameters, options) {
        return AdminOrderRefundsApiFp(this.configuration).adminOrdersOrderIdRefundPost(requestParameters.orderId, requestParameters.adminOrdersOrderIdRefundPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminOrdersApi - axios parameter creator
 * @export
 */
export const AdminOrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} parcelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersBundledParcelIdGet: (parcelId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'parcelId' is not null or undefined
            assertParamExists('adminOrdersBundledParcelIdGet', 'parcelId', parcelId);
            const localVarPath = `/admin/orders/bundled/{parcelId}`
                .replace(`{${"parcelId"}}`, encodeURIComponent(String(parcelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] list framing orders
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {string} [searchTerm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersFramingGet: (pageSize, offset, searchTerm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/orders/framing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] get paginated result of orders
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {'All' | 'Frames' | 'Products' | 'Tickets'} [ordersFilter] all, frames, products &#x3D;&gt; use one of them to get the specific filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersGet: (xPlatformKey, eventId, offset, pageSize, ordersFilter, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/admin/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (ordersFilter !== undefined) {
                localVarQueryParameter['ordersFilter'] = ordersFilter;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update the shipping address of an order.
         * @param {string} orderId The id of the order
         * @param {string} xPlatformKey Select the platform.
         * @param {AdminOrdersOrderIdAddressShippingPatchRequest} [adminOrdersOrderIdAddressShippingPatchRequest] The request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdAddressShippingPatch: (orderId, xPlatformKey, adminOrdersOrderIdAddressShippingPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdAddressShippingPatch', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersOrderIdAddressShippingPatch', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/admin/orders/{orderId}/address/shipping`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrdersOrderIdAddressShippingPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} orderId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBlockShipmentPatch: (orderId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdBlockShipmentPatch', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/block-shipment`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get a list of orders that can be bundled with the given order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBundleableGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdBundleableGet', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/bundleable`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get a framing order by id
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdFramingGet', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/framing`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Change order FramingWindowExpirationDate
         * @param {string} orderId Id of order
         * @param {Date} [body] The Date until the order will wait for framing configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingWindowPut: (orderId, body, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdFramingWindowPut', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/framing-window`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] get an order with order items
         * @param {string} orderId The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdGet', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] get the pdf url of an order\'s invoice
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicePdfGet: (orderId, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdInvoicePdfGet', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersOrderIdInvoicePdfGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/admin/orders/{orderId}/invoice-pdf`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] get paginated customer invoices of an order by order id
         * @param {string} orderId The id of the order
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesGet: (orderId, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdInvoicesGet', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/invoices`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Regenerate the current invoice for an order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesPdfPost: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdInvoicesPdfPost', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/invoices/pdf`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create Ftg order as a sales order in Odoo
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooFtgPost: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdOdooFtgPost', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/odoo/ftg`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create MWS order as a sales order in Odoo
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooMwsPost: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdOdooMwsPost', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/odoo/mws`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update Orders Almost Everything
         * @param {string} orderId
         * @param {AdminOrdersOrderIdPatchRequest} [adminOrdersOrderIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPatch: (orderId, adminOrdersOrderIdPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPatch', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrdersOrderIdPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] send a payment reminder email for an order to the customer
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {AdminOrdersOrderIdPaymentReminderPostRequest} [adminOrdersOrderIdPaymentReminderPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentReminderPost: (orderId, xPlatformKey, adminOrdersOrderIdPaymentReminderPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPaymentReminderPost', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersOrderIdPaymentReminderPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/admin/orders/{orderId}/payment-reminder`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrdersOrderIdPaymentReminderPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get payments by order id
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentsGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPaymentsGet', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/payments`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Pick an order.
         * @param {string} orderId
         * @param {AdminOrdersOrderIdPicksPutRequest} [adminOrdersOrderIdPicksPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPicksPut: (orderId, adminOrdersOrderIdPicksPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdPicksPut', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/picks`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrdersOrderIdPicksPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get the shipment details for a shippable order.
         * @param {string} orderId
         * @param {string} [originCountryCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentDetailsGet: (orderId, originCountryCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdShipmentDetailsGet', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/shipment-details`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (originCountryCode !== undefined) {
                localVarQueryParameter['originCountryCode'] = originCountryCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Resets the shipment of an order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentResetPatch: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdShipmentResetPatch', 'orderId', orderId);
            const localVarPath = `/admin/orders/{orderId}/shipment/reset`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update Order Manual Shipped Status
         * @param {string} orderId The id of the order
         * @param {string} xPlatformKey Select the platform.
         * @param {AdminOrdersOrderIdShippedManuallyPatchRequest} [adminOrdersOrderIdShippedManuallyPatchRequest] The request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShippedManuallyPatch: (orderId, xPlatformKey, adminOrdersOrderIdShippedManuallyPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminOrdersOrderIdShippedManuallyPatch', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersOrderIdShippedManuallyPatch', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/admin/orders/{orderId}/shipped-manually`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrdersOrderIdShippedManuallyPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] search for orders
         * @param {string} [searchTerm]
         * @param {string} [paymentFilter]
         * @param {string} [shippingFilter]
         * @param {string} [country]
         * @param {string} [eventId]
         * @param {'All' | 'Frames' | 'Products' | 'Tickets'} [ordersFilter]
         * @param {'ShowAll' | 'Yes' | 'No'} [authenticatedByFabricksFilter]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {string} [sortOption]
         * @param {string} [sortDirection]
         * @param {boolean} [filterB2bFramingOrders]
         * @param {string} [platformId]
         * @param {string} [shippingOfficeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSearchGet: (searchTerm, paymentFilter, shippingFilter, country, eventId, ordersFilter, authenticatedByFabricksFilter, pageSize, offset, sortOption, sortDirection, filterB2bFramingOrders, platformId, shippingOfficeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/orders/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (paymentFilter !== undefined) {
                localVarQueryParameter['paymentFilter'] = paymentFilter;
            }
            if (shippingFilter !== undefined) {
                localVarQueryParameter['shippingFilter'] = shippingFilter;
            }
            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }
            if (eventId !== undefined) {
                localVarQueryParameter['eventId'] = eventId;
            }
            if (ordersFilter !== undefined) {
                localVarQueryParameter['ordersFilter'] = ordersFilter;
            }
            if (authenticatedByFabricksFilter !== undefined) {
                localVarQueryParameter['authenticatedByFabricksFilter'] = authenticatedByFabricksFilter;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortOption !== undefined) {
                localVarQueryParameter['sortOption'] = sortOption;
            }
            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }
            if (filterB2bFramingOrders !== undefined) {
                localVarQueryParameter['filterB2bFramingOrders'] = filterB2bFramingOrders;
            }
            if (platformId !== undefined) {
                localVarQueryParameter['platformId'] = platformId;
            }
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shippingOfficeId'] = shippingOfficeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get non-closed orders of a product
         * @param {string} skuId Id of the sku
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkuSkuIdGet: (skuId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'skuId' is not null or undefined
            assertParamExists('adminOrdersSkuSkuIdGet', 'skuId', skuId);
            const localVarPath = `/admin/orders/sku/{skuId}`
                .replace(`{${"skuId"}}`, encodeURIComponent(String(skuId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] get report orders by sku ids
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkusPost: (requestBody, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/orders/skus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Create a new order for a user.
         * @param {string} userId
         * @param {string} xPlatformKey Select the platform.
         * @param {AdminOrdersUsersUserIdPostRequest} [adminOrdersUsersUserIdPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersUsersUserIdPost: (userId, xPlatformKey, adminOrdersUsersUserIdPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminOrdersUsersUserIdPost', 'userId', userId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminOrdersUsersUserIdPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/admin/orders/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminOrdersUsersUserIdPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] get orders for an user
         * @param {string} userId The id of the user
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdOrdersGet: (userId, xPlatformKey, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('adminUsersUserIdOrdersGet', 'userId', userId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('adminUsersUserIdOrdersGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/admin/users/{userId}/orders`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminOrdersApi - functional programming interface
 * @export
 */
export const AdminOrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminOrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} parcelId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersBundledParcelIdGet(parcelId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersBundledParcelIdGet(parcelId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] list framing orders
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {string} [searchTerm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersFramingGet(pageSize, offset, searchTerm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersFramingGet(pageSize, offset, searchTerm, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] get paginated result of orders
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [eventId]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {'All' | 'Frames' | 'Products' | 'Tickets'} [ordersFilter] all, frames, products &#x3D;&gt; use one of them to get the specific filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersGet(xPlatformKey, eventId, offset, pageSize, ordersFilter, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersGet(xPlatformKey, eventId, offset, pageSize, ordersFilter, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update the shipping address of an order.
         * @param {string} orderId The id of the order
         * @param {string} xPlatformKey Select the platform.
         * @param {AdminOrdersOrderIdAddressShippingPatchRequest} [adminOrdersOrderIdAddressShippingPatchRequest] The request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdAddressShippingPatch(orderId, xPlatformKey, adminOrdersOrderIdAddressShippingPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdAddressShippingPatch(orderId, xPlatformKey, adminOrdersOrderIdAddressShippingPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} orderId
         * @param {boolean} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBlockShipmentPatch(orderId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdBlockShipmentPatch(orderId, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get a list of orders that can be bundled with the given order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBundleableGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdBundleableGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get a framing order by id
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdFramingGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Change order FramingWindowExpirationDate
         * @param {string} orderId Id of order
         * @param {Date} [body] The Date until the order will wait for framing configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingWindowPut(orderId, body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdFramingWindowPut(orderId, body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] get an order with order items
         * @param {string} orderId The id of the order
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] get the pdf url of an order\'s invoice
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicePdfGet(orderId, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdInvoicePdfGet(orderId, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] get paginated customer invoices of an order by order id
         * @param {string} orderId The id of the order
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesGet(orderId, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdInvoicesGet(orderId, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Regenerate the current invoice for an order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesPdfPost(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdInvoicesPdfPost(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create Ftg order as a sales order in Odoo
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooFtgPost(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdOdooFtgPost(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create MWS order as a sales order in Odoo
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooMwsPost(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdOdooMwsPost(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update Orders Almost Everything
         * @param {string} orderId
         * @param {AdminOrdersOrderIdPatchRequest} [adminOrdersOrderIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPatch(orderId, adminOrdersOrderIdPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdPatch(orderId, adminOrdersOrderIdPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] send a payment reminder email for an order to the customer
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {AdminOrdersOrderIdPaymentReminderPostRequest} [adminOrdersOrderIdPaymentReminderPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentReminderPost(orderId, xPlatformKey, adminOrdersOrderIdPaymentReminderPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdPaymentReminderPost(orderId, xPlatformKey, adminOrdersOrderIdPaymentReminderPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get payments by order id
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentsGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdPaymentsGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Pick an order.
         * @param {string} orderId
         * @param {AdminOrdersOrderIdPicksPutRequest} [adminOrdersOrderIdPicksPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPicksPut(orderId, adminOrdersOrderIdPicksPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdPicksPut(orderId, adminOrdersOrderIdPicksPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get the shipment details for a shippable order.
         * @param {string} orderId
         * @param {string} [originCountryCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentDetailsGet(orderId, originCountryCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdShipmentDetailsGet(orderId, originCountryCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Resets the shipment of an order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentResetPatch(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdShipmentResetPatch(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update Order Manual Shipped Status
         * @param {string} orderId The id of the order
         * @param {string} xPlatformKey Select the platform.
         * @param {AdminOrdersOrderIdShippedManuallyPatchRequest} [adminOrdersOrderIdShippedManuallyPatchRequest] The request body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShippedManuallyPatch(orderId, xPlatformKey, adminOrdersOrderIdShippedManuallyPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersOrderIdShippedManuallyPatch(orderId, xPlatformKey, adminOrdersOrderIdShippedManuallyPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] search for orders
         * @param {string} [searchTerm]
         * @param {string} [paymentFilter]
         * @param {string} [shippingFilter]
         * @param {string} [country]
         * @param {string} [eventId]
         * @param {'All' | 'Frames' | 'Products' | 'Tickets'} [ordersFilter]
         * @param {'ShowAll' | 'Yes' | 'No'} [authenticatedByFabricksFilter]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {string} [sortOption]
         * @param {string} [sortDirection]
         * @param {boolean} [filterB2bFramingOrders]
         * @param {string} [platformId]
         * @param {string} [shippingOfficeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSearchGet(searchTerm, paymentFilter, shippingFilter, country, eventId, ordersFilter, authenticatedByFabricksFilter, pageSize, offset, sortOption, sortDirection, filterB2bFramingOrders, platformId, shippingOfficeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersSearchGet(searchTerm, paymentFilter, shippingFilter, country, eventId, ordersFilter, authenticatedByFabricksFilter, pageSize, offset, sortOption, sortDirection, filterB2bFramingOrders, platformId, shippingOfficeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get non-closed orders of a product
         * @param {string} skuId Id of the sku
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkuSkuIdGet(skuId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersSkuSkuIdGet(skuId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] get report orders by sku ids
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkusPost(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersSkusPost(requestBody, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Create a new order for a user.
         * @param {string} userId
         * @param {string} xPlatformKey Select the platform.
         * @param {AdminOrdersUsersUserIdPostRequest} [adminOrdersUsersUserIdPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersUsersUserIdPost(userId, xPlatformKey, adminOrdersUsersUserIdPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersUsersUserIdPost(userId, xPlatformKey, adminOrdersUsersUserIdPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] get orders for an user
         * @param {string} userId The id of the user
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdOrdersGet(userId, xPlatformKey, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminUsersUserIdOrdersGet(userId, xPlatformKey, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminOrdersApi - factory interface
 * @export
 */
export const AdminOrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminOrdersApiFp(configuration);
    return {
        /**
         *
         * @param {AdminOrdersApiAdminOrdersBundledParcelIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersBundledParcelIdGet(requestParameters, options) {
            return localVarFp.adminOrdersBundledParcelIdGet(requestParameters.parcelId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] list framing orders
         * @param {AdminOrdersApiAdminOrdersFramingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersFramingGet(requestParameters = {}, options) {
            return localVarFp.adminOrdersFramingGet(requestParameters.pageSize, requestParameters.offset, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] get paginated result of orders
         * @param {AdminOrdersApiAdminOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersGet(requestParameters, options) {
            return localVarFp.adminOrdersGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.offset, requestParameters.pageSize, requestParameters.ordersFilter, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update the shipping address of an order.
         * @param {AdminOrdersApiAdminOrdersOrderIdAddressShippingPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdAddressShippingPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdAddressShippingPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.adminOrdersOrderIdAddressShippingPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminOrdersApiAdminOrdersOrderIdBlockShipmentPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBlockShipmentPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdBlockShipmentPatch(requestParameters.orderId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get a list of orders that can be bundled with the given order
         * @param {AdminOrdersApiAdminOrdersOrderIdBundleableGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdBundleableGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdBundleableGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get a framing order by id
         * @param {AdminOrdersApiAdminOrdersOrderIdFramingGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdFramingGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Change order FramingWindowExpirationDate
         * @param {AdminOrdersApiAdminOrdersOrderIdFramingWindowPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdFramingWindowPut(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdFramingWindowPut(requestParameters.orderId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] get an order with order items
         * @param {AdminOrdersApiAdminOrdersOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] get the pdf url of an order\'s invoice
         * @param {AdminOrdersApiAdminOrdersOrderIdInvoicePdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicePdfGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdInvoicePdfGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] get paginated customer invoices of an order by order id
         * @param {AdminOrdersApiAdminOrdersOrderIdInvoicesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdInvoicesGet(requestParameters.orderId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Regenerate the current invoice for an order
         * @param {AdminOrdersApiAdminOrdersOrderIdInvoicesPdfPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdInvoicesPdfPost(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdInvoicesPdfPost(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Ftg order as a sales order in Odoo
         * @param {AdminOrdersApiAdminOrdersOrderIdOdooFtgPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooFtgPost(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdOdooFtgPost(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create MWS order as a sales order in Odoo
         * @param {AdminOrdersApiAdminOrdersOrderIdOdooMwsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdOdooMwsPost(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdOdooMwsPost(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update Orders Almost Everything
         * @param {AdminOrdersApiAdminOrdersOrderIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdPatch(requestParameters.orderId, requestParameters.adminOrdersOrderIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] send a payment reminder email for an order to the customer
         * @param {AdminOrdersApiAdminOrdersOrderIdPaymentReminderPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentReminderPost(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdPaymentReminderPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.adminOrdersOrderIdPaymentReminderPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get payments by order id
         * @param {AdminOrdersApiAdminOrdersOrderIdPaymentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPaymentsGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdPaymentsGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Pick an order.
         * @param {AdminOrdersApiAdminOrdersOrderIdPicksPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdPicksPut(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdPicksPut(requestParameters.orderId, requestParameters.adminOrdersOrderIdPicksPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get the shipment details for a shippable order.
         * @param {AdminOrdersApiAdminOrdersOrderIdShipmentDetailsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentDetailsGet(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdShipmentDetailsGet(requestParameters.orderId, requestParameters.originCountryCode, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resets the shipment of an order
         * @param {AdminOrdersApiAdminOrdersOrderIdShipmentResetPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShipmentResetPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdShipmentResetPatch(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update Order Manual Shipped Status
         * @param {AdminOrdersApiAdminOrdersOrderIdShippedManuallyPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersOrderIdShippedManuallyPatch(requestParameters, options) {
            return localVarFp.adminOrdersOrderIdShippedManuallyPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.adminOrdersOrderIdShippedManuallyPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] search for orders
         * @param {AdminOrdersApiAdminOrdersSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSearchGet(requestParameters = {}, options) {
            return localVarFp.adminOrdersSearchGet(requestParameters.searchTerm, requestParameters.paymentFilter, requestParameters.shippingFilter, requestParameters.country, requestParameters.eventId, requestParameters.ordersFilter, requestParameters.authenticatedByFabricksFilter, requestParameters.pageSize, requestParameters.offset, requestParameters.sortOption, requestParameters.sortDirection, requestParameters.filterB2bFramingOrders, requestParameters.platformId, requestParameters.shippingOfficeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get non-closed orders of a product
         * @param {AdminOrdersApiAdminOrdersSkuSkuIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkuSkuIdGet(requestParameters, options) {
            return localVarFp.adminOrdersSkuSkuIdGet(requestParameters.skuId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] get report orders by sku ids
         * @param {AdminOrdersApiAdminOrdersSkusPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersSkusPost(requestParameters = {}, options) {
            return localVarFp.adminOrdersSkusPost(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Create a new order for a user.
         * @param {AdminOrdersApiAdminOrdersUsersUserIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersUsersUserIdPost(requestParameters, options) {
            return localVarFp.adminOrdersUsersUserIdPost(requestParameters.userId, requestParameters.xPlatformKey, requestParameters.adminOrdersUsersUserIdPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] get orders for an user
         * @param {AdminOrdersApiAdminUsersUserIdOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUsersUserIdOrdersGet(requestParameters, options) {
            return localVarFp.adminUsersUserIdOrdersGet(requestParameters.userId, requestParameters.xPlatformKey, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminOrdersApi - object-oriented interface
 * @export
 * @class AdminOrdersApi
 * @extends {BaseAPI}
 */
export class AdminOrdersApi extends BaseAPI {
    /**
     *
     * @param {AdminOrdersApiAdminOrdersBundledParcelIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersBundledParcelIdGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersBundledParcelIdGet(requestParameters.parcelId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] list framing orders
     * @param {AdminOrdersApiAdminOrdersFramingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersFramingGet(requestParameters = {}, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersFramingGet(requestParameters.pageSize, requestParameters.offset, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] get paginated result of orders
     * @param {AdminOrdersApiAdminOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersGet(requestParameters.xPlatformKey, requestParameters.eventId, requestParameters.offset, requestParameters.pageSize, requestParameters.ordersFilter, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update the shipping address of an order.
     * @param {AdminOrdersApiAdminOrdersOrderIdAddressShippingPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdAddressShippingPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdAddressShippingPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.adminOrdersOrderIdAddressShippingPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminOrdersApiAdminOrdersOrderIdBlockShipmentPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdBlockShipmentPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdBlockShipmentPatch(requestParameters.orderId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get a list of orders that can be bundled with the given order
     * @param {AdminOrdersApiAdminOrdersOrderIdBundleableGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdBundleableGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdBundleableGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get a framing order by id
     * @param {AdminOrdersApiAdminOrdersOrderIdFramingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdFramingGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdFramingGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Change order FramingWindowExpirationDate
     * @param {AdminOrdersApiAdminOrdersOrderIdFramingWindowPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdFramingWindowPut(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdFramingWindowPut(requestParameters.orderId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] get an order with order items
     * @param {AdminOrdersApiAdminOrdersOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] get the pdf url of an order\'s invoice
     * @param {AdminOrdersApiAdminOrdersOrderIdInvoicePdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdInvoicePdfGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdInvoicePdfGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] get paginated customer invoices of an order by order id
     * @param {AdminOrdersApiAdminOrdersOrderIdInvoicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdInvoicesGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdInvoicesGet(requestParameters.orderId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Regenerate the current invoice for an order
     * @param {AdminOrdersApiAdminOrdersOrderIdInvoicesPdfPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdInvoicesPdfPost(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdInvoicesPdfPost(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Ftg order as a sales order in Odoo
     * @param {AdminOrdersApiAdminOrdersOrderIdOdooFtgPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdOdooFtgPost(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdOdooFtgPost(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create MWS order as a sales order in Odoo
     * @param {AdminOrdersApiAdminOrdersOrderIdOdooMwsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdOdooMwsPost(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdOdooMwsPost(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update Orders Almost Everything
     * @param {AdminOrdersApiAdminOrdersOrderIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPatch(requestParameters.orderId, requestParameters.adminOrdersOrderIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] send a payment reminder email for an order to the customer
     * @param {AdminOrdersApiAdminOrdersOrderIdPaymentReminderPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdPaymentReminderPost(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPaymentReminderPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.adminOrdersOrderIdPaymentReminderPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get payments by order id
     * @param {AdminOrdersApiAdminOrdersOrderIdPaymentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdPaymentsGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPaymentsGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Pick an order.
     * @param {AdminOrdersApiAdminOrdersOrderIdPicksPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdPicksPut(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdPicksPut(requestParameters.orderId, requestParameters.adminOrdersOrderIdPicksPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get the shipment details for a shippable order.
     * @param {AdminOrdersApiAdminOrdersOrderIdShipmentDetailsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdShipmentDetailsGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdShipmentDetailsGet(requestParameters.orderId, requestParameters.originCountryCode, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Resets the shipment of an order
     * @param {AdminOrdersApiAdminOrdersOrderIdShipmentResetPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdShipmentResetPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdShipmentResetPatch(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update Order Manual Shipped Status
     * @param {AdminOrdersApiAdminOrdersOrderIdShippedManuallyPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersOrderIdShippedManuallyPatch(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersOrderIdShippedManuallyPatch(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.adminOrdersOrderIdShippedManuallyPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] search for orders
     * @param {AdminOrdersApiAdminOrdersSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersSearchGet(requestParameters = {}, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersSearchGet(requestParameters.searchTerm, requestParameters.paymentFilter, requestParameters.shippingFilter, requestParameters.country, requestParameters.eventId, requestParameters.ordersFilter, requestParameters.authenticatedByFabricksFilter, requestParameters.pageSize, requestParameters.offset, requestParameters.sortOption, requestParameters.sortDirection, requestParameters.filterB2bFramingOrders, requestParameters.platformId, requestParameters.shippingOfficeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get non-closed orders of a product
     * @param {AdminOrdersApiAdminOrdersSkuSkuIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersSkuSkuIdGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersSkuSkuIdGet(requestParameters.skuId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] get report orders by sku ids
     * @param {AdminOrdersApiAdminOrdersSkusPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersSkusPost(requestParameters = {}, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersSkusPost(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Create a new order for a user.
     * @param {AdminOrdersApiAdminOrdersUsersUserIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminOrdersUsersUserIdPost(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminOrdersUsersUserIdPost(requestParameters.userId, requestParameters.xPlatformKey, requestParameters.adminOrdersUsersUserIdPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] get orders for an user
     * @param {AdminOrdersApiAdminUsersUserIdOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminOrdersApi
     */
    adminUsersUserIdOrdersGet(requestParameters, options) {
        return AdminOrdersApiFp(this.configuration).adminUsersUserIdOrdersGet(requestParameters.userId, requestParameters.xPlatformKey, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminParcelApi - axios parameter creator
 * @export
 */
export const AdminParcelApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Will return the parcel for an order, this will include the protected shipping label link
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelOrderOrderIdGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('adminParcelOrderOrderIdGet', 'orderId', orderId);
            const localVarPath = `/admin/parcel/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update the shipment status of the parcel
         * @param {string} parcelId
         * @param {AdminParcelsParcelIdPatchRequest} [adminParcelsParcelIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsParcelIdPatch: (parcelId, adminParcelsParcelIdPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'parcelId' is not null or undefined
            assertParamExists('adminParcelsParcelIdPatch', 'parcelId', parcelId);
            const localVarPath = `/admin/parcels/{parcelId}`
                .replace(`{${"parcelId"}}`, encodeURIComponent(String(parcelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminParcelsParcelIdPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminParcelApi - functional programming interface
 * @export
 */
export const AdminParcelApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminParcelApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Will return the parcel for an order, this will include the protected shipping label link
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelOrderOrderIdGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminParcelOrderOrderIdGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update the shipment status of the parcel
         * @param {string} parcelId
         * @param {AdminParcelsParcelIdPatchRequest} [adminParcelsParcelIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsParcelIdPatch(parcelId, adminParcelsParcelIdPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminParcelsParcelIdPatch(parcelId, adminParcelsParcelIdPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminParcelApi - factory interface
 * @export
 */
export const AdminParcelApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminParcelApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Will return the parcel for an order, this will include the protected shipping label link
         * @param {AdminParcelApiAdminParcelOrderOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelOrderOrderIdGet(requestParameters, options) {
            return localVarFp.adminParcelOrderOrderIdGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update the shipment status of the parcel
         * @param {AdminParcelApiAdminParcelsParcelIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsParcelIdPatch(requestParameters, options) {
            return localVarFp.adminParcelsParcelIdPatch(requestParameters.parcelId, requestParameters.adminParcelsParcelIdPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminParcelApi - object-oriented interface
 * @export
 * @class AdminParcelApi
 * @extends {BaseAPI}
 */
export class AdminParcelApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Will return the parcel for an order, this will include the protected shipping label link
     * @param {AdminParcelApiAdminParcelOrderOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminParcelApi
     */
    adminParcelOrderOrderIdGet(requestParameters, options) {
        return AdminParcelApiFp(this.configuration).adminParcelOrderOrderIdGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update the shipment status of the parcel
     * @param {AdminParcelApiAdminParcelsParcelIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminParcelApi
     */
    adminParcelsParcelIdPatch(requestParameters, options) {
        return AdminParcelApiFp(this.configuration).adminParcelsParcelIdPatch(requestParameters.parcelId, requestParameters.adminParcelsParcelIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminParcelTypesApi - axios parameter creator
 * @export
 */
export const AdminParcelTypesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin]  Get a list of all parcel types
         * @param {string} [orderIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesGet: (orderIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/parcels/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (orderIds !== undefined) {
                localVarQueryParameter['orderIds'] = orderIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [ShippingAdmin]  Deletes a parcel type by id
         * @param {string} id The id of the parcel type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminParcelsTypesIdDelete', 'id', id);
            const localVarPath = `/admin/parcels/types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin]  Get a parcel type by id
         * @param {string} id The id of the parcel type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminParcelsTypesIdGet', 'id', id);
            const localVarPath = `/admin/parcels/types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [ShippingAdmin] Create a link between a parcel type and a product type
         * @param {string} parcelTypeId The id of the parcel type
         * @param {string} productTypeId The id of the product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost: (parcelTypeId, productTypeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'parcelTypeId' is not null or undefined
            assertParamExists('adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost', 'parcelTypeId', parcelTypeId);
            // verify required parameter 'productTypeId' is not null or undefined
            assertParamExists('adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost', 'productTypeId', productTypeId);
            const localVarPath = `/admin/parcels/types/{parcelTypeId}/product-types/{productTypeId}`
                .replace(`{${"parcelTypeId"}}`, encodeURIComponent(String(parcelTypeId)))
                .replace(`{${"productTypeId"}}`, encodeURIComponent(String(productTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [ShippingAdmin]  Add a ParcelType to the ParcelTypes table
         * @param {AdminParcelsTypesPostRequest} [adminParcelsTypesPostRequest] The ParcelType object with all parcel fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesPost: (adminParcelsTypesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/parcels/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminParcelsTypesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Search for parcel types on name, returns a PaginatedList of parcel types
         * @param {string} [searchTerm]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesSearchGet: (searchTerm, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/parcels/types/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminParcelTypesApi - functional programming interface
 * @export
 */
export const AdminParcelTypesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminParcelTypesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin]  Get a list of all parcel types
         * @param {string} [orderIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesGet(orderIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminParcelsTypesGet(orderIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [ShippingAdmin]  Deletes a parcel type by id
         * @param {string} id The id of the parcel type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminParcelsTypesIdDelete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin]  Get a parcel type by id
         * @param {string} id The id of the parcel type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminParcelsTypesIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [ShippingAdmin] Create a link between a parcel type and a product type
         * @param {string} parcelTypeId The id of the parcel type
         * @param {string} productTypeId The id of the product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(parcelTypeId, productTypeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(parcelTypeId, productTypeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [ShippingAdmin]  Add a ParcelType to the ParcelTypes table
         * @param {AdminParcelsTypesPostRequest} [adminParcelsTypesPostRequest] The ParcelType object with all parcel fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesPost(adminParcelsTypesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminParcelsTypesPost(adminParcelsTypesPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Search for parcel types on name, returns a PaginatedList of parcel types
         * @param {string} [searchTerm]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesSearchGet(searchTerm, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminParcelsTypesSearchGet(searchTerm, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminParcelTypesApi - factory interface
 * @export
 */
export const AdminParcelTypesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminParcelTypesApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin]  Get a list of all parcel types
         * @param {AdminParcelTypesApiAdminParcelsTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesGet(requestParameters = {}, options) {
            return localVarFp.adminParcelsTypesGet(requestParameters.orderIds, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [ShippingAdmin]  Deletes a parcel type by id
         * @param {AdminParcelTypesApiAdminParcelsTypesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdDelete(requestParameters, options) {
            return localVarFp.adminParcelsTypesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin]  Get a parcel type by id
         * @param {AdminParcelTypesApiAdminParcelsTypesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesIdGet(requestParameters, options) {
            return localVarFp.adminParcelsTypesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [ShippingAdmin] Create a link between a parcel type and a product type
         * @param {AdminParcelTypesApiAdminParcelsTypesParcelTypeIdProductTypesProductTypeIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(requestParameters, options) {
            return localVarFp.adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(requestParameters.parcelTypeId, requestParameters.productTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [ShippingAdmin]  Add a ParcelType to the ParcelTypes table
         * @param {AdminParcelTypesApiAdminParcelsTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesPost(requestParameters = {}, options) {
            return localVarFp.adminParcelsTypesPost(requestParameters.adminParcelsTypesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Search for parcel types on name, returns a PaginatedList of parcel types
         * @param {AdminParcelTypesApiAdminParcelsTypesSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminParcelsTypesSearchGet(requestParameters = {}, options) {
            return localVarFp.adminParcelsTypesSearchGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminParcelTypesApi - object-oriented interface
 * @export
 * @class AdminParcelTypesApi
 * @extends {BaseAPI}
 */
export class AdminParcelTypesApi extends BaseAPI {
    /**
     *
     * @summary [Admin]  Get a list of all parcel types
     * @param {AdminParcelTypesApiAdminParcelsTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminParcelTypesApi
     */
    adminParcelsTypesGet(requestParameters = {}, options) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesGet(requestParameters.orderIds, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [ShippingAdmin]  Deletes a parcel type by id
     * @param {AdminParcelTypesApiAdminParcelsTypesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminParcelTypesApi
     */
    adminParcelsTypesIdDelete(requestParameters, options) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin]  Get a parcel type by id
     * @param {AdminParcelTypesApiAdminParcelsTypesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminParcelTypesApi
     */
    adminParcelsTypesIdGet(requestParameters, options) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [ShippingAdmin] Create a link between a parcel type and a product type
     * @param {AdminParcelTypesApiAdminParcelsTypesParcelTypeIdProductTypesProductTypeIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminParcelTypesApi
     */
    adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(requestParameters, options) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesParcelTypeIdProductTypesProductTypeIdPost(requestParameters.parcelTypeId, requestParameters.productTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [ShippingAdmin]  Add a ParcelType to the ParcelTypes table
     * @param {AdminParcelTypesApiAdminParcelsTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminParcelTypesApi
     */
    adminParcelsTypesPost(requestParameters = {}, options) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesPost(requestParameters.adminParcelsTypesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Search for parcel types on name, returns a PaginatedList of parcel types
     * @param {AdminParcelTypesApiAdminParcelsTypesSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminParcelTypesApi
     */
    adminParcelsTypesSearchGet(requestParameters = {}, options) {
        return AdminParcelTypesApiFp(this.configuration).adminParcelsTypesSearchGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminPartnerDocumentsApi - axios parameter creator
 * @export
 */
export const AdminPartnerDocumentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} partnerId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsDocumentIdDelete: (partnerId, documentId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdDocumentsDocumentIdDelete', 'partnerId', partnerId);
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdDocumentsDocumentIdDelete', 'documentId', documentId);
            const localVarPath = `/admin/partners/{partnerId}/documents/{documentId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsGet: (partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdDocumentsGet', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}/documents`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdDocumentsPostRequest} [adminPartnersPartnerIdDocumentsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsPost: (partnerId, adminPartnersPartnerIdDocumentsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdDocumentsPost', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}/documents`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminPartnersPartnerIdDocumentsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminPartnerDocumentsApi - functional programming interface
 * @export
 */
export const AdminPartnerDocumentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminPartnerDocumentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} partnerId
         * @param {string} documentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsDocumentIdDelete(partnerId, documentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdDocumentsDocumentIdDelete(partnerId, documentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsGet(partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdDocumentsGet(partnerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdDocumentsPostRequest} [adminPartnersPartnerIdDocumentsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsPost(partnerId, adminPartnersPartnerIdDocumentsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdDocumentsPost(partnerId, adminPartnersPartnerIdDocumentsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminPartnerDocumentsApi - factory interface
 * @export
 */
export const AdminPartnerDocumentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminPartnerDocumentsApiFp(configuration);
    return {
        /**
         *
         * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsDocumentIdDelete(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdDocumentsDocumentIdDelete(requestParameters.partnerId, requestParameters.documentId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsGet(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdDocumentsGet(requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdDocumentsPost(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdDocumentsPost(requestParameters.partnerId, requestParameters.adminPartnersPartnerIdDocumentsPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminPartnerDocumentsApi - object-oriented interface
 * @export
 * @class AdminPartnerDocumentsApi
 * @extends {BaseAPI}
 */
export class AdminPartnerDocumentsApi extends BaseAPI {
    /**
     *
     * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsDocumentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerDocumentsApi
     */
    adminPartnersPartnerIdDocumentsDocumentIdDelete(requestParameters, options) {
        return AdminPartnerDocumentsApiFp(this.configuration).adminPartnersPartnerIdDocumentsDocumentIdDelete(requestParameters.partnerId, requestParameters.documentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerDocumentsApi
     */
    adminPartnersPartnerIdDocumentsGet(requestParameters, options) {
        return AdminPartnerDocumentsApiFp(this.configuration).adminPartnersPartnerIdDocumentsGet(requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminPartnerDocumentsApiAdminPartnersPartnerIdDocumentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerDocumentsApi
     */
    adminPartnersPartnerIdDocumentsPost(requestParameters, options) {
        return AdminPartnerDocumentsApiFp(this.configuration).adminPartnersPartnerIdDocumentsPost(requestParameters.partnerId, requestParameters.adminPartnersPartnerIdDocumentsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminPartnerPickupAddressApi - axios parameter creator
 * @export
 */
export const AdminPartnerPickupAddressApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get partner pick up address by ID
         * @param {number} addressId
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdGet: (addressId, partnerId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressAddressIdGet', 'addressId', addressId);
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressAddressIdGet', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}/pickup-address/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)))
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update a partner pick up address
         * @param {number} addressId
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdPickupAddressAddressIdPutRequest} [adminPartnersPartnerIdPickupAddressAddressIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdPut: (addressId, partnerId, adminPartnersPartnerIdPickupAddressAddressIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressAddressIdPut', 'addressId', addressId);
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressAddressIdPut', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}/pickup-address/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)))
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminPartnersPartnerIdPickupAddressAddressIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get all partner pick up addresses
         * @param {string} partnerId
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressGet: (partnerId, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressGet', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}/pickup-address`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create a partner pick up address
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdPickupAddressPostRequest} [adminPartnersPartnerIdPickupAddressPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressPost: (partnerId, adminPartnersPartnerIdPickupAddressPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPickupAddressPost', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}/pickup-address`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminPartnersPartnerIdPickupAddressPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get partner pickup address states
         * @param {string} [countryCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPickupAddressStatesGet: (countryCode, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/partners/pickup-address/states`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (countryCode !== undefined) {
                localVarQueryParameter['countryCode'] = countryCode;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminPartnerPickupAddressApi - functional programming interface
 * @export
 */
export const AdminPartnerPickupAddressApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminPartnerPickupAddressApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get partner pick up address by ID
         * @param {number} addressId
         * @param {string} partnerId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdGet(addressId, partnerId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdPickupAddressAddressIdGet(addressId, partnerId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update a partner pick up address
         * @param {number} addressId
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdPickupAddressAddressIdPutRequest} [adminPartnersPartnerIdPickupAddressAddressIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdPut(addressId, partnerId, adminPartnersPartnerIdPickupAddressAddressIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdPickupAddressAddressIdPut(addressId, partnerId, adminPartnersPartnerIdPickupAddressAddressIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get all partner pick up addresses
         * @param {string} partnerId
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressGet(partnerId, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdPickupAddressGet(partnerId, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create a partner pick up address
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdPickupAddressPostRequest} [adminPartnersPartnerIdPickupAddressPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressPost(partnerId, adminPartnersPartnerIdPickupAddressPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdPickupAddressPost(partnerId, adminPartnersPartnerIdPickupAddressPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get partner pickup address states
         * @param {string} [countryCode]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPickupAddressStatesGet(countryCode, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPickupAddressStatesGet(countryCode, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminPartnerPickupAddressApi - factory interface
 * @export
 */
export const AdminPartnerPickupAddressApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminPartnerPickupAddressApiFp(configuration);
    return {
        /**
         *
         * @summary Get partner pick up address by ID
         * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdGet(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdPickupAddressAddressIdGet(requestParameters.addressId, requestParameters.partnerId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update a partner pick up address
         * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressAddressIdPut(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdPickupAddressAddressIdPut(requestParameters.addressId, requestParameters.partnerId, requestParameters.adminPartnersPartnerIdPickupAddressAddressIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get all partner pick up addresses
         * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressGet(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdPickupAddressGet(requestParameters.partnerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create a partner pick up address
         * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPickupAddressPost(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdPickupAddressPost(requestParameters.partnerId, requestParameters.adminPartnersPartnerIdPickupAddressPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get partner pickup address states
         * @param {AdminPartnerPickupAddressApiAdminPartnersPickupAddressStatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPickupAddressStatesGet(requestParameters = {}, options) {
            return localVarFp.adminPartnersPickupAddressStatesGet(requestParameters.countryCode, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminPartnerPickupAddressApi - object-oriented interface
 * @export
 * @class AdminPartnerPickupAddressApi
 * @extends {BaseAPI}
 */
export class AdminPartnerPickupAddressApi extends BaseAPI {
    /**
     *
     * @summary Get partner pick up address by ID
     * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerPickupAddressApi
     */
    adminPartnersPartnerIdPickupAddressAddressIdGet(requestParameters, options) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPartnerIdPickupAddressAddressIdGet(requestParameters.addressId, requestParameters.partnerId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update a partner pick up address
     * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressAddressIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerPickupAddressApi
     */
    adminPartnersPartnerIdPickupAddressAddressIdPut(requestParameters, options) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPartnerIdPickupAddressAddressIdPut(requestParameters.addressId, requestParameters.partnerId, requestParameters.adminPartnersPartnerIdPickupAddressAddressIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get all partner pick up addresses
     * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerPickupAddressApi
     */
    adminPartnersPartnerIdPickupAddressGet(requestParameters, options) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPartnerIdPickupAddressGet(requestParameters.partnerId, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create a partner pick up address
     * @param {AdminPartnerPickupAddressApiAdminPartnersPartnerIdPickupAddressPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerPickupAddressApi
     */
    adminPartnersPartnerIdPickupAddressPost(requestParameters, options) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPartnerIdPickupAddressPost(requestParameters.partnerId, requestParameters.adminPartnersPartnerIdPickupAddressPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get partner pickup address states
     * @param {AdminPartnerPickupAddressApiAdminPartnersPickupAddressStatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnerPickupAddressApi
     */
    adminPartnersPickupAddressStatesGet(requestParameters = {}, options) {
        return AdminPartnerPickupAddressApiFp(this.configuration).adminPartnersPickupAddressStatesGet(requestParameters.countryCode, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminPartnersApi - axios parameter creator
 * @export
 */
export const AdminPartnersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] getting partners by contracts Ids
         * @param {string} [contracts]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersContractsGet: (contracts, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/partners/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (contracts !== undefined) {
                localVarQueryParameter['contracts'] = contracts;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Gets a paginated list of partners with the searched name
         * @param {string} [searchTerm]
         * @param {string} [partnerManagerUserId]
         * @param {PartnerRegion} [region]
         * @param {ContractType} [contractType]
         * @param {boolean} [isActive]
         * @param {'StartDate' | 'EndDate'} [sortBy]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersGet: (searchTerm, partnerManagerUserId, region, contractType, isActive, sortBy, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (partnerManagerUserId !== undefined) {
                localVarQueryParameter['partnerManagerUserId'] = partnerManagerUserId;
            }
            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }
            if (contractType !== undefined) {
                localVarQueryParameter['contractType'] = contractType;
            }
            if (isActive !== undefined) {
                localVarQueryParameter['isActive'] = isActive;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Delete a partner
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPartnersIdDelete', 'id', id);
            const localVarPath = `/admin/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get partner with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminPartnersIdGet', 'id', id);
            const localVarPath = `/admin/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Gets all the partners with the given ids list
         * @param {string} [partners]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersListGet: (partners, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/partners/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (partners !== undefined) {
                localVarQueryParameter['partners'] = partners;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] create or update customer of partner
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdCustomerPutRequest} [adminPartnersPartnerIdCustomerPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdCustomerPut: (partnerId, adminPartnersPartnerIdCustomerPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdCustomerPut', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}/customer`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminPartnersPartnerIdCustomerPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update the partner
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdPatchRequest} [adminPartnersPartnerIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPatch: (partnerId, adminPartnersPartnerIdPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdPatch', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminPartnersPartnerIdPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get Vendors Under Partners
         * @param {string} partnerId
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {boolean} [includeGlobalVendors]
         * @param {string} [searchTerm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdVendorsGet: (partnerId, offSet, pageSize, includeGlobalVendors, searchTerm, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'partnerId' is not null or undefined
            assertParamExists('adminPartnersPartnerIdVendorsGet', 'partnerId', partnerId);
            const localVarPath = `/admin/partners/{partnerId}/vendors`
                .replace(`{${"partnerId"}}`, encodeURIComponent(String(partnerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (includeGlobalVendors !== undefined) {
                localVarQueryParameter['includeGlobalVendors'] = includeGlobalVendors;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Create a partner
         * @param {AdminPartnersPostRequest} [adminPartnersPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPost: (adminPartnersPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminPartnersPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminPartnersApi - functional programming interface
 * @export
 */
export const AdminPartnersApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminPartnersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] getting partners by contracts Ids
         * @param {string} [contracts]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersContractsGet(contracts, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersContractsGet(contracts, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Gets a paginated list of partners with the searched name
         * @param {string} [searchTerm]
         * @param {string} [partnerManagerUserId]
         * @param {PartnerRegion} [region]
         * @param {ContractType} [contractType]
         * @param {boolean} [isActive]
         * @param {'StartDate' | 'EndDate'} [sortBy]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersGet(searchTerm, partnerManagerUserId, region, contractType, isActive, sortBy, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersGet(searchTerm, partnerManagerUserId, region, contractType, isActive, sortBy, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Delete a partner
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersIdDelete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get partner with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Gets all the partners with the given ids list
         * @param {string} [partners]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersListGet(partners, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersListGet(partners, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] create or update customer of partner
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdCustomerPutRequest} [adminPartnersPartnerIdCustomerPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdCustomerPut(partnerId, adminPartnersPartnerIdCustomerPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdCustomerPut(partnerId, adminPartnersPartnerIdCustomerPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update the partner
         * @param {string} partnerId
         * @param {AdminPartnersPartnerIdPatchRequest} [adminPartnersPartnerIdPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPatch(partnerId, adminPartnersPartnerIdPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdPatch(partnerId, adminPartnersPartnerIdPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get Vendors Under Partners
         * @param {string} partnerId
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {boolean} [includeGlobalVendors]
         * @param {string} [searchTerm]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdVendorsGet(partnerId, offSet, pageSize, includeGlobalVendors, searchTerm, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPartnerIdVendorsGet(partnerId, offSet, pageSize, includeGlobalVendors, searchTerm, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Create a partner
         * @param {AdminPartnersPostRequest} [adminPartnersPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPost(adminPartnersPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminPartnersPost(adminPartnersPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminPartnersApi - factory interface
 * @export
 */
export const AdminPartnersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminPartnersApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] getting partners by contracts Ids
         * @param {AdminPartnersApiAdminPartnersContractsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersContractsGet(requestParameters = {}, options) {
            return localVarFp.adminPartnersContractsGet(requestParameters.contracts, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Gets a paginated list of partners with the searched name
         * @param {AdminPartnersApiAdminPartnersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersGet(requestParameters = {}, options) {
            return localVarFp.adminPartnersGet(requestParameters.searchTerm, requestParameters.partnerManagerUserId, requestParameters.region, requestParameters.contractType, requestParameters.isActive, requestParameters.sortBy, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Delete a partner
         * @param {AdminPartnersApiAdminPartnersIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdDelete(requestParameters, options) {
            return localVarFp.adminPartnersIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get partner with Id
         * @param {AdminPartnersApiAdminPartnersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersIdGet(requestParameters, options) {
            return localVarFp.adminPartnersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Gets all the partners with the given ids list
         * @param {AdminPartnersApiAdminPartnersListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersListGet(requestParameters = {}, options) {
            return localVarFp.adminPartnersListGet(requestParameters.partners, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] create or update customer of partner
         * @param {AdminPartnersApiAdminPartnersPartnerIdCustomerPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdCustomerPut(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdCustomerPut(requestParameters.partnerId, requestParameters.adminPartnersPartnerIdCustomerPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update the partner
         * @param {AdminPartnersApiAdminPartnersPartnerIdPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdPatch(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdPatch(requestParameters.partnerId, requestParameters.adminPartnersPartnerIdPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get Vendors Under Partners
         * @param {AdminPartnersApiAdminPartnersPartnerIdVendorsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPartnerIdVendorsGet(requestParameters, options) {
            return localVarFp.adminPartnersPartnerIdVendorsGet(requestParameters.partnerId, requestParameters.offSet, requestParameters.pageSize, requestParameters.includeGlobalVendors, requestParameters.searchTerm, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Create a partner
         * @param {AdminPartnersApiAdminPartnersPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminPartnersPost(requestParameters = {}, options) {
            return localVarFp.adminPartnersPost(requestParameters.adminPartnersPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminPartnersApi - object-oriented interface
 * @export
 * @class AdminPartnersApi
 * @extends {BaseAPI}
 */
export class AdminPartnersApi extends BaseAPI {
    /**
     *
     * @summary [Admin] getting partners by contracts Ids
     * @param {AdminPartnersApiAdminPartnersContractsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnersApi
     */
    adminPartnersContractsGet(requestParameters = {}, options) {
        return AdminPartnersApiFp(this.configuration).adminPartnersContractsGet(requestParameters.contracts, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Gets a paginated list of partners with the searched name
     * @param {AdminPartnersApiAdminPartnersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnersApi
     */
    adminPartnersGet(requestParameters = {}, options) {
        return AdminPartnersApiFp(this.configuration).adminPartnersGet(requestParameters.searchTerm, requestParameters.partnerManagerUserId, requestParameters.region, requestParameters.contractType, requestParameters.isActive, requestParameters.sortBy, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Delete a partner
     * @param {AdminPartnersApiAdminPartnersIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnersApi
     */
    adminPartnersIdDelete(requestParameters, options) {
        return AdminPartnersApiFp(this.configuration).adminPartnersIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get partner with Id
     * @param {AdminPartnersApiAdminPartnersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnersApi
     */
    adminPartnersIdGet(requestParameters, options) {
        return AdminPartnersApiFp(this.configuration).adminPartnersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Gets all the partners with the given ids list
     * @param {AdminPartnersApiAdminPartnersListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnersApi
     */
    adminPartnersListGet(requestParameters = {}, options) {
        return AdminPartnersApiFp(this.configuration).adminPartnersListGet(requestParameters.partners, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] create or update customer of partner
     * @param {AdminPartnersApiAdminPartnersPartnerIdCustomerPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnersApi
     */
    adminPartnersPartnerIdCustomerPut(requestParameters, options) {
        return AdminPartnersApiFp(this.configuration).adminPartnersPartnerIdCustomerPut(requestParameters.partnerId, requestParameters.adminPartnersPartnerIdCustomerPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update the partner
     * @param {AdminPartnersApiAdminPartnersPartnerIdPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnersApi
     */
    adminPartnersPartnerIdPatch(requestParameters, options) {
        return AdminPartnersApiFp(this.configuration).adminPartnersPartnerIdPatch(requestParameters.partnerId, requestParameters.adminPartnersPartnerIdPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get Vendors Under Partners
     * @param {AdminPartnersApiAdminPartnersPartnerIdVendorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnersApi
     */
    adminPartnersPartnerIdVendorsGet(requestParameters, options) {
        return AdminPartnersApiFp(this.configuration).adminPartnersPartnerIdVendorsGet(requestParameters.partnerId, requestParameters.offSet, requestParameters.pageSize, requestParameters.includeGlobalVendors, requestParameters.searchTerm, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Create a partner
     * @param {AdminPartnersApiAdminPartnersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPartnersApi
     */
    adminPartnersPost(requestParameters = {}, options) {
        return AdminPartnersApiFp(this.configuration).adminPartnersPost(requestParameters.adminPartnersPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminPickListsApi - axios parameter creator
 * @export
 */
export const AdminPickListsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [shippingOfficeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersPickListsPaidNotShippedGet: (shippingOfficeId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/orders/pick-lists/paid-not-shipped`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shippingOfficeId'] = shippingOfficeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} pickListType
         * @param {string} [shippingOfficeId]
         * @param {string} [eventId]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {Date} [paidBefore]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersPickListsPickListTypeGet: (pickListType, shippingOfficeId, eventId, pageSize, offset, paidBefore, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'pickListType' is not null or undefined
            assertParamExists('adminOrdersPickListsPickListTypeGet', 'pickListType', pickListType);
            const localVarPath = `/admin/orders/pick-lists/{pickListType}`
                .replace(`{${"pickListType"}}`, encodeURIComponent(String(pickListType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['ShippingOfficeId'] = shippingOfficeId;
            }
            if (eventId !== undefined) {
                localVarQueryParameter['EventId'] = eventId;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (paidBefore !== undefined) {
                localVarQueryParameter['PaidBefore'] = (paidBefore instanceof Date) ?
                    paidBefore.toISOString() :
                    paidBefore;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminPickListsApi - functional programming interface
 * @export
 */
export const AdminPickListsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminPickListsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {string} [shippingOfficeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersPickListsPaidNotShippedGet(shippingOfficeId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersPickListsPaidNotShippedGet(shippingOfficeId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} pickListType
         * @param {string} [shippingOfficeId]
         * @param {string} [eventId]
         * @param {number} [pageSize]
         * @param {number} [offset]
         * @param {Date} [paidBefore]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersPickListsPickListTypeGet(pickListType, shippingOfficeId, eventId, pageSize, offset, paidBefore, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOrdersPickListsPickListTypeGet(pickListType, shippingOfficeId, eventId, pageSize, offset, paidBefore, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminPickListsApi - factory interface
 * @export
 */
export const AdminPickListsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminPickListsApiFp(configuration);
    return {
        /**
         *
         * @param {AdminPickListsApiAdminOrdersPickListsPaidNotShippedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersPickListsPaidNotShippedGet(requestParameters = {}, options) {
            return localVarFp.adminOrdersPickListsPaidNotShippedGet(requestParameters.shippingOfficeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AdminPickListsApiAdminOrdersPickListsPickListTypeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOrdersPickListsPickListTypeGet(requestParameters, options) {
            return localVarFp.adminOrdersPickListsPickListTypeGet(requestParameters.pickListType, requestParameters.shippingOfficeId, requestParameters.eventId, requestParameters.pageSize, requestParameters.offset, requestParameters.paidBefore, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminPickListsApi - object-oriented interface
 * @export
 * @class AdminPickListsApi
 * @extends {BaseAPI}
 */
export class AdminPickListsApi extends BaseAPI {
    /**
     *
     * @param {AdminPickListsApiAdminOrdersPickListsPaidNotShippedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPickListsApi
     */
    adminOrdersPickListsPaidNotShippedGet(requestParameters = {}, options) {
        return AdminPickListsApiFp(this.configuration).adminOrdersPickListsPaidNotShippedGet(requestParameters.shippingOfficeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AdminPickListsApiAdminOrdersPickListsPickListTypeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPickListsApi
     */
    adminOrdersPickListsPickListTypeGet(requestParameters, options) {
        return AdminPickListsApiFp(this.configuration).adminOrdersPickListsPickListTypeGet(requestParameters.pickListType, requestParameters.shippingOfficeId, requestParameters.eventId, requestParameters.pageSize, requestParameters.offset, requestParameters.paidBefore, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminPickupsApi - axios parameter creator
 * @export
 */
export const AdminPickupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] By default this endpoint returns all future pickups in a PaginatedList.
         * @param {string} [shippingOfficeId]
         * @param {boolean} [all] optional boolean argument that if true returns all of the pickups sorted by date descending. Enables pagination
         * @param {number} [offset] optional offset for pagination. Default 0
         * @param {number} [pageSize] optional page size for pagination. Default 25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsGet: (shippingOfficeId, all, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/pickups`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shippingOfficeId'] = shippingOfficeId;
            }
            if (all !== undefined) {
                localVarQueryParameter['all'] = all;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] This endpoint deletes a pickup
         * @param {string} id The id of the pickup that needs deleting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pickupsIdDelete', 'id', id);
            const localVarPath = `/pickups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminPickupsApi - functional programming interface
 * @export
 */
export const AdminPickupsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminPickupsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] By default this endpoint returns all future pickups in a PaginatedList.
         * @param {string} [shippingOfficeId]
         * @param {boolean} [all] optional boolean argument that if true returns all of the pickups sorted by date descending. Enables pagination
         * @param {number} [offset] optional offset for pagination. Default 0
         * @param {number} [pageSize] optional page size for pagination. Default 25
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsGet(shippingOfficeId, all, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pickupsGet(shippingOfficeId, all, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] This endpoint deletes a pickup
         * @param {string} id The id of the pickup that needs deleting
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.pickupsIdDelete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminPickupsApi - factory interface
 * @export
 */
export const AdminPickupsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminPickupsApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] By default this endpoint returns all future pickups in a PaginatedList.
         * @param {AdminPickupsApiPickupsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsGet(requestParameters = {}, options) {
            return localVarFp.pickupsGet(requestParameters.shippingOfficeId, requestParameters.all, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] This endpoint deletes a pickup
         * @param {AdminPickupsApiPickupsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pickupsIdDelete(requestParameters, options) {
            return localVarFp.pickupsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminPickupsApi - object-oriented interface
 * @export
 * @class AdminPickupsApi
 * @extends {BaseAPI}
 */
export class AdminPickupsApi extends BaseAPI {
    /**
     *
     * @summary [Admin] By default this endpoint returns all future pickups in a PaginatedList.
     * @param {AdminPickupsApiPickupsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPickupsApi
     */
    pickupsGet(requestParameters = {}, options) {
        return AdminPickupsApiFp(this.configuration).pickupsGet(requestParameters.shippingOfficeId, requestParameters.all, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] This endpoint deletes a pickup
     * @param {AdminPickupsApiPickupsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminPickupsApi
     */
    pickupsIdDelete(requestParameters, options) {
        return AdminPickupsApiFp(this.configuration).pickupsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminProductTypesApi - axios parameter creator
 * @export
 */
export const AdminProductTypesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Get all product type conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesConditionsGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/products/types/conditions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get all product types
         * @param {string} [includedProductTypeId]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {boolean} [includeInactive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesGet: (includedProductTypeId, offset, pageSize, includeInactive, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/products/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (includedProductTypeId !== undefined) {
                localVarQueryParameter['includedProductTypeId'] = includedProductTypeId;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (includeInactive !== undefined) {
                localVarQueryParameter['includeInactive'] = includeInactive;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin]  Get a product type by id
         * @param {string} id The id of the product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminProductsTypesIdGet', 'id', id);
            const localVarPath = `/admin/products/types/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin and ProductManager] Update a product type
         * @param {AdminProductsTypesPatchRequest} [adminProductsTypesPatchRequest] The request that contains the fields of the updated product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPatch: (adminProductsTypesPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/products/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminProductsTypesPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin and ProductManager] Create a product type
         * @param {AdminProductsTypesPostRequest} [adminProductsTypesPostRequest] The request that contains the fields of the new product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPost: (adminProductsTypesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/products/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminProductsTypesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminProductTypesApi - functional programming interface
 * @export
 */
export const AdminProductTypesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminProductTypesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Get all product type conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesConditionsGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminProductsTypesConditionsGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get all product types
         * @param {string} [includedProductTypeId]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {boolean} [includeInactive]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesGet(includedProductTypeId, offset, pageSize, includeInactive, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminProductsTypesGet(includedProductTypeId, offset, pageSize, includeInactive, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin]  Get a product type by id
         * @param {string} id The id of the product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminProductsTypesIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin and ProductManager] Update a product type
         * @param {AdminProductsTypesPatchRequest} [adminProductsTypesPatchRequest] The request that contains the fields of the updated product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPatch(adminProductsTypesPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminProductsTypesPatch(adminProductsTypesPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin and ProductManager] Create a product type
         * @param {AdminProductsTypesPostRequest} [adminProductsTypesPostRequest] The request that contains the fields of the new product type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPost(adminProductsTypesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminProductsTypesPost(adminProductsTypesPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminProductTypesApi - factory interface
 * @export
 */
export const AdminProductTypesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminProductTypesApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Get all product type conditions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesConditionsGet(options) {
            return localVarFp.adminProductsTypesConditionsGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get all product types
         * @param {AdminProductTypesApiAdminProductsTypesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesGet(requestParameters = {}, options) {
            return localVarFp.adminProductsTypesGet(requestParameters.includedProductTypeId, requestParameters.offset, requestParameters.pageSize, requestParameters.includeInactive, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin]  Get a product type by id
         * @param {AdminProductTypesApiAdminProductsTypesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesIdGet(requestParameters, options) {
            return localVarFp.adminProductsTypesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin and ProductManager] Update a product type
         * @param {AdminProductTypesApiAdminProductsTypesPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPatch(requestParameters = {}, options) {
            return localVarFp.adminProductsTypesPatch(requestParameters.adminProductsTypesPatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin and ProductManager] Create a product type
         * @param {AdminProductTypesApiAdminProductsTypesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminProductsTypesPost(requestParameters = {}, options) {
            return localVarFp.adminProductsTypesPost(requestParameters.adminProductsTypesPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminProductTypesApi - object-oriented interface
 * @export
 * @class AdminProductTypesApi
 * @extends {BaseAPI}
 */
export class AdminProductTypesApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Get all product type conditions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductTypesApi
     */
    adminProductsTypesConditionsGet(options) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesConditionsGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get all product types
     * @param {AdminProductTypesApiAdminProductsTypesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductTypesApi
     */
    adminProductsTypesGet(requestParameters = {}, options) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesGet(requestParameters.includedProductTypeId, requestParameters.offset, requestParameters.pageSize, requestParameters.includeInactive, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin]  Get a product type by id
     * @param {AdminProductTypesApiAdminProductsTypesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductTypesApi
     */
    adminProductsTypesIdGet(requestParameters, options) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin and ProductManager] Update a product type
     * @param {AdminProductTypesApiAdminProductsTypesPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductTypesApi
     */
    adminProductsTypesPatch(requestParameters = {}, options) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesPatch(requestParameters.adminProductsTypesPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin and ProductManager] Create a product type
     * @param {AdminProductTypesApiAdminProductsTypesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminProductTypesApi
     */
    adminProductsTypesPost(requestParameters = {}, options) {
        return AdminProductTypesApiFp(this.configuration).adminProductsTypesPost(requestParameters.adminProductsTypesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminSeasonalFinancialReportsApi - axios parameter creator
 * @export
 */
export const AdminSeasonalFinancialReportsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Generate a season financial report for a contract
         * @param {string} contractId
         * @param {AdminSeasonFinancialReportsContractContractIdPostRequest} [adminSeasonFinancialReportsContractContractIdPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSeasonFinancialReportsContractContractIdPost: (contractId, adminSeasonFinancialReportsContractContractIdPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'contractId' is not null or undefined
            assertParamExists('adminSeasonFinancialReportsContractContractIdPost', 'contractId', contractId);
            const localVarPath = `/admin/season-financial-reports/contract/{contractId}`
                .replace(`{${"contractId"}}`, encodeURIComponent(String(contractId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminSeasonFinancialReportsContractContractIdPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminSeasonalFinancialReportsApi - functional programming interface
 * @export
 */
export const AdminSeasonalFinancialReportsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminSeasonalFinancialReportsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Generate a season financial report for a contract
         * @param {string} contractId
         * @param {AdminSeasonFinancialReportsContractContractIdPostRequest} [adminSeasonFinancialReportsContractContractIdPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSeasonFinancialReportsContractContractIdPost(contractId, adminSeasonFinancialReportsContractContractIdPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminSeasonFinancialReportsContractContractIdPost(contractId, adminSeasonFinancialReportsContractContractIdPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminSeasonalFinancialReportsApi - factory interface
 * @export
 */
export const AdminSeasonalFinancialReportsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminSeasonalFinancialReportsApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Generate a season financial report for a contract
         * @param {AdminSeasonalFinancialReportsApiAdminSeasonFinancialReportsContractContractIdPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSeasonFinancialReportsContractContractIdPost(requestParameters, options) {
            return localVarFp.adminSeasonFinancialReportsContractContractIdPost(requestParameters.contractId, requestParameters.adminSeasonFinancialReportsContractContractIdPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminSeasonalFinancialReportsApi - object-oriented interface
 * @export
 * @class AdminSeasonalFinancialReportsApi
 * @extends {BaseAPI}
 */
export class AdminSeasonalFinancialReportsApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Generate a season financial report for a contract
     * @param {AdminSeasonalFinancialReportsApiAdminSeasonFinancialReportsContractContractIdPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminSeasonalFinancialReportsApi
     */
    adminSeasonFinancialReportsContractContractIdPost(requestParameters, options) {
        return AdminSeasonalFinancialReportsApiFp(this.configuration).adminSeasonFinancialReportsContractContractIdPost(requestParameters.contractId, requestParameters.adminSeasonFinancialReportsContractContractIdPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminShipmentsApi - axios parameter creator
 * @export
 */
export const AdminShipmentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] This endpoint creates a shipment
         * @param {AdminShipmentsPostRequest} [adminShipmentsPostRequest] The request object that contains all required values for a shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsPost: (adminShipmentsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/shipments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminShipmentsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get shipping rates for hypothetical shipment
         * @param {string} [userId]
         * @param {string} [orderId]
         * @param {string} [shippingOfficeId]
         * @param {string} [parcelTypeId]
         * @param {number} [parcelHeight]
         * @param {number} [parcelWidth]
         * @param {number} [parcelDepth]
         * @param {number} [parcelWeight]
         * @param {Date} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsRatesGet: (userId, orderId, shippingOfficeId, parcelTypeId, parcelHeight, parcelWidth, parcelDepth, parcelWeight, date, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/shipments/rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shippingOfficeId'] = shippingOfficeId;
            }
            if (parcelTypeId !== undefined) {
                localVarQueryParameter['parcelTypeId'] = parcelTypeId;
            }
            if (parcelHeight !== undefined) {
                localVarQueryParameter['parcelHeight'] = parcelHeight;
            }
            if (parcelWidth !== undefined) {
                localVarQueryParameter['parcelWidth'] = parcelWidth;
            }
            if (parcelDepth !== undefined) {
                localVarQueryParameter['parcelDepth'] = parcelDepth;
            }
            if (parcelWeight !== undefined) {
                localVarQueryParameter['parcelWeight'] = parcelWeight;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = (date instanceof Date) ?
                    date.toISOString() :
                    date;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminShipmentsApi - functional programming interface
 * @export
 */
export const AdminShipmentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminShipmentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] This endpoint creates a shipment
         * @param {AdminShipmentsPostRequest} [adminShipmentsPostRequest] The request object that contains all required values for a shipment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsPost(adminShipmentsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminShipmentsPost(adminShipmentsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get shipping rates for hypothetical shipment
         * @param {string} [userId]
         * @param {string} [orderId]
         * @param {string} [shippingOfficeId]
         * @param {string} [parcelTypeId]
         * @param {number} [parcelHeight]
         * @param {number} [parcelWidth]
         * @param {number} [parcelDepth]
         * @param {number} [parcelWeight]
         * @param {Date} [date]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsRatesGet(userId, orderId, shippingOfficeId, parcelTypeId, parcelHeight, parcelWidth, parcelDepth, parcelWeight, date, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminShipmentsRatesGet(userId, orderId, shippingOfficeId, parcelTypeId, parcelHeight, parcelWidth, parcelDepth, parcelWeight, date, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminShipmentsApi - factory interface
 * @export
 */
export const AdminShipmentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminShipmentsApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] This endpoint creates a shipment
         * @param {AdminShipmentsApiAdminShipmentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsPost(requestParameters = {}, options) {
            return localVarFp.adminShipmentsPost(requestParameters.adminShipmentsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get shipping rates for hypothetical shipment
         * @param {AdminShipmentsApiAdminShipmentsRatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminShipmentsRatesGet(requestParameters = {}, options) {
            return localVarFp.adminShipmentsRatesGet(requestParameters.userId, requestParameters.orderId, requestParameters.shippingOfficeId, requestParameters.parcelTypeId, requestParameters.parcelHeight, requestParameters.parcelWidth, requestParameters.parcelDepth, requestParameters.parcelWeight, requestParameters.date, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminShipmentsApi - object-oriented interface
 * @export
 * @class AdminShipmentsApi
 * @extends {BaseAPI}
 */
export class AdminShipmentsApi extends BaseAPI {
    /**
     *
     * @summary [Admin] This endpoint creates a shipment
     * @param {AdminShipmentsApiAdminShipmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminShipmentsApi
     */
    adminShipmentsPost(requestParameters = {}, options) {
        return AdminShipmentsApiFp(this.configuration).adminShipmentsPost(requestParameters.adminShipmentsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get shipping rates for hypothetical shipment
     * @param {AdminShipmentsApiAdminShipmentsRatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminShipmentsApi
     */
    adminShipmentsRatesGet(requestParameters = {}, options) {
        return AdminShipmentsApiFp(this.configuration).adminShipmentsRatesGet(requestParameters.userId, requestParameters.orderId, requestParameters.shippingOfficeId, requestParameters.parcelTypeId, requestParameters.parcelHeight, requestParameters.parcelWidth, requestParameters.parcelDepth, requestParameters.parcelWeight, requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminShippingOfficesApi - axios parameter creator
 * @export
 */
export const AdminShippingOfficesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] list shipping offices
         * @param {boolean} [isFtg]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesGet: (isFtg, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (isFtg !== undefined) {
                localVarQueryParameter['isFtg'] = isFtg;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Delete a shipping office
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminOfficesIdDelete', 'id', id);
            const localVarPath = `/admin/offices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get shipping office with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminOfficesIdGet', 'id', id);
            const localVarPath = `/admin/offices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Create a shipping office
         * @param {AdminOfficesPostRequest} [adminOfficesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPost: (adminOfficesPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminOfficesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update the shipping office
         * @param {AdminOfficesPutRequest} [adminOfficesPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPut: (adminOfficesPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminOfficesPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Gets a paginated list of shipping offices with the searched name, or by Id
         * @param {string} [searchTerm]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesSearchGet: (searchTerm, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/offices/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminShippingOfficesApi - functional programming interface
 * @export
 */
export const AdminShippingOfficesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminShippingOfficesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] list shipping offices
         * @param {boolean} [isFtg]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesGet(isFtg, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOfficesGet(isFtg, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Delete a shipping office
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOfficesIdDelete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get shipping office with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOfficesIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Create a shipping office
         * @param {AdminOfficesPostRequest} [adminOfficesPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPost(adminOfficesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOfficesPost(adminOfficesPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update the shipping office
         * @param {AdminOfficesPutRequest} [adminOfficesPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPut(adminOfficesPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOfficesPut(adminOfficesPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Gets a paginated list of shipping offices with the searched name, or by Id
         * @param {string} [searchTerm]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesSearchGet(searchTerm, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminOfficesSearchGet(searchTerm, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminShippingOfficesApi - factory interface
 * @export
 */
export const AdminShippingOfficesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminShippingOfficesApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] list shipping offices
         * @param {AdminShippingOfficesApiAdminOfficesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesGet(requestParameters = {}, options) {
            return localVarFp.adminOfficesGet(requestParameters.isFtg, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Delete a shipping office
         * @param {AdminShippingOfficesApiAdminOfficesIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdDelete(requestParameters, options) {
            return localVarFp.adminOfficesIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get shipping office with Id
         * @param {AdminShippingOfficesApiAdminOfficesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesIdGet(requestParameters, options) {
            return localVarFp.adminOfficesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Create a shipping office
         * @param {AdminShippingOfficesApiAdminOfficesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPost(requestParameters = {}, options) {
            return localVarFp.adminOfficesPost(requestParameters.adminOfficesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update the shipping office
         * @param {AdminShippingOfficesApiAdminOfficesPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesPut(requestParameters = {}, options) {
            return localVarFp.adminOfficesPut(requestParameters.adminOfficesPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Gets a paginated list of shipping offices with the searched name, or by Id
         * @param {AdminShippingOfficesApiAdminOfficesSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminOfficesSearchGet(requestParameters = {}, options) {
            return localVarFp.adminOfficesSearchGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminShippingOfficesApi - object-oriented interface
 * @export
 * @class AdminShippingOfficesApi
 * @extends {BaseAPI}
 */
export class AdminShippingOfficesApi extends BaseAPI {
    /**
     *
     * @summary [Admin] list shipping offices
     * @param {AdminShippingOfficesApiAdminOfficesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminShippingOfficesApi
     */
    adminOfficesGet(requestParameters = {}, options) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesGet(requestParameters.isFtg, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Delete a shipping office
     * @param {AdminShippingOfficesApiAdminOfficesIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminShippingOfficesApi
     */
    adminOfficesIdDelete(requestParameters, options) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get shipping office with Id
     * @param {AdminShippingOfficesApiAdminOfficesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminShippingOfficesApi
     */
    adminOfficesIdGet(requestParameters, options) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Create a shipping office
     * @param {AdminShippingOfficesApiAdminOfficesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminShippingOfficesApi
     */
    adminOfficesPost(requestParameters = {}, options) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesPost(requestParameters.adminOfficesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update the shipping office
     * @param {AdminShippingOfficesApiAdminOfficesPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminShippingOfficesApi
     */
    adminOfficesPut(requestParameters = {}, options) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesPut(requestParameters.adminOfficesPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Gets a paginated list of shipping offices with the searched name, or by Id
     * @param {AdminShippingOfficesApiAdminOfficesSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminShippingOfficesApi
     */
    adminOfficesSearchGet(requestParameters = {}, options) {
        return AdminShippingOfficesApiFp(this.configuration).adminOfficesSearchGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminVendorInvoicesApi - axios parameter creator
 * @export
 */
export const AdminVendorInvoicesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Get the url of the vendor invoice\' pdf
         * @param {string} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesInvoiceIdPdfGet: (invoiceId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('adminVendorInvoicesInvoiceIdPdfGet', 'invoiceId', invoiceId);
            const localVarPath = `/admin/vendor-invoices/{invoiceId}/pdf`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] get paginated vendor invoices of an vendor by vendor id
         * @param {string} vendorId The id of the vendor
         * @param {boolean} [includeProformas]
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesVendorsVendorIdInvoicesGet: (vendorId, includeProformas, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('adminVendorInvoicesVendorsVendorIdInvoicesGet', 'vendorId', vendorId);
            const localVarPath = `/admin/vendor-invoices/vendors/{vendorId}/invoices`
                .replace(`{${"vendorId"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (includeProformas !== undefined) {
                localVarQueryParameter['includeProformas'] = includeProformas;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminVendorInvoicesApi - functional programming interface
 * @export
 */
export const AdminVendorInvoicesApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminVendorInvoicesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Get the url of the vendor invoice\' pdf
         * @param {string} invoiceId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesInvoiceIdPdfGet(invoiceId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminVendorInvoicesInvoiceIdPdfGet(invoiceId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] get paginated vendor invoices of an vendor by vendor id
         * @param {string} vendorId The id of the vendor
         * @param {boolean} [includeProformas]
         * @param {number} [offSet] Offset
         * @param {number} [pageSize] Page size
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesVendorsVendorIdInvoicesGet(vendorId, includeProformas, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminVendorInvoicesVendorsVendorIdInvoicesGet(vendorId, includeProformas, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminVendorInvoicesApi - factory interface
 * @export
 */
export const AdminVendorInvoicesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminVendorInvoicesApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Get the url of the vendor invoice\' pdf
         * @param {AdminVendorInvoicesApiAdminVendorInvoicesInvoiceIdPdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesInvoiceIdPdfGet(requestParameters, options) {
            return localVarFp.adminVendorInvoicesInvoiceIdPdfGet(requestParameters.invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] get paginated vendor invoices of an vendor by vendor id
         * @param {AdminVendorInvoicesApiAdminVendorInvoicesVendorsVendorIdInvoicesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorInvoicesVendorsVendorIdInvoicesGet(requestParameters, options) {
            return localVarFp.adminVendorInvoicesVendorsVendorIdInvoicesGet(requestParameters.vendorId, requestParameters.includeProformas, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminVendorInvoicesApi - object-oriented interface
 * @export
 * @class AdminVendorInvoicesApi
 * @extends {BaseAPI}
 */
export class AdminVendorInvoicesApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Get the url of the vendor invoice\' pdf
     * @param {AdminVendorInvoicesApiAdminVendorInvoicesInvoiceIdPdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorInvoicesApi
     */
    adminVendorInvoicesInvoiceIdPdfGet(requestParameters, options) {
        return AdminVendorInvoicesApiFp(this.configuration).adminVendorInvoicesInvoiceIdPdfGet(requestParameters.invoiceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] get paginated vendor invoices of an vendor by vendor id
     * @param {AdminVendorInvoicesApiAdminVendorInvoicesVendorsVendorIdInvoicesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorInvoicesApi
     */
    adminVendorInvoicesVendorsVendorIdInvoicesGet(requestParameters, options) {
        return AdminVendorInvoicesApiFp(this.configuration).adminVendorInvoicesVendorsVendorIdInvoicesGet(requestParameters.vendorId, requestParameters.includeProformas, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * AdminVendorsApi - axios parameter creator
 * @export
 */
export const AdminVendorsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Gets a paginated list of vendors with the searched id (This should have other properties of vendor, like name i guees)
         * @param {string} [searchTerm] currently only searchable by full Id
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsGet: (searchTerm, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Delete a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdDelete: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminVendorsIdDelete', 'id', id);
            const localVarPath = `/admin/vendors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get vendor with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('adminVendorsIdGet', 'id', id);
            const localVarPath = `/admin/vendors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Gets all the vendors with the given ids list
         * @param {string} [vendors]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsListGet: (vendors, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/vendors/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (vendors !== undefined) {
                localVarQueryParameter['vendors'] = vendors;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Create a vendor
         * @param {AdminVendorsPostRequest} [adminVendorsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPost: (adminVendorsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminVendorsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Update the vendor
         * @param {AdminVendorsPutRequest} [adminVendorsPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPut: (adminVendorsPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/admin/vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminVendorsPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get Contracts Under Vendor
         * @param {string} vendorId
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsVendorIdContractsGet: (vendorId, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'vendorId' is not null or undefined
            assertParamExists('adminVendorsVendorIdContractsGet', 'vendorId', vendorId);
            const localVarPath = `/admin/vendors/{vendorId}/contracts`
                .replace(`{${"vendorId"}}`, encodeURIComponent(String(vendorId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * AdminVendorsApi - functional programming interface
 * @export
 */
export const AdminVendorsApiFp = function (configuration) {
    const localVarAxiosParamCreator = AdminVendorsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Gets a paginated list of vendors with the searched id (This should have other properties of vendor, like name i guees)
         * @param {string} [searchTerm] currently only searchable by full Id
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsGet(searchTerm, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminVendorsGet(searchTerm, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Delete a vendor
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdDelete(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminVendorsIdDelete(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get vendor with Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminVendorsIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Gets all the vendors with the given ids list
         * @param {string} [vendors]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsListGet(vendors, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminVendorsListGet(vendors, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Create a vendor
         * @param {AdminVendorsPostRequest} [adminVendorsPostRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPost(adminVendorsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminVendorsPost(adminVendorsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Update the vendor
         * @param {AdminVendorsPutRequest} [adminVendorsPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPut(adminVendorsPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminVendorsPut(adminVendorsPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get Contracts Under Vendor
         * @param {string} vendorId
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsVendorIdContractsGet(vendorId, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.adminVendorsVendorIdContractsGet(vendorId, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * AdminVendorsApi - factory interface
 * @export
 */
export const AdminVendorsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = AdminVendorsApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Gets a paginated list of vendors with the searched id (This should have other properties of vendor, like name i guees)
         * @param {AdminVendorsApiAdminVendorsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsGet(requestParameters = {}, options) {
            return localVarFp.adminVendorsGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Delete a vendor
         * @param {AdminVendorsApiAdminVendorsIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdDelete(requestParameters, options) {
            return localVarFp.adminVendorsIdDelete(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get vendor with Id
         * @param {AdminVendorsApiAdminVendorsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsIdGet(requestParameters, options) {
            return localVarFp.adminVendorsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Gets all the vendors with the given ids list
         * @param {AdminVendorsApiAdminVendorsListGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsListGet(requestParameters = {}, options) {
            return localVarFp.adminVendorsListGet(requestParameters.vendors, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Create a vendor
         * @param {AdminVendorsApiAdminVendorsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPost(requestParameters = {}, options) {
            return localVarFp.adminVendorsPost(requestParameters.adminVendorsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Update the vendor
         * @param {AdminVendorsApiAdminVendorsPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsPut(requestParameters = {}, options) {
            return localVarFp.adminVendorsPut(requestParameters.adminVendorsPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get Contracts Under Vendor
         * @param {AdminVendorsApiAdminVendorsVendorIdContractsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminVendorsVendorIdContractsGet(requestParameters, options) {
            return localVarFp.adminVendorsVendorIdContractsGet(requestParameters.vendorId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * AdminVendorsApi - object-oriented interface
 * @export
 * @class AdminVendorsApi
 * @extends {BaseAPI}
 */
export class AdminVendorsApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Gets a paginated list of vendors with the searched id (This should have other properties of vendor, like name i guees)
     * @param {AdminVendorsApiAdminVendorsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorsApi
     */
    adminVendorsGet(requestParameters = {}, options) {
        return AdminVendorsApiFp(this.configuration).adminVendorsGet(requestParameters.searchTerm, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Delete a vendor
     * @param {AdminVendorsApiAdminVendorsIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorsApi
     */
    adminVendorsIdDelete(requestParameters, options) {
        return AdminVendorsApiFp(this.configuration).adminVendorsIdDelete(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get vendor with Id
     * @param {AdminVendorsApiAdminVendorsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorsApi
     */
    adminVendorsIdGet(requestParameters, options) {
        return AdminVendorsApiFp(this.configuration).adminVendorsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Gets all the vendors with the given ids list
     * @param {AdminVendorsApiAdminVendorsListGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorsApi
     */
    adminVendorsListGet(requestParameters = {}, options) {
        return AdminVendorsApiFp(this.configuration).adminVendorsListGet(requestParameters.vendors, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Create a vendor
     * @param {AdminVendorsApiAdminVendorsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorsApi
     */
    adminVendorsPost(requestParameters = {}, options) {
        return AdminVendorsApiFp(this.configuration).adminVendorsPost(requestParameters.adminVendorsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Update the vendor
     * @param {AdminVendorsApiAdminVendorsPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorsApi
     */
    adminVendorsPut(requestParameters = {}, options) {
        return AdminVendorsApiFp(this.configuration).adminVendorsPut(requestParameters.adminVendorsPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get Contracts Under Vendor
     * @param {AdminVendorsApiAdminVendorsVendorIdContractsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminVendorsApi
     */
    adminVendorsVendorIdContractsGet(requestParameters, options) {
        return AdminVendorsApiFp(this.configuration).adminVendorsVendorIdContractsGet(requestParameters.vendorId, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * BusinessIdentifiersApi - axios parameter creator
 * @export
 */
export const BusinessIdentifiersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all the possible business identifier types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessIdentifiersTypesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/business-identifiers/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * BusinessIdentifiersApi - functional programming interface
 * @export
 */
export const BusinessIdentifiersApiFp = function (configuration) {
    const localVarAxiosParamCreator = BusinessIdentifiersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Gets all the possible business identifier types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessIdentifiersTypesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.businessIdentifiersTypesGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * BusinessIdentifiersApi - factory interface
 * @export
 */
export const BusinessIdentifiersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BusinessIdentifiersApiFp(configuration);
    return {
        /**
         *
         * @summary Gets all the possible business identifier types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        businessIdentifiersTypesGet(options) {
            return localVarFp.businessIdentifiersTypesGet(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BusinessIdentifiersApi - object-oriented interface
 * @export
 * @class BusinessIdentifiersApi
 * @extends {BaseAPI}
 */
export class BusinessIdentifiersApi extends BaseAPI {
    /**
     *
     * @summary Gets all the possible business identifier types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessIdentifiersApi
     */
    businessIdentifiersTypesGet(options) {
        return BusinessIdentifiersApiFp(this.configuration).businessIdentifiersTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CostEstimatesApi - axios parameter creator
 * @export
 */
export const CostEstimatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Fetch the summary of additional bid costs for a given bid value  NOTE: this endpoint has an absolute path for legacy reasons, stemming from when the controller itself was  still the BidCostsController
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [contractId]
         * @param {number} [bid]
         * @param {string} [currency]
         * @param {string} [destinationCountryCode]
         * @param {'Shirt' | 'Ball' | 'Frame'} [boxType]
         * @param {'PaidShipping' | 'FreeShipping' | 'NoShipping'} [shippingType]
         * @param {Date} [eventStartDate]
         * @param {string} [shippingOfficeId]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalBidCostsGet: (xPlatformKey, contractId, bid, currency, destinationCountryCode, boxType, shippingType, eventStartDate, shippingOfficeId, userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('internalBidCostsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/internal/bid-costs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (contractId !== undefined) {
                localVarQueryParameter['ContractId'] = contractId;
            }
            if (bid !== undefined) {
                localVarQueryParameter['Bid'] = bid;
            }
            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }
            if (destinationCountryCode !== undefined) {
                localVarQueryParameter['DestinationCountryCode'] = destinationCountryCode;
            }
            if (boxType !== undefined) {
                localVarQueryParameter['BoxType'] = boxType;
            }
            if (shippingType !== undefined) {
                localVarQueryParameter['ShippingType'] = shippingType;
            }
            if (eventStartDate !== undefined) {
                localVarQueryParameter['EventStartDate'] = (eventStartDate instanceof Date) ?
                    eventStartDate.toISOString() :
                    eventStartDate;
            }
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['ShippingOfficeId'] = shippingOfficeId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['UserId'] = userId;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} [basePrice]
         * @param {boolean} [basePriceIncludesVat]
         * @param {string} [currency]
         * @param {string} [destinationCountryCode]
         * @param {string} [destinationStateCode]
         * @param {'Shirt' | 'Ball' | 'Frame'} [boxType]
         * @param {string} [shippingOfficeId]
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCostEstimatesGet: (basePrice, basePriceIncludesVat, currency, destinationCountryCode, destinationStateCode, boxType, shippingOfficeId, orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/internal/cost-estimates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (basePrice !== undefined) {
                localVarQueryParameter['BasePrice'] = basePrice;
            }
            if (basePriceIncludesVat !== undefined) {
                localVarQueryParameter['BasePriceIncludesVat'] = basePriceIncludesVat;
            }
            if (currency !== undefined) {
                localVarQueryParameter['Currency'] = currency;
            }
            if (destinationCountryCode !== undefined) {
                localVarQueryParameter['DestinationCountryCode'] = destinationCountryCode;
            }
            if (destinationStateCode !== undefined) {
                localVarQueryParameter['DestinationStateCode'] = destinationStateCode;
            }
            if (boxType !== undefined) {
                localVarQueryParameter['BoxType'] = boxType;
            }
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['ShippingOfficeId'] = shippingOfficeId;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['OrderId'] = orderId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CostEstimatesApi - functional programming interface
 * @export
 */
export const CostEstimatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CostEstimatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Fetch the summary of additional bid costs for a given bid value  NOTE: this endpoint has an absolute path for legacy reasons, stemming from when the controller itself was  still the BidCostsController
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [contractId]
         * @param {number} [bid]
         * @param {string} [currency]
         * @param {string} [destinationCountryCode]
         * @param {'Shirt' | 'Ball' | 'Frame'} [boxType]
         * @param {'PaidShipping' | 'FreeShipping' | 'NoShipping'} [shippingType]
         * @param {Date} [eventStartDate]
         * @param {string} [shippingOfficeId]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalBidCostsGet(xPlatformKey, contractId, bid, currency, destinationCountryCode, boxType, shippingType, eventStartDate, shippingOfficeId, userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalBidCostsGet(xPlatformKey, contractId, bid, currency, destinationCountryCode, boxType, shippingType, eventStartDate, shippingOfficeId, userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} [basePrice]
         * @param {boolean} [basePriceIncludesVat]
         * @param {string} [currency]
         * @param {string} [destinationCountryCode]
         * @param {string} [destinationStateCode]
         * @param {'Shirt' | 'Ball' | 'Frame'} [boxType]
         * @param {string} [shippingOfficeId]
         * @param {string} [orderId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCostEstimatesGet(basePrice, basePriceIncludesVat, currency, destinationCountryCode, destinationStateCode, boxType, shippingOfficeId, orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalCostEstimatesGet(basePrice, basePriceIncludesVat, currency, destinationCountryCode, destinationStateCode, boxType, shippingOfficeId, orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CostEstimatesApi - factory interface
 * @export
 */
export const CostEstimatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CostEstimatesApiFp(configuration);
    return {
        /**
         *
         * @summary Fetch the summary of additional bid costs for a given bid value  NOTE: this endpoint has an absolute path for legacy reasons, stemming from when the controller itself was  still the BidCostsController
         * @param {CostEstimatesApiInternalBidCostsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalBidCostsGet(requestParameters, options) {
            return localVarFp.internalBidCostsGet(requestParameters.xPlatformKey, requestParameters.contractId, requestParameters.bid, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.boxType, requestParameters.shippingType, requestParameters.eventStartDate, requestParameters.shippingOfficeId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {CostEstimatesApiInternalCostEstimatesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCostEstimatesGet(requestParameters = {}, options) {
            return localVarFp.internalCostEstimatesGet(requestParameters.basePrice, requestParameters.basePriceIncludesVat, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.destinationStateCode, requestParameters.boxType, requestParameters.shippingOfficeId, requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CostEstimatesApi - object-oriented interface
 * @export
 * @class CostEstimatesApi
 * @extends {BaseAPI}
 */
export class CostEstimatesApi extends BaseAPI {
    /**
     *
     * @summary Fetch the summary of additional bid costs for a given bid value  NOTE: this endpoint has an absolute path for legacy reasons, stemming from when the controller itself was  still the BidCostsController
     * @param {CostEstimatesApiInternalBidCostsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostEstimatesApi
     */
    internalBidCostsGet(requestParameters, options) {
        return CostEstimatesApiFp(this.configuration).internalBidCostsGet(requestParameters.xPlatformKey, requestParameters.contractId, requestParameters.bid, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.boxType, requestParameters.shippingType, requestParameters.eventStartDate, requestParameters.shippingOfficeId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {CostEstimatesApiInternalCostEstimatesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CostEstimatesApi
     */
    internalCostEstimatesGet(requestParameters = {}, options) {
        return CostEstimatesApiFp(this.configuration).internalCostEstimatesGet(requestParameters.basePrice, requestParameters.basePriceIncludesVat, requestParameters.currency, requestParameters.destinationCountryCode, requestParameters.destinationStateCode, requestParameters.boxType, requestParameters.shippingOfficeId, requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CurrenciesApi - axios parameter creator
 * @export
 */
export const CurrenciesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary get all currencies.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        currenciesGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CurrenciesApi - functional programming interface
 * @export
 */
export const CurrenciesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CurrenciesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary get all currencies.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        currenciesGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.currenciesGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CurrenciesApi - factory interface
 * @export
 */
export const CurrenciesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CurrenciesApiFp(configuration);
    return {
        /**
         *
         * @summary get all currencies.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        currenciesGet(options) {
            return localVarFp.currenciesGet(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CurrenciesApi - object-oriented interface
 * @export
 * @class CurrenciesApi
 * @extends {BaseAPI}
 */
export class CurrenciesApi extends BaseAPI {
    /**
     *
     * @summary get all currencies.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof CurrenciesApi
     */
    currenciesGet(options) {
        return CurrenciesApiFp(this.configuration).currenciesGet(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CustomerAddressesApi - axios parameter creator
 * @export
 */
export const CustomerAddressesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Delete an address from a customer  It is not possible to delete an address if this address is a customer\'s billing or shipping address
         * @param {string} addressId The id of the address that needs to be removed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesAddressIdDelete: (addressId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressesAddressIdDelete', 'addressId', addressId);
            const localVarPath = `/addresses/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update one address of a customer
         * @param {string} addressId The id of the address that needs to be updated
         * @param {AdminCustomersAddressesAddressIdPutRequest} [adminCustomersAddressesAddressIdPutRequest] The request object that contains the necessary fields of a customer address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesAddressIdPut: (addressId, adminCustomersAddressesAddressIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressesAddressIdPut', 'addressId', addressId);
            const localVarPath = `/addresses/{addressId}`
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminCustomersAddressesAddressIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set a user\'s address to their billing address and/or shipping address
         * @param {string} customerId The id of the customer
         * @param {string} addressId The id of the new billing/shipping address
         * @param {boolean} [billing] Set this address to the user\&#39;s billing address
         * @param {boolean} [shipping] Set this address to the user\&#39;s shipping address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressesAddressIdStatusPatch: (customerId, addressId, billing, shipping, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('customersCustomerIdAddressesAddressIdStatusPatch', 'customerId', customerId);
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('customersCustomerIdAddressesAddressIdStatusPatch', 'addressId', addressId);
            const localVarPath = `/customers/{customerId}/addresses/{addressId}/status`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (billing !== undefined) {
                localVarQueryParameter['billing'] = billing;
            }
            if (shipping !== undefined) {
                localVarQueryParameter['shipping'] = shipping;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Add an address to a customer
         * @param {string} customerId The id of the customer
         * @param {AdminCustomersAddressesAddressIdPutRequest} [adminCustomersAddressesAddressIdPutRequest] The request object that contains the necessary fields of a customer address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressesPost: (customerId, adminCustomersAddressesAddressIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('customersCustomerIdAddressesPost', 'customerId', customerId);
            const localVarPath = `/customers/{customerId}/addresses`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(adminCustomersAddressesAddressIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CustomerAddressesApi - functional programming interface
 * @export
 */
export const CustomerAddressesApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomerAddressesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Delete an address from a customer  It is not possible to delete an address if this address is a customer\'s billing or shipping address
         * @param {string} addressId The id of the address that needs to be removed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesAddressIdDelete(addressId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesAddressIdDelete(addressId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update one address of a customer
         * @param {string} addressId The id of the address that needs to be updated
         * @param {AdminCustomersAddressesAddressIdPutRequest} [adminCustomersAddressesAddressIdPutRequest] The request object that contains the necessary fields of a customer address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesAddressIdPut(addressId, adminCustomersAddressesAddressIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.addressesAddressIdPut(addressId, adminCustomersAddressesAddressIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Set a user\'s address to their billing address and/or shipping address
         * @param {string} customerId The id of the customer
         * @param {string} addressId The id of the new billing/shipping address
         * @param {boolean} [billing] Set this address to the user\&#39;s billing address
         * @param {boolean} [shipping] Set this address to the user\&#39;s shipping address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressesAddressIdStatusPatch(customerId, addressId, billing, shipping, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customersCustomerIdAddressesAddressIdStatusPatch(customerId, addressId, billing, shipping, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Add an address to a customer
         * @param {string} customerId The id of the customer
         * @param {AdminCustomersAddressesAddressIdPutRequest} [adminCustomersAddressesAddressIdPutRequest] The request object that contains the necessary fields of a customer address
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressesPost(customerId, adminCustomersAddressesAddressIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customersCustomerIdAddressesPost(customerId, adminCustomersAddressesAddressIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CustomerAddressesApi - factory interface
 * @export
 */
export const CustomerAddressesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomerAddressesApiFp(configuration);
    return {
        /**
         *
         * @summary Delete an address from a customer  It is not possible to delete an address if this address is a customer\'s billing or shipping address
         * @param {CustomerAddressesApiAddressesAddressIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesAddressIdDelete(requestParameters, options) {
            return localVarFp.addressesAddressIdDelete(requestParameters.addressId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update one address of a customer
         * @param {CustomerAddressesApiAddressesAddressIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressesAddressIdPut(requestParameters, options) {
            return localVarFp.addressesAddressIdPut(requestParameters.addressId, requestParameters.adminCustomersAddressesAddressIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set a user\'s address to their billing address and/or shipping address
         * @param {CustomerAddressesApiCustomersCustomerIdAddressesAddressIdStatusPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressesAddressIdStatusPatch(requestParameters, options) {
            return localVarFp.customersCustomerIdAddressesAddressIdStatusPatch(requestParameters.customerId, requestParameters.addressId, requestParameters.billing, requestParameters.shipping, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Add an address to a customer
         * @param {CustomerAddressesApiCustomersCustomerIdAddressesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdAddressesPost(requestParameters, options) {
            return localVarFp.customersCustomerIdAddressesPost(requestParameters.customerId, requestParameters.adminCustomersAddressesAddressIdPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomerAddressesApi - object-oriented interface
 * @export
 * @class CustomerAddressesApi
 * @extends {BaseAPI}
 */
export class CustomerAddressesApi extends BaseAPI {
    /**
     *
     * @summary Delete an address from a customer  It is not possible to delete an address if this address is a customer\'s billing or shipping address
     * @param {CustomerAddressesApiAddressesAddressIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAddressesApi
     */
    addressesAddressIdDelete(requestParameters, options) {
        return CustomerAddressesApiFp(this.configuration).addressesAddressIdDelete(requestParameters.addressId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update one address of a customer
     * @param {CustomerAddressesApiAddressesAddressIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAddressesApi
     */
    addressesAddressIdPut(requestParameters, options) {
        return CustomerAddressesApiFp(this.configuration).addressesAddressIdPut(requestParameters.addressId, requestParameters.adminCustomersAddressesAddressIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set a user\'s address to their billing address and/or shipping address
     * @param {CustomerAddressesApiCustomersCustomerIdAddressesAddressIdStatusPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAddressesApi
     */
    customersCustomerIdAddressesAddressIdStatusPatch(requestParameters, options) {
        return CustomerAddressesApiFp(this.configuration).customersCustomerIdAddressesAddressIdStatusPatch(requestParameters.customerId, requestParameters.addressId, requestParameters.billing, requestParameters.shipping, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Add an address to a customer
     * @param {CustomerAddressesApiCustomersCustomerIdAddressesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerAddressesApi
     */
    customersCustomerIdAddressesPost(requestParameters, options) {
        return CustomerAddressesApiFp(this.configuration).customersCustomerIdAddressesPost(requestParameters.customerId, requestParameters.adminCustomersAddressesAddressIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * CustomersApi - axios parameter creator
 * @export
 */
export const CustomersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get customer object of the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCurrentGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/customers/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Get customer stats for the my profile page
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCurrentStatsGet: (xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('customersCurrentStatsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/customers/current/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Update customer business identifiers
         * @param {string} customerId
         * @param {CustomersCustomerIdBusinessIdentifiersPatchRequest} [customersCustomerIdBusinessIdentifiersPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBusinessIdentifiersPatch: (customerId, customersCustomerIdBusinessIdentifiersPatchRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'customerId' is not null or undefined
            assertParamExists('customersCustomerIdBusinessIdentifiersPatch', 'customerId', customerId);
            const localVarPath = `/customers/{customerId}/business-identifiers`
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(customersCustomerIdBusinessIdentifiersPatchRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * CustomersApi - functional programming interface
 * @export
 */
export const CustomersApiFp = function (configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get customer object of the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCurrentGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customersCurrentGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Get customer stats for the my profile page
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCurrentStatsGet(xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customersCurrentStatsGet(xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Update customer business identifiers
         * @param {string} customerId
         * @param {CustomersCustomerIdBusinessIdentifiersPatchRequest} [customersCustomerIdBusinessIdentifiersPatchRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBusinessIdentifiersPatch(customerId, customersCustomerIdBusinessIdentifiersPatchRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.customersCustomerIdBusinessIdentifiersPatch(customerId, customersCustomerIdBusinessIdentifiersPatchRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * CustomersApi - factory interface
 * @export
 */
export const CustomersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = CustomersApiFp(configuration);
    return {
        /**
         *
         * @summary Get customer object of the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCurrentGet(options) {
            return localVarFp.customersCurrentGet(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Get customer stats for the my profile page
         * @param {CustomersApiCustomersCurrentStatsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCurrentStatsGet(requestParameters, options) {
            return localVarFp.customersCurrentStatsGet(requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Update customer business identifiers
         * @param {CustomersApiCustomersCustomerIdBusinessIdentifiersPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersCustomerIdBusinessIdentifiersPatch(requestParameters, options) {
            return localVarFp.customersCustomerIdBusinessIdentifiersPatch(requestParameters.customerId, requestParameters.customersCustomerIdBusinessIdentifiersPatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * CustomersApi - object-oriented interface
 * @export
 * @class CustomersApi
 * @extends {BaseAPI}
 */
export class CustomersApi extends BaseAPI {
    /**
     *
     * @summary Get customer object of the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    customersCurrentGet(options) {
        return CustomersApiFp(this.configuration).customersCurrentGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Get customer stats for the my profile page
     * @param {CustomersApiCustomersCurrentStatsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    customersCurrentStatsGet(requestParameters, options) {
        return CustomersApiFp(this.configuration).customersCurrentStatsGet(requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Update customer business identifiers
     * @param {CustomersApiCustomersCustomerIdBusinessIdentifiersPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomersApi
     */
    customersCustomerIdBusinessIdentifiersPatch(requestParameters, options) {
        return CustomersApiFp(this.configuration).customersCustomerIdBusinessIdentifiersPatch(requestParameters.customerId, requestParameters.customersCustomerIdBusinessIdentifiersPatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ExchangeRatesApi - axios parameter creator
 * @export
 */
export const ExchangeRatesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get current exchange rates to and from eur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeratesCurrentGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/exchangerates/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ExchangeRatesApi - functional programming interface
 * @export
 */
export const ExchangeRatesApiFp = function (configuration) {
    const localVarAxiosParamCreator = ExchangeRatesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get current exchange rates to and from eur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeratesCurrentGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.exchangeratesCurrentGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ExchangeRatesApi - factory interface
 * @export
 */
export const ExchangeRatesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ExchangeRatesApiFp(configuration);
    return {
        /**
         *
         * @summary Get current exchange rates to and from eur
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exchangeratesCurrentGet(options) {
            return localVarFp.exchangeratesCurrentGet(options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ExchangeRatesApi - object-oriented interface
 * @export
 * @class ExchangeRatesApi
 * @extends {BaseAPI}
 */
export class ExchangeRatesApi extends BaseAPI {
    /**
     *
     * @summary Get current exchange rates to and from eur
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExchangeRatesApi
     */
    exchangeratesCurrentGet(options) {
        return ExchangeRatesApiFp(this.configuration).exchangeratesCurrentGet(options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InternalContractsApi - axios parameter creator
 * @export
 */
export const InternalContractsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Get contract by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalContractsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalContractsIdGet', 'id', id);
            const localVarPath = `/internal/contracts/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InternalContractsApi - functional programming interface
 * @export
 */
export const InternalContractsApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalContractsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Get contract by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalContractsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalContractsIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InternalContractsApi - factory interface
 * @export
 */
export const InternalContractsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalContractsApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Get contract by Id
         * @param {InternalContractsApiInternalContractsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalContractsIdGet(requestParameters, options) {
            return localVarFp.internalContractsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InternalContractsApi - object-oriented interface
 * @export
 * @class InternalContractsApi
 * @extends {BaseAPI}
 */
export class InternalContractsApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Get contract by Id
     * @param {InternalContractsApiInternalContractsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalContractsApi
     */
    internalContractsIdGet(requestParameters, options) {
        return InternalContractsApiFp(this.configuration).internalContractsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InternalCustomersApi - axios parameter creator
 * @export
 */
export const InternalCustomersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get customer object by userId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdGet: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('internalCustomersUserUserIdGet', 'userId', userId);
            const localVarPath = `/internal/customers/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary (RPC) Returns a double that indicates the ratio of unpaid orders of a user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdSuspiciousBidInformationGet: (userId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('internalCustomersUserUserIdSuspiciousBidInformationGet', 'userId', userId);
            const localVarPath = `/internal/customers/user/{userId}/suspicious-bid-information`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InternalCustomersApi - functional programming interface
 * @export
 */
export const InternalCustomersApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalCustomersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get customer object by userId
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdGet(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalCustomersUserUserIdGet(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary (RPC) Returns a double that indicates the ratio of unpaid orders of a user
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdSuspiciousBidInformationGet(userId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalCustomersUserUserIdSuspiciousBidInformationGet(userId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InternalCustomersApi - factory interface
 * @export
 */
export const InternalCustomersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalCustomersApiFp(configuration);
    return {
        /**
         *
         * @summary Get customer object by userId
         * @param {InternalCustomersApiInternalCustomersUserUserIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdGet(requestParameters, options) {
            return localVarFp.internalCustomersUserUserIdGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (RPC) Returns a double that indicates the ratio of unpaid orders of a user
         * @param {InternalCustomersApiInternalCustomersUserUserIdSuspiciousBidInformationGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalCustomersUserUserIdSuspiciousBidInformationGet(requestParameters, options) {
            return localVarFp.internalCustomersUserUserIdSuspiciousBidInformationGet(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InternalCustomersApi - object-oriented interface
 * @export
 * @class InternalCustomersApi
 * @extends {BaseAPI}
 */
export class InternalCustomersApi extends BaseAPI {
    /**
     *
     * @summary Get customer object by userId
     * @param {InternalCustomersApiInternalCustomersUserUserIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalCustomersApi
     */
    internalCustomersUserUserIdGet(requestParameters, options) {
        return InternalCustomersApiFp(this.configuration).internalCustomersUserUserIdGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (RPC) Returns a double that indicates the ratio of unpaid orders of a user
     * @param {InternalCustomersApiInternalCustomersUserUserIdSuspiciousBidInformationGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalCustomersApi
     */
    internalCustomersUserUserIdSuspiciousBidInformationGet(requestParameters, options) {
        return InternalCustomersApiFp(this.configuration).internalCustomersUserUserIdSuspiciousBidInformationGet(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InternalOrdersApi - axios parameter creator
 * @export
 */
export const InternalOrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get full order details by id.
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalOrdersOrderIdGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('internalOrdersOrderIdGet', 'orderId', orderId);
            const localVarPath = `/internal/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InternalOrdersApi - functional programming interface
 * @export
 */
export const InternalOrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalOrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get full order details by id.
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalOrdersOrderIdGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalOrdersOrderIdGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InternalOrdersApi - factory interface
 * @export
 */
export const InternalOrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalOrdersApiFp(configuration);
    return {
        /**
         *
         * @summary Get full order details by id.
         * @param {InternalOrdersApiInternalOrdersOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalOrdersOrderIdGet(requestParameters, options) {
            return localVarFp.internalOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InternalOrdersApi - object-oriented interface
 * @export
 * @class InternalOrdersApi
 * @extends {BaseAPI}
 */
export class InternalOrdersApi extends BaseAPI {
    /**
     *
     * @summary Get full order details by id.
     * @param {InternalOrdersApiInternalOrdersOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalOrdersApi
     */
    internalOrdersOrderIdGet(requestParameters, options) {
        return InternalOrdersApiFp(this.configuration).internalOrdersOrderIdGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InternalPartnersApi - axios parameter creator
 * @export
 */
export const InternalPartnersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] getting partners by contracts Ids
         * @param {string} [contracts]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersContractsGet: (contracts, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/internal/partners/contracts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (contracts !== undefined) {
                localVarQueryParameter['contracts'] = contracts;
            }
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get partner by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalPartnersIdGet', 'id', id);
            const localVarPath = `/internal/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InternalPartnersApi - functional programming interface
 * @export
 */
export const InternalPartnersApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalPartnersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] getting partners by contracts Ids
         * @param {string} [contracts]
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersContractsGet(contracts, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalPartnersContractsGet(contracts, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get partner by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalPartnersIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InternalPartnersApi - factory interface
 * @export
 */
export const InternalPartnersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalPartnersApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] getting partners by contracts Ids
         * @param {InternalPartnersApiInternalPartnersContractsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersContractsGet(requestParameters = {}, options) {
            return localVarFp.internalPartnersContractsGet(requestParameters.contracts, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get partner by Id
         * @param {InternalPartnersApiInternalPartnersIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalPartnersIdGet(requestParameters, options) {
            return localVarFp.internalPartnersIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InternalPartnersApi - object-oriented interface
 * @export
 * @class InternalPartnersApi
 * @extends {BaseAPI}
 */
export class InternalPartnersApi extends BaseAPI {
    /**
     *
     * @summary [Admin] getting partners by contracts Ids
     * @param {InternalPartnersApiInternalPartnersContractsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalPartnersApi
     */
    internalPartnersContractsGet(requestParameters = {}, options) {
        return InternalPartnersApiFp(this.configuration).internalPartnersContractsGet(requestParameters.contracts, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get partner by Id
     * @param {InternalPartnersApiInternalPartnersIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalPartnersApi
     */
    internalPartnersIdGet(requestParameters, options) {
        return InternalPartnersApiFp(this.configuration).internalPartnersIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InternalShippingOfficesApi - axios parameter creator
 * @export
 */
export const InternalShippingOfficesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Internal] list shipping offices
         * @param {boolean} [isFtg]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesGet: (isFtg, offset, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/internal/shipping-offices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (isFtg !== undefined) {
                localVarQueryParameter['isFtg'] = isFtg;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [Admin] Get shipping office by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalShippingOfficesIdGet', 'id', id);
            const localVarPath = `/internal/shipping-offices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InternalShippingOfficesApi - functional programming interface
 * @export
 */
export const InternalShippingOfficesApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalShippingOfficesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Internal] list shipping offices
         * @param {boolean} [isFtg]
         * @param {number} [offset]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesGet(isFtg, offset, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalShippingOfficesGet(isFtg, offset, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [Admin] Get shipping office by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalShippingOfficesIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InternalShippingOfficesApi - factory interface
 * @export
 */
export const InternalShippingOfficesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalShippingOfficesApiFp(configuration);
    return {
        /**
         *
         * @summary [Internal] list shipping offices
         * @param {InternalShippingOfficesApiInternalShippingOfficesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesGet(requestParameters = {}, options) {
            return localVarFp.internalShippingOfficesGet(requestParameters.isFtg, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [Admin] Get shipping office by Id
         * @param {InternalShippingOfficesApiInternalShippingOfficesIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalShippingOfficesIdGet(requestParameters, options) {
            return localVarFp.internalShippingOfficesIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InternalShippingOfficesApi - object-oriented interface
 * @export
 * @class InternalShippingOfficesApi
 * @extends {BaseAPI}
 */
export class InternalShippingOfficesApi extends BaseAPI {
    /**
     *
     * @summary [Internal] list shipping offices
     * @param {InternalShippingOfficesApiInternalShippingOfficesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalShippingOfficesApi
     */
    internalShippingOfficesGet(requestParameters = {}, options) {
        return InternalShippingOfficesApiFp(this.configuration).internalShippingOfficesGet(requestParameters.isFtg, requestParameters.offset, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [Admin] Get shipping office by Id
     * @param {InternalShippingOfficesApiInternalShippingOfficesIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalShippingOfficesApi
     */
    internalShippingOfficesIdGet(requestParameters, options) {
        return InternalShippingOfficesApiFp(this.configuration).internalShippingOfficesIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * InternalVendorsApi - axios parameter creator
 * @export
 */
export const InternalVendorsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [Admin] Get vendor by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalVendorsIdGet: (id, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('internalVendorsIdGet', 'id', id);
            const localVarPath = `/internal/vendors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * InternalVendorsApi - functional programming interface
 * @export
 */
export const InternalVendorsApiFp = function (configuration) {
    const localVarAxiosParamCreator = InternalVendorsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [Admin] Get vendor by Id
         * @param {string} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalVendorsIdGet(id, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalVendorsIdGet(id, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * InternalVendorsApi - factory interface
 * @export
 */
export const InternalVendorsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = InternalVendorsApiFp(configuration);
    return {
        /**
         *
         * @summary [Admin] Get vendor by Id
         * @param {InternalVendorsApiInternalVendorsIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalVendorsIdGet(requestParameters, options) {
            return localVarFp.internalVendorsIdGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * InternalVendorsApi - object-oriented interface
 * @export
 * @class InternalVendorsApi
 * @extends {BaseAPI}
 */
export class InternalVendorsApi extends BaseAPI {
    /**
     *
     * @summary [Admin] Get vendor by Id
     * @param {InternalVendorsApiInternalVendorsIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalVendorsApi
     */
    internalVendorsIdGet(requestParameters, options) {
        return InternalVendorsApiFp(this.configuration).internalVendorsIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary (RPC) close a framing order
         * @param {string} externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdClosePatch: (externalId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('ordersFramingExternalIdClosePatch', 'externalId', externalId);
            const localVarPath = `/orders/framing/{externalId}/close`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary (RPC) update or create a framing order by external id.
         * @param {string} externalId
         * @param {OrdersFramingExternalIdPutRequest} [ordersFramingExternalIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdPut: (externalId, ordersFramingExternalIdPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'externalId' is not null or undefined
            assertParamExists('ordersFramingExternalIdPut', 'externalId', externalId);
            const localVarPath = `/orders/framing/{externalId}`
                .replace(`{${"externalId"}}`, encodeURIComponent(String(externalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ordersFramingExternalIdPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [User] get order by id
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [paymentMethod] the payment method for payment
         * @param {string} [shippingAddressId] the shipping address for which the shipping costs need to be calculated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdGet: (orderId, xPlatformKey, paymentMethod, shippingAddressId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdGet', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('ordersOrderIdGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }
            if (shippingAddressId !== undefined) {
                localVarQueryParameter['shippingAddressId'] = shippingAddressId;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Set the customer id on an order. Will also update the framing order and create a customer if it does not exist.  If the customer already exists but does not have an address, also add the addresses
         * @param {string} orderId
         * @param {OrdersOrderIdUserPutRequest} [ordersOrderIdUserPutRequest] The request object containing data about the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdUserPut: (orderId, ordersOrderIdUserPutRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdUserPut', 'orderId', orderId);
            const localVarPath = `/orders/{orderId}/user`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PUT' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ordersOrderIdUserPutRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary (RPC) close a framing order
         * @param {string} externalId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdClosePatch(externalId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersFramingExternalIdClosePatch(externalId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary (RPC) update or create a framing order by external id.
         * @param {string} externalId
         * @param {OrdersFramingExternalIdPutRequest} [ordersFramingExternalIdPutRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdPut(externalId, ordersFramingExternalIdPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersFramingExternalIdPut(externalId, ordersFramingExternalIdPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [User] get order by id
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {string} [paymentMethod] the payment method for payment
         * @param {string} [shippingAddressId] the shipping address for which the shipping costs need to be calculated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdGet(orderId, xPlatformKey, paymentMethod, shippingAddressId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersOrderIdGet(orderId, xPlatformKey, paymentMethod, shippingAddressId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Set the customer id on an order. Will also update the framing order and create a customer if it does not exist.  If the customer already exists but does not have an address, also add the addresses
         * @param {string} orderId
         * @param {OrdersOrderIdUserPutRequest} [ordersOrderIdUserPutRequest] The request object containing data about the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdUserPut(orderId, ordersOrderIdUserPutRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersOrderIdUserPut(orderId, ordersOrderIdUserPutRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = OrdersApiFp(configuration);
    return {
        /**
         *
         * @summary (RPC) close a framing order
         * @param {OrdersApiOrdersFramingExternalIdClosePatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdClosePatch(requestParameters, options) {
            return localVarFp.ordersFramingExternalIdClosePatch(requestParameters.externalId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary (RPC) update or create a framing order by external id.
         * @param {OrdersApiOrdersFramingExternalIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersFramingExternalIdPut(requestParameters, options) {
            return localVarFp.ordersFramingExternalIdPut(requestParameters.externalId, requestParameters.ordersFramingExternalIdPutRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [User] get order by id
         * @param {OrdersApiOrdersOrderIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdGet(requestParameters, options) {
            return localVarFp.ordersOrderIdGet(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.paymentMethod, requestParameters.shippingAddressId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Set the customer id on an order. Will also update the framing order and create a customer if it does not exist.  If the customer already exists but does not have an address, also add the addresses
         * @param {OrdersApiOrdersOrderIdUserPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdUserPut(requestParameters, options) {
            return localVarFp.ordersOrderIdUserPut(requestParameters.orderId, requestParameters.ordersOrderIdUserPutRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     *
     * @summary (RPC) close a framing order
     * @param {OrdersApiOrdersFramingExternalIdClosePatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    ordersFramingExternalIdClosePatch(requestParameters, options) {
        return OrdersApiFp(this.configuration).ordersFramingExternalIdClosePatch(requestParameters.externalId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary (RPC) update or create a framing order by external id.
     * @param {OrdersApiOrdersFramingExternalIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    ordersFramingExternalIdPut(requestParameters, options) {
        return OrdersApiFp(this.configuration).ordersFramingExternalIdPut(requestParameters.externalId, requestParameters.ordersFramingExternalIdPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [User] get order by id
     * @param {OrdersApiOrdersOrderIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    ordersOrderIdGet(requestParameters, options) {
        return OrdersApiFp(this.configuration).ordersOrderIdGet(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.paymentMethod, requestParameters.shippingAddressId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Set the customer id on an order. Will also update the framing order and create a customer if it does not exist.  If the customer already exists but does not have an address, also add the addresses
     * @param {OrdersApiOrdersOrderIdUserPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    ordersOrderIdUserPut(requestParameters, options) {
        return OrdersApiFp(this.configuration).ordersOrderIdUserPut(requestParameters.orderId, requestParameters.ordersOrderIdUserPutRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ParcelsApi - axios parameter creator
 * @export
 */
export const ParcelsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [User] Will return the tracking parcel dto\'s for every order in orderIds that has a parcel entity
         * @param {string} [orderIds] Comma seperated list of order ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelsOrdersGet: (orderIds, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/parcels/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (orderIds !== undefined) {
                localVarQueryParameter['orderIds'] = orderIds;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ParcelsApi - functional programming interface
 * @export
 */
export const ParcelsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ParcelsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [User] Will return the tracking parcel dto\'s for every order in orderIds that has a parcel entity
         * @param {string} [orderIds] Comma seperated list of order ids
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelsOrdersGet(orderIds, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.parcelsOrdersGet(orderIds, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ParcelsApi - factory interface
 * @export
 */
export const ParcelsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ParcelsApiFp(configuration);
    return {
        /**
         *
         * @summary [User] Will return the tracking parcel dto\'s for every order in orderIds that has a parcel entity
         * @param {ParcelsApiParcelsOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        parcelsOrdersGet(requestParameters = {}, options) {
            return localVarFp.parcelsOrdersGet(requestParameters.orderIds, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ParcelsApi - object-oriented interface
 * @export
 * @class ParcelsApi
 * @extends {BaseAPI}
 */
export class ParcelsApi extends BaseAPI {
    /**
     *
     * @summary [User] Will return the tracking parcel dto\'s for every order in orderIds that has a parcel entity
     * @param {ParcelsApiParcelsOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParcelsApi
     */
    parcelsOrdersGet(requestParameters = {}, options) {
        return ParcelsApiFp(this.configuration).parcelsOrdersGet(requestParameters.orderIds, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ShippingCostsApi - axios parameter creator
 * @export
 */
export const ShippingCostsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Calculate the shipping costs for a product with given shipping information.
         * @param {string} xPlatformKey Select the platform.
         * @param {'NotFrameable' | 'Frameable' | 'Framed'} [framingType]
         * @param {'PaidShipping' | 'FreeShipping' | 'NoShipping'} [shippingType]
         * @param {string} [shippingOfficeId]
         * @param {string} [destinationCountryCode] [optional] destination country code, overrides the users\&#39; shipping address country as destination if provided.
         * @param {boolean} [applyVat] [optional] whether or not the shipping cost will include vat in the price defaults to true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippingCostsGet: (xPlatformKey, framingType, shippingType, shippingOfficeId, destinationCountryCode, applyVat, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('shippingCostsGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/shipping-costs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (framingType !== undefined) {
                localVarQueryParameter['framingType'] = framingType;
            }
            if (shippingType !== undefined) {
                localVarQueryParameter['shippingType'] = shippingType;
            }
            if (shippingOfficeId !== undefined) {
                localVarQueryParameter['shippingOfficeId'] = shippingOfficeId;
            }
            if (destinationCountryCode !== undefined) {
                localVarQueryParameter['destinationCountryCode'] = destinationCountryCode;
            }
            if (applyVat !== undefined) {
                localVarQueryParameter['applyVat'] = applyVat;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ShippingCostsApi - functional programming interface
 * @export
 */
export const ShippingCostsApiFp = function (configuration) {
    const localVarAxiosParamCreator = ShippingCostsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Calculate the shipping costs for a product with given shipping information.
         * @param {string} xPlatformKey Select the platform.
         * @param {'NotFrameable' | 'Frameable' | 'Framed'} [framingType]
         * @param {'PaidShipping' | 'FreeShipping' | 'NoShipping'} [shippingType]
         * @param {string} [shippingOfficeId]
         * @param {string} [destinationCountryCode] [optional] destination country code, overrides the users\&#39; shipping address country as destination if provided.
         * @param {boolean} [applyVat] [optional] whether or not the shipping cost will include vat in the price defaults to true.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippingCostsGet(xPlatformKey, framingType, shippingType, shippingOfficeId, destinationCountryCode, applyVat, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.shippingCostsGet(xPlatformKey, framingType, shippingType, shippingOfficeId, destinationCountryCode, applyVat, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ShippingCostsApi - factory interface
 * @export
 */
export const ShippingCostsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ShippingCostsApiFp(configuration);
    return {
        /**
         *
         * @summary Calculate the shipping costs for a product with given shipping information.
         * @param {ShippingCostsApiShippingCostsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shippingCostsGet(requestParameters, options) {
            return localVarFp.shippingCostsGet(requestParameters.xPlatformKey, requestParameters.framingType, requestParameters.shippingType, requestParameters.shippingOfficeId, requestParameters.destinationCountryCode, requestParameters.applyVat, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ShippingCostsApi - object-oriented interface
 * @export
 * @class ShippingCostsApi
 * @extends {BaseAPI}
 */
export class ShippingCostsApi extends BaseAPI {
    /**
     *
     * @summary Calculate the shipping costs for a product with given shipping information.
     * @param {ShippingCostsApiShippingCostsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ShippingCostsApi
     */
    shippingCostsGet(requestParameters, options) {
        return ShippingCostsApiFp(this.configuration).shippingCostsGet(requestParameters.xPlatformKey, requestParameters.framingType, requestParameters.shippingType, requestParameters.shippingOfficeId, requestParameters.destinationCountryCode, requestParameters.applyVat, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * TransactionsApi - axios parameter creator
 * @export
 */
export const TransactionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get the payment fee for the requested payment
         * @param {string} orderId The id of the order
         * @param {string} [paymentMethod] The requested payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdPaymentsFeesGet: (orderId, paymentMethod, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdPaymentsFeesGet', 'orderId', orderId);
            const localVarPath = `/orders/{orderId}/payments/fees`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (paymentMethod !== undefined) {
                localVarQueryParameter['paymentMethod'] = paymentMethod;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create the payment session and get Adyen references for order payment
         * @param {string} orderId The id of the order that is going to be paid
         * @param {string} xPlatformKey Select the platform.
         * @param {OrdersOrderIdPaymentsPostRequest} [ordersOrderIdPaymentsPostRequest] The request object that contains the return url and locale code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdPaymentsPost: (orderId, xPlatformKey, ordersOrderIdPaymentsPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdPaymentsPost', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('ordersOrderIdPaymentsPost', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/orders/{orderId}/payments`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(ordersOrderIdPaymentsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create the payment session and get Adyen references for verifying payment information
         * @param {PaymentsVerificationPostRequest} [paymentsVerificationPostRequest] The request object that contains the return url, locale code and currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsVerificationPost: (paymentsVerificationPostRequest, options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/payments/verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(paymentsVerificationPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * TransactionsApi - functional programming interface
 * @export
 */
export const TransactionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = TransactionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Get the payment fee for the requested payment
         * @param {string} orderId The id of the order
         * @param {string} [paymentMethod] The requested payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdPaymentsFeesGet(orderId, paymentMethod, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersOrderIdPaymentsFeesGet(orderId, paymentMethod, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create the payment session and get Adyen references for order payment
         * @param {string} orderId The id of the order that is going to be paid
         * @param {string} xPlatformKey Select the platform.
         * @param {OrdersOrderIdPaymentsPostRequest} [ordersOrderIdPaymentsPostRequest] The request object that contains the return url and locale code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdPaymentsPost(orderId, xPlatformKey, ordersOrderIdPaymentsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersOrderIdPaymentsPost(orderId, xPlatformKey, ordersOrderIdPaymentsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create the payment session and get Adyen references for verifying payment information
         * @param {PaymentsVerificationPostRequest} [paymentsVerificationPostRequest] The request object that contains the return url, locale code and currency code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsVerificationPost(paymentsVerificationPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.paymentsVerificationPost(paymentsVerificationPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * TransactionsApi - factory interface
 * @export
 */
export const TransactionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = TransactionsApiFp(configuration);
    return {
        /**
         *
         * @summary Get the payment fee for the requested payment
         * @param {TransactionsApiOrdersOrderIdPaymentsFeesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdPaymentsFeesGet(requestParameters, options) {
            return localVarFp.ordersOrderIdPaymentsFeesGet(requestParameters.orderId, requestParameters.paymentMethod, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create the payment session and get Adyen references for order payment
         * @param {TransactionsApiOrdersOrderIdPaymentsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdPaymentsPost(requestParameters, options) {
            return localVarFp.ordersOrderIdPaymentsPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.ordersOrderIdPaymentsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create the payment session and get Adyen references for verifying payment information
         * @param {TransactionsApiPaymentsVerificationPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentsVerificationPost(requestParameters = {}, options) {
            return localVarFp.paymentsVerificationPost(requestParameters.paymentsVerificationPostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
export class TransactionsApi extends BaseAPI {
    /**
     *
     * @summary Get the payment fee for the requested payment
     * @param {TransactionsApiOrdersOrderIdPaymentsFeesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    ordersOrderIdPaymentsFeesGet(requestParameters, options) {
        return TransactionsApiFp(this.configuration).ordersOrderIdPaymentsFeesGet(requestParameters.orderId, requestParameters.paymentMethod, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create the payment session and get Adyen references for order payment
     * @param {TransactionsApiOrdersOrderIdPaymentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    ordersOrderIdPaymentsPost(requestParameters, options) {
        return TransactionsApiFp(this.configuration).ordersOrderIdPaymentsPost(requestParameters.orderId, requestParameters.xPlatformKey, requestParameters.ordersOrderIdPaymentsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create the payment session and get Adyen references for verifying payment information
     * @param {TransactionsApiPaymentsVerificationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    paymentsVerificationPost(requestParameters = {}, options) {
        return TransactionsApiFp(this.configuration).paymentsVerificationPost(requestParameters.paymentsVerificationPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * UserOrdersApi - axios parameter creator
 * @export
 */
export const UserOrdersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary [User] get paginated result of orders
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersGet: (xPlatformKey, offSet, pageSize, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('ordersGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (offSet !== undefined) {
                localVarQueryParameter['offSet'] = offSet;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [User] Returns a boolean indicating whether framing for an order can be started
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdCanBeFramedGet: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdCanBeFramedGet', 'orderId', orderId);
            const localVarPath = `/orders/{orderId}/can-be-framed`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [User] Claims a (free) order, marking it as \"paid\" so it can be picked up by operations.
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdClaimPatch: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdClaimPatch', 'orderId', orderId);
            const localVarPath = `/orders/{orderId}/claim`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [User] User does not want to frame product, so continue with the processing of order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersOrderIdFramingWindowDelete: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdFramingWindowDelete', 'orderId', orderId);
            const localVarPath = `/orders/{orderId}/framing-window`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [User] Fetches or creates a framing session for the specified order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersOrderIdFramingsessionPost: (orderId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdFramingsessionPost', 'orderId', orderId);
            const localVarPath = `/orders/{orderId}/framingsession`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary [User] get the pdf url of an order\'s invoice
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersOrderIdInvoicePdfGet: (orderId, xPlatformKey, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('ordersOrderIdInvoicePdfGet', 'orderId', orderId);
            // verify required parameter 'xPlatformKey' is not null or undefined
            assertParamExists('ordersOrderIdInvoicePdfGet', 'xPlatformKey', xPlatformKey);
            const localVarPath = `/orders/{orderId}/invoice-pdf`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication oidc required
            if (xPlatformKey != null) {
                localVarHeaderParameter['X-Platform-Key'] = String(xPlatformKey);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * UserOrdersApi - functional programming interface
 * @export
 */
export const UserOrdersApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserOrdersApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary [User] get paginated result of orders
         * @param {string} xPlatformKey Select the platform.
         * @param {number} [offSet]
         * @param {number} [pageSize]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersGet(xPlatformKey, offSet, pageSize, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersGet(xPlatformKey, offSet, pageSize, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [User] Returns a boolean indicating whether framing for an order can be started
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdCanBeFramedGet(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersOrderIdCanBeFramedGet(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [User] Claims a (free) order, marking it as \"paid\" so it can be picked up by operations.
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdClaimPatch(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersOrderIdClaimPatch(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [User] User does not want to frame product, so continue with the processing of order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersOrderIdFramingWindowDelete(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersOrderIdFramingWindowDelete(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [User] Fetches or creates a framing session for the specified order
         * @param {string} orderId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersOrderIdFramingsessionPost(orderId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersOrderIdFramingsessionPost(orderId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary [User] get the pdf url of an order\'s invoice
         * @param {string} orderId
         * @param {string} xPlatformKey Select the platform.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersOrderIdInvoicePdfGet(orderId, xPlatformKey, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.ordersOrderIdInvoicePdfGet(orderId, xPlatformKey, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * UserOrdersApi - factory interface
 * @export
 */
export const UserOrdersApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserOrdersApiFp(configuration);
    return {
        /**
         *
         * @summary [User] get paginated result of orders
         * @param {UserOrdersApiOrdersGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersGet(requestParameters, options) {
            return localVarFp.ordersGet(requestParameters.xPlatformKey, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [User] Returns a boolean indicating whether framing for an order can be started
         * @param {UserOrdersApiOrdersOrderIdCanBeFramedGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdCanBeFramedGet(requestParameters, options) {
            return localVarFp.ordersOrderIdCanBeFramedGet(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [User] Claims a (free) order, marking it as \"paid\" so it can be picked up by operations.
         * @param {UserOrdersApiOrdersOrderIdClaimPatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ordersOrderIdClaimPatch(requestParameters, options) {
            return localVarFp.ordersOrderIdClaimPatch(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [User] User does not want to frame product, so continue with the processing of order
         * @param {UserOrdersApiOrdersOrderIdFramingWindowDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersOrderIdFramingWindowDelete(requestParameters, options) {
            return localVarFp.ordersOrderIdFramingWindowDelete(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [User] Fetches or creates a framing session for the specified order
         * @param {UserOrdersApiOrdersOrderIdFramingsessionPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersOrderIdFramingsessionPost(requestParameters, options) {
            return localVarFp.ordersOrderIdFramingsessionPost(requestParameters.orderId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary [User] get the pdf url of an order\'s invoice
         * @param {UserOrdersApiOrdersOrderIdInvoicePdfGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        ordersOrderIdInvoicePdfGet(requestParameters, options) {
            return localVarFp.ordersOrderIdInvoicePdfGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserOrdersApi - object-oriented interface
 * @export
 * @class UserOrdersApi
 * @extends {BaseAPI}
 */
export class UserOrdersApi extends BaseAPI {
    /**
     *
     * @summary [User] get paginated result of orders
     * @param {UserOrdersApiOrdersGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserOrdersApi
     */
    ordersGet(requestParameters, options) {
        return UserOrdersApiFp(this.configuration).ordersGet(requestParameters.xPlatformKey, requestParameters.offSet, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [User] Returns a boolean indicating whether framing for an order can be started
     * @param {UserOrdersApiOrdersOrderIdCanBeFramedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserOrdersApi
     */
    ordersOrderIdCanBeFramedGet(requestParameters, options) {
        return UserOrdersApiFp(this.configuration).ordersOrderIdCanBeFramedGet(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [User] Claims a (free) order, marking it as \"paid\" so it can be picked up by operations.
     * @param {UserOrdersApiOrdersOrderIdClaimPatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserOrdersApi
     */
    ordersOrderIdClaimPatch(requestParameters, options) {
        return UserOrdersApiFp(this.configuration).ordersOrderIdClaimPatch(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [User] User does not want to frame product, so continue with the processing of order
     * @param {UserOrdersApiOrdersOrderIdFramingWindowDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UserOrdersApi
     */
    ordersOrderIdFramingWindowDelete(requestParameters, options) {
        return UserOrdersApiFp(this.configuration).ordersOrderIdFramingWindowDelete(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [User] Fetches or creates a framing session for the specified order
     * @param {UserOrdersApiOrdersOrderIdFramingsessionPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UserOrdersApi
     */
    ordersOrderIdFramingsessionPost(requestParameters, options) {
        return UserOrdersApiFp(this.configuration).ordersOrderIdFramingsessionPost(requestParameters.orderId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary [User] get the pdf url of an order\'s invoice
     * @param {UserOrdersApiOrdersOrderIdInvoicePdfGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof UserOrdersApi
     */
    ordersOrderIdInvoicePdfGet(requestParameters, options) {
        return UserOrdersApiFp(this.configuration).ordersOrderIdInvoicePdfGet(requestParameters.orderId, requestParameters.xPlatformKey, options).then((request) => request(this.axios, this.basePath));
    }
}
